import e, { createContext as t, forwardRef as n, isValidElement as r, useCallback as i, useContext as a, useEffect as o, useImperativeHandle as s, useLayoutEffect as c, useMemo as l, useRef as u, useState as d } from "react";
import { Resizable as f } from "re-resizable";
import { Alert as p, AutoComplete as m, Button as h, Card as g, Col as _, Collapse as v, ColorPicker as y, ConfigProvider as b, Divider as x, Dropdown as S, Empty as C, Input as w, InputNumber as T, Modal as E, Popover as D, Radio as O, Row as k, Segmented as A, Select as j, Slider as ee, Space as M, Switch as te, Tabs as ne, Tag as re, Tooltip as N, TreeSelect as ie, message as ae } from "antd";
import { ApartmentOutlined as oe, AppstoreAddOutlined as se, BorderOutlined as ce, CloseCircleOutlined as le, CloseOutlined as ue, CompressOutlined as de, CopyOutlined as fe, DatabaseOutlined as pe, DeleteOutlined as me, DesktopOutlined as he, DoubleRightOutlined as ge, EyeInvisibleOutlined as _e, EyeOutlined as ve, FullscreenExitOutlined as ye, FullscreenOutlined as be, HolderOutlined as xe, InfoCircleOutlined as Se, LaptopOutlined as Ce, MinusCircleOutlined as we, MinusOutlined as Te, MobileOutlined as Ee, PlusOutlined as De, PushpinOutlined as Oe, QuestionCircleOutlined as ke, ReloadOutlined as Ae, RightOutlined as je, SearchOutlined as Me, SwapOutlined as Ne, ZoomInOutlined as Pe, ZoomOutOutlined as Fe } from "@ant-design/icons";
import P from "clsx";
import Ie from "mitt";
import { AssignValueType as Le, CNodePropsTypeEnum as Re, CPage as ze, DEFAULT_EVENT_LIST as Be, DEV_CONFIG_KEY as Ve, EmptyPage as He, HTMl_TAGS as Ue, InnerComponentNameEnum as We, LogicType as F, SetterTypeEnum as Ge, findContainerNode as Ke, getMTitle as qe, getMTitleTip as Je, getRandomStr as I, isExpression as Ye, isFunction as Xe, isJSSlotPropNode as Ze, isNodeModel as Qe, isPageModel as $e, isSpecialMaterialPropType as et, traversePageNode as tt } from "@chamn/model";
import nt from "color";
import { capitalize as rt, cloneDeep as it, debounce as at, isEmpty as ot, isEqual as st, isNil as ct, isPlainObject as lt, omitBy as ut, pick as dt } from "lodash-es";
import * as ft from "css-tree";
import { AssetLoader as pt, ON_DID_RENDER as mt, ON_WILL_DESTROY as ht, collectVariable as gt, flatObject as _t, getThirdLibs as vt } from "@chamn/render";
import { consola as yt } from "consola";
import { createPortal as bt } from "react-dom";
import { Fragment as L, jsx as R, jsxs as z } from "react/jsx-runtime";
import xt, { loader as St } from "@monaco-editor/react";
import Ct from "antd/locale/en_US";
import wt from "antd/locale/zh_CN";
import Tt from "i18next";
import { initReactI18next as Et, useTranslation as Dt, withTranslation as Ot } from "react-i18next";
import { Layout as kt, LayoutMode as At, Sensor as jt, addEventListenerReturnCancel as Mt } from "@chamn/layout";
import "@chamn/layout/dist/style.css";
import { Background as Nt, Controls as Pt, Handle as Ft, MiniMap as It, Position as Lt, ReactFlow as Rt, ReactFlowProvider as zt, addEdge as Bt, useEdgesState as Vt, useNodesState as Ht, useReactFlow as Ut } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import Wt from "@dagrejs/dagre";
import { CSS as Gt } from "@dnd-kit/utilities";
import { DndContext as Kt, KeyboardSensor as qt, PointerSensor as Jt, useDraggable as Yt, useSensor as Xt, useSensors as Zt } from "@dnd-kit/core";
import { SortableContext as Qt, arrayMove as $t, sortableKeyboardCoordinates as en, useSortable as tn } from "@dnd-kit/sortable";
import { restrictToVerticalAxis as nn } from "@dnd-kit/modifiers";
import { InputData as rn, jsonInputForTargetLanguage as an, quicktype as on } from "quicktype-core";
import { SketchPicker as sn } from "react-color";
import { AlignHorizontalDistributeEnd as cn, AlignHorizontalDistributeStart as ln, AlignHorizontalSpaceAround as un, AlignHorizontalSpaceBetween as dn, AlignVerticalJustifyEnd as fn, AlignVerticalJustifyStart as pn, AlignVerticalSpaceAround as mn, AlignVerticalSpaceBetween as hn, ArrowDownFromLine as gn, ArrowLeftFromLine as _n, ArrowRightFromLine as vn, ArrowUpFromLine as yn, Component as bn, MoveHorizontal as xn, MoveVertical as Sn, SquareCode as Cn, SquareX as wn, StretchHorizontal as Tn, StretchVertical as En } from "lucide-react";
import Dn from "antd/es/tag/CheckableTag";
export * from "@chamn/layout";
//#region \0rolldown/runtime.js
var On = Object.defineProperty, kn = (e, t) => {
	let n = {};
	for (var r in e) On(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || On(n, Symbol.toStringTag, { value: "Module" }), n;
}, B = {
	workbenchContainer: "_workbenchContainer_bdawd_2",
	topToolBarBox: "_topToolBarBox_bdawd_12",
	topToolBarView: "_topToolBarView_bdawd_18",
	bodyContent: "_bodyContent_bdawd_21",
	leftBox: "_leftBox_bdawd_27",
	pluginIconBar: "_pluginIconBar_bdawd_34",
	pluginIconItem: "_pluginIconItem_bdawd_39",
	active: "_active_bdawd_49",
	pluginPanelBoxResizeBox: "_pluginPanelBoxResizeBox_bdawd_65",
	pluginHeader: "_pluginHeader_bdawd_72",
	pluginNameText: "_pluginNameText_bdawd_80",
	closeBtn: "_closeBtn_bdawd_87",
	fixedBtn: "_fixedBtn_bdawd_88",
	pluginPanelBox: "_pluginPanelBox_bdawd_65",
	leftBoxFloating: "_leftBoxFloating_bdawd_104",
	hiddenLeftPanel: "_hiddenLeftPanel_bdawd_107",
	rightResizeBox: "_rightResizeBox_bdawd_110",
	arrowCursor: "_arrowCursor_bdawd_114",
	rightBox: "_rightBox_bdawd_129",
	hiddenRightPanel: "_hiddenRightPanel_bdawd_136",
	centerBox: "_centerBox_bdawd_140",
	subTopToolbarBox: "_subTopToolbarBox_bdawd_149",
	canvasBox: "_canvasBox_bdawd_154",
	scrollBox: "_scrollBox_bdawd_161",
	canvasBoxPadding: "_canvasBoxPadding_bdawd_165",
	customViewBox: "_customViewBox_bdawd_169"
}, An = [
	{
		key: "MODERN_PC",
		label: "Modern PC",
		width: 1920
	},
	{
		key: "PC",
		label: "PC",
		width: 1200
	},
	{
		key: "IPAD",
		label: "Tablet",
		width: 768
	},
	{
		key: "MOBILE",
		label: "Mobile",
		width: 350
	}
], jn = (e) => {
	let t = e?.filter(({ key: e, label: t, width: n }) => !!(e && t) && Number.isFinite(n) && n > 0);
	return t?.length ? t : An;
}, Mn = (e, t) => [...jn(t)].sort((e, t) => e.width - t.width).find(({ width: t }) => e <= t), Nn = (e) => {
	let t = {};
	return e.forEach((e) => {
		t[e.property] = e.value;
	}), t;
}, Pn = (e = {}) => Object.keys(e).reduce((t, n) => [...t, {
	property: n,
	value: e[n]
}], []), Fn = (e) => {
	let t = "";
	return e.forEach((e) => {
		t += `${e.property}:${e.value};`;
	}), t;
}, In = (e, t) => {
	let n = Bn(e);
	return Object.entries(t).forEach(([e, t]) => {
		let r = n.find((t) => t.property === e);
		r ? r.value = t : n.push({
			id: I(),
			property: e,
			value: t
		});
	}), Fn(n);
}, Ln = (e, t) => {
	let n = Bn(e), r = new Set(["width", "height"].filter((e) => n.find((t) => t.property === e)?.value.trim().toLowerCase() === "100%"));
	return In(e, Object.fromEntries(Object.entries(t).filter(([e]) => !r.has(e))));
}, Rn = (e, { width: t, height: n, viewportWidth: r }, i) => {
	let a = {
		width: `${Math.max(1, Math.round(t))}px`,
		height: `${Math.max(1, Math.round(n))}px`
	}, o = e.value.css || { value: [] }, s = o.value.findIndex((e) => e.state === "normal"), c = s < 0 ? {
		state: "normal",
		media: [],
		text: ""
	} : o.value[s], l = Mn(r, i), u = l ? [l] : [], d = !!(l && ["PC", "MODERN_PC"].includes(l.key)), f = (t) => {
		e.updateValue({ css: {
			...o,
			value: s < 0 ? [...o.value, t] : o.value.map((e, n) => n === s ? t : e)
		} });
	};
	if (u.length) {
		let e = [...c.media || []];
		u.forEach((t) => {
			let n = e.findIndex((e) => e.type === "max-width" && Number.parseFloat(e.value || "") === t.width), r = n < 0 ? {
				type: "max-width",
				value: `${t.width}`,
				text: In("", a)
			} : {
				...e[n],
				text: In(e[n].text || "", a)
			};
			n < 0 ? e.push(r) : e[n] = r;
		}), e.sort((e, t) => Number.parseFloat(t.value || "") - Number.parseFloat(e.value || "")), f({
			...c,
			text: d ? Ln(c.text || "", a) : c.text,
			media: e
		});
		return;
	}
	f({
		...c,
		text: In(c.text || "", a)
	});
}, zn = (e = []) => {
	lt(e) && (e = Object.keys(e).map((t) => ({
		property: t,
		value: e[t]
	})));
	let t = [], n = [], r = [];
	return e.forEach((e) => {
		let i = e.value, a = {
			property: e.property,
			value: i
		};
		r.push(a), Ye(i) ? n.push({
			...a,
			value: i
		}) : t.push({
			...a,
			value: i
		});
	}), {
		normalProperty: t,
		expressionProperty: n,
		allProperty: r
	};
}, Bn = (e) => {
	let t = ft.parse(`.node {${e}}`), n = [];
	return ft.walk(t, function(e) {
		e.type === "Declaration" && n.push({
			id: I(),
			property: e.property,
			value: ft.generate(e.value)
		});
	}), n;
}, Vn = (e, t) => {
	let n = {
		class: e,
		value: []
	}, r = [];
	return Object.keys(t).forEach((e) => {
		let n = t[e], i = {
			state: e,
			media: [],
			text: n?.normal || ""
		};
		Object.keys(n || {}).forEach((e) => {
			i.media = i.media || [], e !== "normal" && i.media.push({
				type: "max-width",
				value: e,
				text: n?.[e] || ""
			});
		}), r.push(i);
	}), n.value = r, n;
}, Hn = (e) => {
	if (!e) return {};
	let t = e.value, n = {};
	return t.forEach((e) => {
		let t = e.style;
		!e.text && t && (e.text = Object.keys(t).reduce((e, n) => (e += `${n}: ${t[n]};`, e), ""));
		let r = { normal: e.text || "" };
		e.media?.forEach((e) => {
			r[e.value] = e.text || "";
		}), n[e.state] = r;
	}), n;
}, Un = (e) => {
	let t = /#(?:[0-9a-fA-F]{3}){1,2}\b/g, n = /rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*(?:\d*\.\d+|\d+\.\d*|\d+)\s*\)/g, r = /rgb?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/g, i = /hsb?\(\s*\d+\s*,\s*\d+%\s*,\s*\d+%\s*\)/g, a = e.match(t) || [], o = e.match(n) || [], s = e.match(r) || [], c = e.match(i) || [];
	return [
		...a,
		...o,
		...s,
		...c
	];
}, Wn = (e) => {
	let t = Un(e), n = t.reduce((e, t) => (e[t] = nt(t).hexa(), e), {}), r = e;
	return t.forEach((e) => {
		r = r.replaceAll(e, n[e]);
	}), r.split(",").map((e) => {
		let t = {
			offsetX: void 0,
			offsetY: void 0,
			blur: void 0,
			spread: void 0,
			color: void 0,
			type: void 0
		}, n = e;
		n.includes("inset") && (t.type = "inset", n = n.replace("inset", "").trim());
		let r = Un(n);
		r.length && (t.color = r[0], n = n.replace(t.color, "").trim());
		let i = n.split(" "), a = [];
		for (let e = 0; e < i.length && !isNaN(parseInt(i[e])); e++) a.push(i[e]);
		return t.offsetX = a[0], t.offsetY = a[1], t.blur = a[2] || "", t.spread = a[3] || "", t.color ||= i[a.length], t;
	});
}, Gn = class {
	_assets;
	constructor(e) {
		this._assets = e;
	}
	getList() {
		return this._assets;
	}
	setList(e) {
		let t = Kn([...e, ...this._assets]);
		this._assets = t;
	}
}, Kn = (e) => {
	let t = [], n = {};
	return e.forEach((e) => {
		n[e.package] || (n[e.package] = e, t.push(e));
	}), t;
}, qn = async ({ iframe: e }) => {
	let t = e.getWindow();
	t && (t.React = window.React, t.ReactDOM = window.ReactDOM, t.ReactDOMClient = window.ReactDOMClient);
}, Jn = (e) => async ({ iframe: t, assets: n, page: r, pageModel: i, ready: a, renderJSUrl: o, dropPlaceholder: s }) => {
	await t.injectJS(o || "");
	let c = t.getWindow(), l = t.getDocument(), u = c.React, d = c.ReactDOMClient, f = c.CRender, p = r || i?.export();
	if (!p) {
		console.log("page schema is empty");
		return;
	}
	let m = Kn([...n, ...p.assets || []]);
	new f.AssetLoader(m, { window: t.getWindow() }).onSuccess(() => {
		let t = gt(m, c), n = _t(t), o = vt(t, p.thirdLibs || []), h = u?.createElement(f.DesignRender, {
			adapter: f?.ReactAdapter,
			page: r,
			pageModel: i,
			components: {
				...n,
				...e.components || {}
			},
			$$context: { thirdLibs: o },
			dropPlaceholder: s,
			onMount: (e) => {
				a(e);
			},
			...e?.renderProps || {}
		});
		d.createRoot(l.getElementById("app")).render(h);
	}).onError(() => {
		console.log("资源加载出错");
	}).load();
}, V = yt.create({ level: 1 }), Yn = [
	"title",
	"nodeName",
	"configure"
], Xn = (e) => typeof e.componentName == "string" && ("children" in e || "props" in e), Zn = (e) => Array.isArray(e) ? e.map(Zn) : lt(e) ? Xn(e) ? Qn(e) : Object.keys(e).reduce((t, n) => (t[n] = Zn(e[n]), t), {}) : e, Qn = (e) => {
	let t = { ...e };
	return Yn.forEach((e) => {
		delete t[e];
	}), Array.isArray(t.children) && (t.children = t.children.map((e) => lt(e) ? Qn(e) : e)), lt(t.props) && (t.props = Object.keys(t.props).reduce((e, n) => (e[n] = Zn(t.props[n]), e), {})), t;
}, $n = (e) => {
	let t = e instanceof ze ? e.export("save") : it(e);
	return {
		...t,
		componentsTree: Qn(t.componentsTree)
	};
}, H = ({ time: e = 1e3 / 60, cb: t } = {}) => new Promise((n) => {
	setTimeout(() => {
		n("ok"), t?.();
	}, e);
}), er = (e, t, n) => {
	e[t] === void 0 && (e[t] = n);
}, tr = function(e, t) {
	try {
		return JSON.parse(e);
	} catch {
		return t ?? null;
	}
}, nr = class extends e.Component {
	state = { hasError: !1 };
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidCatch(e, t) {
		console.error(`Plugin ${this.props.area} render failed`, e, t);
	}
	render() {
		return this.state.hasError ? /* @__PURE__ */ R("div", {
			style: {
				padding: 12,
				color: "#999",
				fontSize: 12
			},
			children: "Plugin view failed to render."
		}) : this.props.children;
	}
}, rr = class extends e.Component {
	emitter;
	leftPanelContentRef;
	constructor(t) {
		super(t), this.emitter = t.emitter || Ie(), this.leftPanelContentRef = e.createRef(), this.state = {
			leftBoxVisible: !0,
			leftBoxSize: {
				width: 300,
				height: "100%"
			},
			leftBoxFixed: !0,
			rightBoxVisible: !0,
			rightBoxSize: {
				width: 350,
				height: "100%"
			},
			currentActiveLeftPanel: "ComponentLib",
			leftPanels: [],
			bodyView: null,
			rightView: null,
			topToolBarView: null,
			subTopToolBarView: null,
			customViewList: [],
			hiddenTopBar: t.hiddenTopBar ?? !1,
			hiddenLeftPanel: t.hiddenLeftPanel ?? !1,
			hiddenRightPanel: t.hiddenRightPanel ?? !1,
			canvasFull: t.canvasFull ?? !1
		};
	}
	getHiddenWidgetConfig() {
		return {
			hiddenTopBar: this.state.hiddenTopBar,
			hiddenLeftPanel: this.state.hiddenLeftPanel,
			hiddenRightPanel: this.state.hiddenRightPanel
		};
	}
	hiddenWidget(e) {
		this.setState({ ...e || {} });
	}
	addLeftPanel = (e) => {
		this.state.leftPanels.push(e), this.setState({ leftPanels: [...this.state.leftPanels] });
	};
	replaceLeftPanel = (e, t) => {
		let n = this.state.leftPanels.findIndex((t) => t.name === e);
		if (n > -1) {
			let e = [...this.state.leftPanels];
			e[n] = t, this.setState({ leftPanels: e });
		}
	};
	addCustomView(e) {
		let t = this.state.customViewList;
		return t.push(e), this.setState({ customViewList: [...t] }), () => {
			let t = this.state.customViewList.filter((t) => t !== e);
			this.setState({ customViewList: [...t] });
		};
	}
	openLeftPanel = async (e) => {
		let t = e || this.state.currentActiveLeftPanel;
		this.setState({
			leftBoxVisible: !0,
			leftBoxSize: {
				width: 350,
				height: "100%"
			},
			currentActiveLeftPanel: t
		}), await H(), this.emitter.emit("leftPanelVisible", {
			visible: !0,
			panelName: t
		});
	};
	closeLeftPanel = async () => {
		this.setState({
			leftBoxVisible: !1,
			leftBoxSize: {
				width: 0,
				height: "100%"
			}
		}), await H(), this.emitter.emit("leftPanelVisible", {
			visible: !1,
			panelName: this.state.currentActiveLeftPanel
		});
	};
	toggleLeftPanel = () => {
		let { leftBoxVisible: e } = this.state;
		e ? this.closeLeftPanel() : this.openLeftPanel();
	};
	onPluginIconClick = (e) => {
		let { currentActiveLeftPanel: t } = this.state;
		t === e.name && this.state.leftBoxVisible ? this.closeLeftPanel() : this.openLeftPanel(e.name);
	};
	openRightPanel = () => {
		let { rightBoxSize: e } = this.state;
		this.setState({
			rightBoxVisible: !0,
			rightBoxSize: {
				width: 400,
				height: e.height
			}
		});
	};
	closeRightPanel = () => {
		let { rightBoxSize: e } = this.state;
		this.setState({
			rightBoxVisible: !1,
			rightBoxSize: {
				width: 0,
				height: e.height
			}
		});
	};
	replaceBodyView = (e) => {
		this.setState({ bodyView: e });
	};
	replaceRightView = (e) => {
		this.setState({ rightView: e });
	};
	replaceTopBarView = (e) => {
		this.setState({ topToolBarView: e });
	};
	replaceSubTopBarView = (e) => {
		this.setState({ subTopToolBarView: e });
	};
	toggleRightPanel = () => {
		let { rightBoxVisible: e, rightBoxSize: t } = this.state, n = !e;
		this.setState({
			rightBoxVisible: n,
			rightBoxSize: {
				width: n ? 400 : 0,
				height: t.height
			}
		});
	};
	onLeftBoxResizeStop = (e, t, n, r) => {
		let i = this.state.leftBoxSize.width + r.width;
		this.setState({ leftBoxSize: {
			width: i,
			height: this.state.leftBoxSize.height
		} });
	};
	onGlobalClick = (e) => {
		e.target && this.leftPanelContentRef.current?.contains(e.target) || !this.state.leftBoxFixed && this.state.leftBoxVisible && this.closeLeftPanel();
	};
	componentDidMount() {
		document.addEventListener("click", this.onGlobalClick);
	}
	render() {
		let { leftBoxVisible: e, leftBoxSize: t, leftBoxFixed: n, rightBoxSize: r, rightBoxVisible: i, leftPanels: a, currentActiveLeftPanel: o, bodyView: s, rightView: c, topToolBarView: l, subTopToolBarView: u, customViewList: d, hiddenTopBar: p, hiddenLeftPanel: m, hiddenRightPanel: g } = this.state, _ = {};
		n || (_.position = "absolute", _.left = "50px", _.top = 0);
		let v = a.find((e) => e.name === o), y = v?.render || null, { onPluginIconClick: b, toggleRightPanel: x, toggleLeftPanel: S, onLeftBoxResizeStop: C } = this;
		return /* @__PURE__ */ z("div", {
			className: B.workbenchContainer,
			children: [
				!p && /* @__PURE__ */ R("div", {
					className: B.topToolBarBox,
					children: /* @__PURE__ */ R("div", {
						className: B.topToolBarView,
						children: /* @__PURE__ */ R(nr, {
							area: "top toolbar",
							children: l
						})
					})
				}),
				/* @__PURE__ */ z("div", {
					className: B.bodyContent,
					children: [
						!m && /* @__PURE__ */ z("div", {
							className: P([
								B.leftBox,
								m ?? B.hiddenLeftPanel,
								e && !n && B.leftBoxFloating
							]),
							ref: this.leftPanelContentRef,
							children: [/* @__PURE__ */ R("div", {
								className: B.pluginIconBar,
								children: a.map((e) => /* @__PURE__ */ R("div", {
									onClick: (t) => {
										t.stopPropagation(), b(e);
									},
									className: P([B.pluginIconItem, v?.name === e.name && B.active]),
									children: /* @__PURE__ */ R(nr, {
										area: `${e.name} icon`,
										children: e.icon
									})
								}, e.name))
							}), e && /* @__PURE__ */ z(f, {
								className: B.pluginPanelBoxResizeBox,
								size: t,
								style: _,
								minWidth: 300,
								maxWidth: 600,
								enable: { right: e },
								onResizeStop: C,
								children: [/* @__PURE__ */ z("div", {
									className: B.pluginHeader,
									children: [
										/* @__PURE__ */ R("span", {
											className: B.pluginNameText,
											children: /* @__PURE__ */ R(nr, {
												area: `${v?.name || "left panel"} header`,
												children: v?.title || v?.name
											})
										}),
										/* @__PURE__ */ R(h, {
											className: P([B.fixedBtn]),
											type: "text",
											size: "small",
											onClick: (e) => {
												e.stopPropagation(), this.setState((e) => ({ leftBoxFixed: !e.leftBoxFixed }));
											},
											children: /* @__PURE__ */ R(Oe, { className: P([n && B.active]) })
										}),
										/* @__PURE__ */ R(h, {
											className: B.closeBtn,
											type: "text",
											size: "small",
											onClick: S,
											children: /* @__PURE__ */ R(ue, {})
										})
									]
								}), /* @__PURE__ */ R("div", {
									className: B.pluginPanelBox,
									children: /* @__PURE__ */ R(nr, {
										area: v?.name || "left panel",
										children: y
									})
								})]
							})]
						}),
						/* @__PURE__ */ z("div", {
							className: B.centerBox,
							children: [u && /* @__PURE__ */ R("div", {
								className: B.subTopToolbarBox,
								children: /* @__PURE__ */ R(nr, {
									area: "sub top toolbar",
									children: u
								})
							}), /* @__PURE__ */ R("div", {
								className: P([B.canvasBox, this.state.canvasFull !== !0 && B.canvasBoxPadding]),
								children: /* @__PURE__ */ R("div", {
									className: B.scrollBox,
									children: /* @__PURE__ */ R(nr, {
										area: "body",
										children: s
									})
								})
							})]
						}),
						/* @__PURE__ */ z("div", {
							className: P([B.rightResizeBox, g && B.hiddenRightPanel]),
							children: [/* @__PURE__ */ R("div", {
								className: B.arrowCursor,
								onClick: x,
								children: /* @__PURE__ */ R(ge, { className: P([!i && B.active]) })
							}), /* @__PURE__ */ R("div", {
								style: {
									display: i ? "block" : "none",
									height: "100%"
								},
								children: /* @__PURE__ */ R(f, {
									minWidth: 400,
									maxWidth: 600,
									enable: { left: i },
									size: r,
									onResizeStop: (e, t, n, r) => {
										this.setState({ rightBoxSize: {
											width: this.state.rightBoxSize.width + r.width,
											height: this.state.rightBoxSize.height
										} });
									},
									children: /* @__PURE__ */ R("div", {
										className: B.rightBox,
										children: /* @__PURE__ */ R(nr, {
											area: "right panel",
											children: c
										})
									})
								})
							})]
						})
					]
				}),
				bt(/* @__PURE__ */ R("div", {
					className: B.customViewBox,
					children: d.map((e) => /* @__PURE__ */ R("div", {
						style: {
							pointerEvents: "auto",
							display: "inline-block"
						},
						children: /* @__PURE__ */ R(nr, {
							area: `custom view: ${e.key}`,
							children: e.view
						})
					}, e.key))
				}), document.body)
			]
		});
	}
}, ir = { engineContainer: "_engineContainer_1h15w_2" }, ar = {
	"Welcome to React": "Welcome to React",
	"style.dimension.mediaOverride": "Setting width or height disables the corresponding media dimension",
	"style.dimension.widthMediaOverride": "Setting width disables width in media styles",
	"style.dimension.heightMediaOverride": "Setting height disables height in media styles",
	afterMount: "After render",
	beforeDestroy: "Before destroy",
	selectEvent: "Select event",
	add: "Add",
	组件库: "Components",
	大纲树: "Outline Tree",
	全局状态: "Global State",
	快捷键: "Hotkeys",
	属性: "Properties",
	属性名: "Property name",
	值: "Value",
	内置组件: "Built-in components",
	原子组件: "Basic components",
	块: "Block",
	文本: "Text",
	容器: "Container",
	图片: "Image",
	地址: "URL",
	视频: "Video",
	音频: "Audio",
	自动播放: "Autoplay",
	控制面板: "Controls",
	内容: "Content",
	渲染之后: "After render",
	销毁之前: "Before destroy",
	画布: "Canvas",
	"HTML 标签": "HTML tag",
	标签名: "Tag name",
	布局: "Layout",
	类名: "Class name",
	启用: "Enabled",
	初始化完成后: "After initialization",
	组件销毁之前: "Before component destroy",
	选择节点: "Select node",
	请求成功时: "On request success",
	请求异常时: "On request failure",
	请求方法: "Request method",
	返回值变量: "Response variable",
	返回值变量名: "Response variable name",
	组件: "Component",
	方法: "Method",
	参数: "Parameters",
	请求数据: "Request data",
	调用组件方法: "Call component method",
	运行代码: "Run code",
	"赋值/创建变量": "Assign / create variable",
	页面跳转: "Navigate",
	表达式: "Expression",
	逻辑流设置器: "Action flow setter",
	颜色设置器: "Color setter",
	长文本设置器: "Long text setter",
	选择设置器: "Select setter",
	空值设置器: "Empty value setter",
	滑动条设置器: "Slider setter",
	数组设置器: "Array setter",
	数字设置器: "Number setter",
	对象设置器: "Object setter",
	字符设置器: "String setter",
	单选设置器: "Radio group setter",
	函数设置器: "Function setter",
	"JSON 设置器": "JSON setter",
	CSS值设置器: "CSS value setter",
	"CSS size 设置器": "CSS size setter",
	"Bool 设置器": "Boolean setter",
	该节点不能删除: "This node cannot be deleted",
	不允许存在一个节点连接多个节点: "A node cannot connect to multiple nodes",
	资源加载出错: "Failed to load resource",
	"变量名必须以字母（a-z、A-Z）、下划线（_）或美元符号（$）开头。后续字符可以是字母、数字（0-9）、下划线或美元符号。变量名不能是保留关键字（例如 if、while 等）": "Variable names must start with a letter, underscore, or dollar sign. Remaining characters may be letters, numbers, underscores, or dollar signs. Reserved keywords such as if and while are not allowed."
}, or = {
	"style.dimension.mediaOverride": "设置 width 或 height 后，media 中对应的尺寸设置将不会生效",
	"style.dimension.widthMediaOverride": "设置 width 后，media 中的 width 设置将不会生效",
	"style.dimension.heightMediaOverride": "设置 height 后，media 中的 height 设置将不会生效",
	afterMount: "AfterMount",
	beforeDestroy: "BeforeDestroy",
	selectEvent: "选择事件",
	add: "添加"
}, sr = "zh_CN", cr = ["zh_CN", "en_US"], lr = {
	zh_CN: { translation: or },
	en_US: { translation: ar }
};
function ur(e) {
	if (!e) return sr;
	let t = e.replace("-", "_");
	return cr.includes(t) ? t : sr;
}
function dr(e) {
	e && Object.entries(e).forEach(([e, t]) => {
		Object.entries(t).forEach(([t, n]) => {
			Tt.addResourceBundle(ur(e), t, n, !0, !0);
		});
	});
}
Tt.use(Et).init({
	resources: lr,
	lng: sr,
	fallbackLng: sr,
	supportedLngs: cr,
	interpolation: { escapeValue: !1 },
	react: {
		bindI18n: "added languageChanged",
		bindI18nStore: "added"
	}
});
var fr = Tt;
fr.update = () => {
	setTimeout(() => {
		Tt.emit("added");
	}, 0);
};
function pr(e) {
	return fr.changeLanguage(ur(e));
}
//#endregion
//#region src/core/pluginManager.ts
var mr = class {
	plugins = /* @__PURE__ */ new Map();
	emitter = Ie();
	getWorkbench;
	pageModel;
	i18n;
	assetsPackageListManager;
	engine;
	customPluginHooks = {};
	constructor({ getWorkbench: e, emitter: t, pageModel: n, i18n: r, assetsPackageListManager: i, engine: a }) {
		this.getWorkbench = e, this.emitter = t, this.pageModel = n, this.i18n = r, this.assetsPackageListManager = i, this.engine = a;
	}
	customPlugin = (e, t) => {
		let n = this.customPluginHooks, r = n[e] || [];
		r.push(t), n[e] = r, this.customPluginHooks = n;
	};
	createPluginCtx = () => ({
		globalEmitter: this.emitter,
		emitter: Ie(),
		config: {},
		getWorkbench: this.getWorkbench,
		pluginManager: this,
		pageModel: this.pageModel,
		i18n: this.i18n,
		assetsPackageListManager: this.assetsPackageListManager,
		engine: this.engine,
		pluginReadyOk: () => {}
	});
	async add(e) {
		let t = this.createPluginCtx(), n;
		n = typeof e == "function" ? e(t) : e, t.meta = n.meta;
		let r = {
			source: n,
			ctx: t,
			export: n.export?.(t) || {},
			ready: !1
		};
		(this.customPluginHooks[n.name] || []).forEach((e) => {
			r = e(r);
		}), t.pluginReadyOk = () => {
			this.emitter.emit(`${n.name}:ready`), r.ready = !0;
		}, this.plugins.set(n.name, r);
		try {
			await n.init(t);
		} catch (e) {
			console.error(`Plugin ${n.name} initialization failed`, e), t.pluginReadyOk();
		}
	}
	async get(e) {
		let t = this.plugins.get(e);
		return t?.ready || await this.onPluginReadyOk(e), t;
	}
	async remove(e) {
		let t = this.plugins.get(e);
		await t?.source.destroy(t.ctx), this.plugins.delete(e);
	}
	onPluginReadyOk(e, t) {
		return new Promise((n) => {
			let r = this.plugins.get(e);
			r?.ready ? n(r) : r === void 0 && console.warn(`plugin: ${e} not found.`), this.emitter.on(`${e}:ready`, () => {
				let r = this.plugins.get(e);
				r && (r.ready = !0, t?.(r), n(r));
			});
		});
	}
}, hr = {
	zh_CN: or,
	en_US: ar
}, gr = Object.fromEntries(Object.entries(ar).map(([e, t]) => [t, e]));
function _r(e, t) {
	if (t === "zh_CN") return gr[e] ?? e;
	let n = e.match(/^元素-(\d+)$/);
	return n ? `Item-${n[1]}` : hr.en_US[e] ?? e;
}
//#endregion
//#region src/i18n/I18nTextBridge.tsx
var vr = [
	"title",
	"placeholder",
	"aria-label"
];
function yr(e) {
	let t = e.parentElement;
	return !t || t.closest("script, style, input, textarea, [contenteditable=\"true\"]") !== null;
}
function br(e, t) {
	if (yr(e)) return;
	let n = e.nodeValue;
	if (!n) return;
	let r = n.match(/^\s*/)?.[0] ?? "", i = n.match(/\s*$/)?.[0] ?? "", a = n.slice(r.length, n.length - i.length), o = _r(a, t);
	o !== a && (e.nodeValue = `${r}${o}${i}`);
}
function xr(e, t) {
	vr.forEach((n) => {
		let r = e.getAttribute(n);
		if (!r) return;
		let i = _r(r, t);
		i !== r && e.setAttribute(n, i);
	}), e.childNodes.forEach((e) => {
		e.nodeType === Node.TEXT_NODE ? br(e, t) : e.nodeType === Node.ELEMENT_NODE && xr(e, t);
	});
}
function Sr({ children: e, language: t }) {
	let n = u(null);
	return o(() => {
		let e = n.current;
		if (!e) return;
		xr(e, t);
		let r = new MutationObserver((e) => {
			e.forEach((e) => {
				if (e.type === "characterData") {
					br(e.target, t);
					return;
				}
				if (e.type === "attributes") {
					xr(e.target, t);
					return;
				}
				e.addedNodes.forEach((e) => {
					e.nodeType === Node.TEXT_NODE ? br(e, t) : e.nodeType === Node.ELEMENT_NODE && xr(e, t);
				});
			});
		});
		return r.observe(e, {
			attributes: !0,
			attributeFilter: [...vr],
			characterData: !0,
			childList: !0,
			subtree: !0
		}), () => r.disconnect();
	}, [t]), /* @__PURE__ */ R("div", {
		ref: n,
		style: {
			width: "100%",
			height: "100%"
		},
		children: e
	});
}
//#endregion
//#region src/plugins/ComponentLibrary/localize/index.ts
var Cr = {
	zh_CN: { pluginName: "组件库" },
	en_US: { pluginName: "Components" }
}, wr = {
	container: "_container_1ftoc_2",
	header: "_header_1ftoc_8",
	tabTitle: "_tabTitle_1ftoc_25",
	searchInput: "_searchInput_1ftoc_41",
	notFoundComponent: "_notFoundComponent_1ftoc_46"
}, Tr = {
	square: "_square_chjh2_2",
	componentItem: "_componentItem_chjh2_18",
	iconImg: "_iconImg_chjh2_41",
	iconBox: "_iconBox_chjh2_45",
	componentName: "_componentName_chjh2_54",
	iconText: "_iconText_chjh2_64"
}, Er = "data-drag-key", Dr = ({ id: e, children: t, className: n, style: r }) => /* @__PURE__ */ R("div", {
	[Er]: e,
	className: n,
	style: r,
	children: t
}), Or = (e) => {
	let t = u(null), [n, r] = d(!1), i = l(() => e.iconText ? /* @__PURE__ */ R("div", {
		className: Tr.iconText,
		children: String(e.iconText).toUpperCase()
	}) : typeof e.icon == "string" ? /* @__PURE__ */ R("img", {
		className: Tr.iconImg,
		src: e.icon,
		draggable: !1
	}) : e.icon, [e.icon, e.iconText]);
	c(() => {
		let e = t.current;
		if (!e) return;
		let n = () => {
			r(e.scrollWidth > e.clientWidth);
		};
		n();
		let i = typeof ResizeObserver > "u" ? null : new ResizeObserver(n);
		return i?.observe(e), () => i?.disconnect();
	}, [e.name]);
	let a = /* @__PURE__ */ R("span", {
		ref: t,
		className: Tr.componentName,
		children: e.name
	}), o = /* @__PURE__ */ R("div", {
		className: P([Tr.square, e.containerClassName]),
		children: /* @__PURE__ */ z(Dr, {
			id: e.id,
			className: Tr.componentItem,
			style: e.style,
			children: [/* @__PURE__ */ R("div", {
				className: Tr.iconBox,
				children: i
			}), n ? /* @__PURE__ */ R(N, {
				title: e.name,
				placement: "top",
				children: a
			}) : a]
		})
	});
	return e.description ? /* @__PURE__ */ R(D, {
		overlayInnerStyle: {
			maxWidth: "300px",
			maxHeight: "200px",
			overflow: "auto"
		},
		content: e.description || "",
		zIndex: 1e3,
		placement: "right",
		children: o
	}) : o;
}, kr = {
	ListBox: "_ListBox_1f8b8_2",
	collapsePanel: "_collapsePanel_1f8b8_24"
}, Ar = (t) => {
	let { dataSource: n, renderItem: r } = t, i = n.map((e) => e.name || ""), a = l(() => n.map((t) => {
		let n = t.name || "";
		return {
			key: n,
			label: n,
			children: /* @__PURE__ */ R("div", {
				className: kr.collapsePanel,
				children: t.list.map((t) => {
					let n = /* @__PURE__ */ R(Or, {
						id: t.id,
						name: t.title,
						icon: t.snapshot || t.snapshotText,
						iconText: t.snapshotText,
						description: t.description || ""
					}, t.id), i = r ? r({
						item: t,
						defaultView: n,
						DragComponent: Dr
					}) : n;
					return /* @__PURE__ */ R(e.Fragment, { children: i }, t.id);
				})
			})
		};
	}), [n, r]);
	return n.length ? /* @__PURE__ */ R("div", {
		className: kr.ListBox,
		children: /* @__PURE__ */ R(v, {
			style: { width: "100%" },
			defaultActiveKey: i,
			items: a
		})
	}) : null;
}, jr = (e, t) => e ? e.getAttribute(t) || jr(e.parentElement, t) : null, Mr = (e, t) => {
	let n = [], r = t?.toLowerCase();
	return e.forEach((e) => {
		[...e.list].forEach((e) => {
			let t = e.list.filter((e) => {
				let t = !1;
				return typeof e.description == "string" && (t = e.description?.includes(r)), t ||= e.title?.toLowerCase().includes(r), t ||= e.snapshotText?.toLowerCase().includes(r), t ||= e.category?.toLowerCase().includes(r), t;
			});
			t.length && n.push({
				name: e.name,
				list: t
			});
		});
	}), n;
}, Nr = "ComponentLib", Pr = `plugin:${Nr}`, Fr = ({ children: e }) => /* @__PURE__ */ R("div", {
	className: wr.tabTitle,
	children: e
}), Ir = class extends e.Component {
	containerRef;
	disposeList = [];
	boxSensor;
	constructor(t) {
		super(t), this.containerRef = e.createRef(), this.state = {
			componentsList: [],
			searchString: "",
			searchMode: !1,
			searchResultList: []
		};
	}
	leftPanelVisibleCb = async ({ visible: e, panelName: t }) => {
		await this.props.pluginCtx.pluginManager.onPluginReadyOk("Designer"), t === "ComponentLib" && e && this.registerDragEvent();
	};
	updateComponentsList() {
		let { pluginCtx: e } = this.props, { pageModel: t } = e, { materialsModel: n } = t, r = n.getAllSnippets();
		if (r.length && r[0].name === "default") {
			let e = r.shift();
			e && r.push(e);
		}
		this.setState({ componentsList: r });
	}
	async componentDidMount() {
		await this.props.pluginCtx.pluginManager.onPluginReadyOk("Designer"), this.registerDragEvent();
		let { pluginCtx: e } = this.props, { i18n: t } = e;
		Object.keys(Cr).forEach((e) => {
			t.addResourceBundle(e, Pr, Cr[e], !0, !0);
		}), t.update(), this.updateComponentsList(), e.globalEmitter.on("updateMaterials", () => {
			this.updateComponentsList();
		});
	}
	componentWillUnmount() {
		this.disposeList.map((e) => e());
	}
	getNewNode = (e) => {
		let { pluginCtx: t } = this.props, n = t.pageModel;
		if (!e) return;
		let r = jr(e, Er);
		if (!r) return;
		let i = n.materialsModel.findSnippetById(r);
		if (i) return n?.createNode(i.schema);
	};
	registerDragEvent = async () => {
		let { containerRef: e } = this, { pluginCtx: t } = this.props, n = await t.pluginManager.get("Designer");
		if (!n || !e.current) return;
		let r = n.export.getDnd(), i = new jt({
			name: "ComponentListBox",
			container: e.current,
			mainDocument: document
		});
		this.boxSensor = i, i.setCanDrag(async (e) => {
			let t = this.getNewNode(e.event.target);
			return this.props.pluginCtx.pluginManager.get("Designer").then((e) => {
				(e?.export)?.selectNode("");
			}), {
				...e,
				extraData: {
					dropType: "NEW_ADD",
					dragNode: t
				}
			};
		}), r.registerSensor(i);
		let a = () => {
			let { getWorkbench: e } = this.props.pluginCtx, t = e();
			t.state.leftBoxFixed || t.closeLeftPanel();
		};
		this.disposeList.push(() => {
			r.emitter.off("dragStart", a);
		}), r.emitter.on("dragStart", a);
	};
	toAddNewNode = async (e) => {
		let t = this.getNewNode(e.nativeEvent.target);
		if (!t) return;
		let { pageModel: n } = this.props.pluginCtx;
		return this.props.pluginCtx.pluginManager.get("Designer").then(async (r) => {
			let i = r?.export, a = i?.getSelectedNodeId(), o = n.getNode(a), s = Ke(o), c = "CHILD_END", l = o ?? null;
			if (o) s === o.parent ? o.isContainer() ? (c = "CHILD_END", l = o) : (c = "AFTER", l = o) : s && !$e(s) && (c = "CHILD_END", l = s);
			else {
				let e = n.getRootNode();
				e && (c = "CHILD_END", l = e);
			}
			let u = await (i?.getInstance())?.customAdvanceHook.onNewAdd({
				dragNode: t,
				dropNode: l,
				eventObj: {
					from: e.nativeEvent,
					fromSensor: this.boxSensor,
					pointer: null,
					fromPointer: null,
					extraData: {}
				}
			});
			if (u === !1) return;
			let d = {
				dragNode: t,
				dropNode: l,
				pos: c
			};
			typeof u == "object" && (d = {
				...d,
				dragNode: u.addNode ?? d.dragNode,
				dropNode: u.dropNode ?? d.dropNode,
				pos: u.dropPosInfo?.pos ?? d.pos
			}), n.addNode(d.dragNode, d.dropNode, d.pos), setTimeout(() => {
				i?.selectNode(d.dragNode.id);
			}, 16);
		});
	};
	onSearch = () => {
		if (!this.state.searchString.length) {
			this.setState({
				searchResultList: [],
				searchMode: !1
			});
			return;
		}
		let e = Mr(this.state.componentsList, this.state.searchString);
		this.setState({
			searchResultList: e,
			searchMode: !0
		});
	};
	renderItem = (e) => {
		let t = this.props.pluginCtx.config.customItemRender;
		return t ? t({
			...e,
			...this.getRenderContext()
		}) : e.defaultView;
	};
	renderList = (e) => /* @__PURE__ */ R(Ar, {
		dataSource: e,
		renderItem: this.renderItem
	});
	getRenderContext = () => ({
		materials: this.state.componentsList,
		searchString: this.state.searchString,
		searchMode: this.state.searchMode,
		searchResults: this.state.searchResultList
	});
	renderSearchView = () => {
		let { searchResultList: e } = this.state;
		return /* @__PURE__ */ z("div", { children: [!e.length && /* @__PURE__ */ R("div", {
			className: wr.notFoundComponent,
			children: "暂无相关组件"
		}), /* @__PURE__ */ R(Ar, {
			dataSource: e,
			renderItem: this.renderItem
		})] });
	};
	render() {
		let { componentsList: e, searchString: t } = this.state, { toAddNewNode: n } = this, r = this.props.pluginCtx.config.customSearchBar, i = e.map((e) => ({
			label: /* @__PURE__ */ R(Fr, { children: rt(e.name) }),
			key: e.name,
			children: this.renderList(e.list)
		})), a = /* @__PURE__ */ R(w, {
			className: wr.searchInput,
			value: t,
			placeholder: "input search text",
			suffix: /* @__PURE__ */ R(Me, { style: { color: "rgba(0,0,0,.25)" } }),
			onPressEnter: this.onSearch,
			allowClear: !0,
			onClear: () => {
				this.setState({
					searchMode: !1,
					searchResultList: []
				});
			},
			onChange: (e) => {
				this.setState({ searchString: e.target.value });
			}
		});
		return /* @__PURE__ */ z("div", {
			ref: this.containerRef,
			className: wr.container,
			onClick: n,
			children: [/* @__PURE__ */ R("div", {
				className: wr.header,
				children: r ? /* @__PURE__ */ R(r, {
					defaultInputView: a,
					updateState: this.setState.bind(this)
				}) : a
			}), this.renderTabs(i)]
		});
	}
	renderTabs = (e) => {
		let t = this.state.searchMode ? this.renderSearchView() : /* @__PURE__ */ R(ne, {
			defaultActiveKey: "BaseComponent",
			items: e,
			style: { width: "100%" }
		}), n = this.props.pluginCtx.config.customTabsRender;
		return n ? n({
			...this.getRenderContext(),
			defaultView: t,
			renderList: this.renderList,
			DragComponent: Dr
		}) : t;
	};
}, Lr = {
	name: Nr,
	PLUGIN_NAME: Nr,
	async init(e) {
		let t = Ot(Pr)(Ir), n = Ot(Pr)(({ t: e }) => /* @__PURE__ */ R(L, { children: e("pluginName") }));
		e.getWorkbench().addLeftPanel({
			title: /* @__PURE__ */ R(n, {}),
			name: "ComponentLib",
			icon: /* @__PURE__ */ R(se, {}),
			render: /* @__PURE__ */ R(t, { pluginCtx: e })
		}), e.pluginReadyOk();
	},
	reload: async () => {
		console.log(Nr, "not suooprt reload");
	},
	async destroy(e) {
		console.log("destroy", e);
	},
	export: () => ({}),
	meta: { engine: { version: "1.0.0" } }
};
Lr.PLUGIN_NAME = Nr;
//#endregion
//#region src/plugins/Designer/config.ts
var Rr = "Designer", zr = {
	zh_CN: { pluginName: "组件库" },
	en_US: { pluginName: "Designer Canvas" }
}, U = {
	toolBarBox: "_toolBarBox_1hr3z_2",
	item: "_item_1hr3z_16",
	layoutSelectBox: "_layoutSelectBox_1hr3z_38",
	hoverBox: "_hoverBox_1hr3z_43",
	hoverBoxActive: "_hoverBoxActive_1hr3z_53",
	hoverItem: "_hoverItem_1hr3z_57",
	placeholder: "_placeholder_1hr3z_69"
}, Br = (e) => /* @__PURE__ */ R(xt, {
	height: "100%",
	width: "100%",
	defaultLanguage: e.language,
	defaultValue: e.initialValue,
	beforeMount: (t) => {
		e.beforeMount?.(t);
	},
	onMount: (t) => {
		e.onDidMount?.(t);
	},
	options: e.options,
	theme: e.theme,
	onChange: e.onChange
}), Vr = ({ node: e }) => {
	let [t, n] = d(!1);
	if (!e) return null;
	let r = JSON.stringify(e.export("save"), null, 2);
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R("div", {
		className: U.item,
		onClick: () => n(!0),
		title: "View node schema",
		children: /* @__PURE__ */ R(Se, {})
	}), /* @__PURE__ */ R(E, {
		open: t,
		title: `${e.value.title || e.material?.value.title || e.value.componentName || "Node"} Schema`,
		width: "100%",
		onCancel: () => n(!1),
		footer: /* @__PURE__ */ R(h, {
			icon: /* @__PURE__ */ R(fe, {}),
			onClick: async () => {
				try {
					await navigator.clipboard.writeText(r), ae.success("Schema copied");
				} catch {
					ae.error("Failed to copy schema");
				}
			},
			children: "Copy"
		}),
		style: {
			height: "calc(100vh - 50px)",
			top: "25px"
		},
		destroyOnHidden: !0,
		children: /* @__PURE__ */ R("div", {
			style: {
				width: "100%",
				height: "calc(100vh - 200px)"
			},
			children: /* @__PURE__ */ R(Br, {
				initialValue: r,
				language: "json",
				options: {
					automaticLayout: !0,
					readOnly: !0
				}
			})
		})
	})] });
}, Hr = ({ dataSource: e, children: t, onSelect: n }) => {
	let [r, i] = d(!1);
	return /* @__PURE__ */ z("div", {
		className: U.layoutSelectBox,
		children: [/* @__PURE__ */ R("div", {
			className: P([U.hoverBox, r && U.hoverBoxActive]),
			children: e.map((e) => /* @__PURE__ */ R("div", {
				className: U.hoverItem,
				onClick: () => n(e.key),
				children: e.label
			}, e.key))
		}), /* @__PURE__ */ R("div", {
			className: U.placeholder,
			onMouseOver: () => i(!0),
			onMouseOut: () => i(!1),
			children: t
		})]
	});
}, Ur = (e) => {
	let { nodeList: t, toSelectNode: n, toDelete: r, toCopy: i, toHidden: a } = e, o = [...t], s = o.shift(), c = o.map((e) => {
		let t = e, n = t.materialsModel.findByComponentName(t.value.componentName)?.value.title, r = t.value.title || n || t.value.componentName || "";
		return {
			key: e.id,
			label: r || "Empty"
		};
	}), l = /* @__PURE__ */ R("div", {
		className: U.item,
		onClick: () => i(s?.id || ""),
		children: /* @__PURE__ */ R(fe, {})
	}, "CopyOutlined"), u = /* @__PURE__ */ R("div", {
		className: U.item,
		onClick: () => r(s?.id || ""),
		children: /* @__PURE__ */ R(me, {})
	}, "DeleteOutlined"), d = /* @__PURE__ */ R("div", {
		className: U.item,
		onClick: () => a(s?.id || ""),
		children: /* @__PURE__ */ R(_e, {})
	}, "EyeInvisibleOutlined"), f = /* @__PURE__ */ R(Vr, { node: s }, "NodeSchemaOutlined"), p = /* @__PURE__ */ R(Hr, {
		dataSource: c.reverse(),
		onSelect: n,
		children: /* @__PURE__ */ R("div", { children: s?.value.title || s?.material?.value.title || "Empty" })
	}, "LayoutSelect");
	return {
		map: {
			copyItem: l,
			deleteItem: u,
			visibleItem: d,
			nodeLayout: p,
			nodeSchemaItem: f
		},
		list: [
			f,
			p,
			d,
			l,
			u
		]
	};
}, Wr = (e) => {
	let { copyItem: t, deleteItem: n, visibleItem: r, nodeLayout: i, nodeSchemaItem: a } = l(() => Ur(e).map, [e]);
	return /* @__PURE__ */ z("div", {
		className: U.toolBarBox,
		children: [
			a,
			i,
			r,
			t,
			n
		]
	});
}, Gr = (e, t = 5) => {
	let n = [], r = 0, i = e;
	for (; r < t && i;) Qe(i) && (n.push(i), r++), i = i.parent || null;
	return n;
}, W = {
	canvasRoot: "_canvasRoot_1tz7m_2",
	layoutWrapper: "_layoutWrapper_1tz7m_11",
	hoverTips: "_hoverTips_1tz7m_16",
	ghostView: "_ghostView_1tz7m_27",
	ghostLabel: "_ghostLabel_1tz7m_46",
	quickAddBox: "_quickAddBox_1tz7m_51",
	quickAddButton: "_quickAddButton_1tz7m_57",
	vertical: "_vertical_1tz7m_72",
	before: "_before_1tz7m_72",
	after: "_after_1tz7m_78",
	horizontal: "_horizontal_1tz7m_84",
	inside: "_inside_1tz7m_96",
	quickAddList: "_quickAddList_1tz7m_116",
	quickAddItem: "_quickAddItem_1tz7m_141",
	quickAddName: "_quickAddName_1tz7m_172",
	quickAddTitle: "_quickAddTitle_1tz7m_182"
}, Kr = ({ node: e }) => {
	let t = e.value.title || e.material?.value.title || e.value.componentName;
	return /* @__PURE__ */ R("div", {
		className: W.ghostView,
		role: "presentation",
		children: /* @__PURE__ */ R("span", {
			className: W.ghostLabel,
			children: t
		})
	});
}, qr = class {
	getPortalViewCtx;
	ctx;
	layoutRef;
	constructor(e) {
		this.getPortalViewCtx = e.getPortalViewCtx, this.ctx = e.ctx, this.layoutRef = e.layoutRef;
	}
	async canDrag({ dragNode: e, eventObj: t }) {
		let n = e?.material?.value.advanceCustom;
		return !n?.canDragNode || n?.canDragNode(e, {
			context: this.ctx,
			viewPortal: this.getPortalViewCtx(),
			event: t,
			extra: t.extraData
		});
	}
	async canDrop({ dragNode: e, dropNode: t, eventObj: n }) {
		let r = e?.material?.value.advanceCustom, i = t.material?.value.advanceCustom, a = {}, o = {
			dropNode: t,
			context: this.ctx,
			viewPortal: this.getPortalViewCtx(),
			event: n,
			extra: n.extraData
		};
		if (r?.canDropNode) {
			if (a = await r.canDropNode(e, o), i?.canAcceptNode) {
				let t;
				return t = typeof a == "object" ? await i?.canAcceptNode(a.dragNode, {
					...o,
					...a
				}) : await i?.canAcceptNode(e, { ...o }), t;
			}
			return a;
		}
		return !i?.canAcceptNode || await i?.canAcceptNode(e, { ...o });
	}
	async onNewAdd({ dragNode: e, dropNode: t, eventObj: n }) {
		let r = await e.material?.value.advanceCustom?.onNewAdd?.(e, {
			dropNode: t,
			context: this.ctx,
			viewPortal: this.getPortalViewCtx(),
			event: n,
			extra: n.extraData
		});
		return r !== !1 && r;
	}
	getSelectRectViewRender(e) {
		return e.material?.value.advanceCustom?.selectRectViewRender;
	}
	getHoverRectViewRender(e) {
		return e ? e.material?.value.advanceCustom?.hoverRectViewRender : null;
	}
	getDropViewRender(e) {
		return e ? e.material?.value.advanceCustom?.dropViewRender : null;
	}
	getGhostViewRender(e) {
		return e ? e.material?.value.advanceCustom?.ghostViewRender : null;
	}
	getToolbarViewRender(e) {
		return e ? e.material?.value.advanceCustom?.toolbarViewRender : null;
	}
	async onCopy(e) {
		let t = e, n = this.ctx, r = e.material?.value.advanceCustom?.onCopy;
		if (r) {
			let i = await r(e, {
				viewPortal: this.getPortalViewCtx(),
				context: n,
				extra: {}
			});
			if (i === !1) return !1;
			typeof i == "object" && (t = i.copyNode ?? t);
		}
		return t && n.pageModel.copyNode(t) && await H(), t;
	}
	async onDelete(e) {
		let t = e, n = this.ctx, r = e.material?.value.advanceCustom?.onDelete;
		if (r) {
			let i = await r(e, {
				viewPortal: this.getPortalViewCtx(),
				context: n,
				extra: {}
			});
			if (i === !1) return !1;
			typeof i == "object" && (t = i.deleteNode ?? t);
		}
		return t && n.pageModel.deleteNode(t) && await H(), t;
	}
}, Jr = {
	toolbar: "_toolbar_479bv_2",
	viewportControl: "_viewportControl_479bv_10",
	canvasStatus: "_canvasStatus_479bv_11",
	zoomControl: "_zoomControl_479bv_18",
	sectionLabel: "_sectionLabel_479bv_48"
}, Yr = 25, Xr = 200, Zr = 10, Qr = (e) => Math.min(Xr, Math.max(Yr, e)), $r = (e) => {
	let t = u(), n = jn(e.ctx.engine.props.responsiveSizes), [r, a] = d("AUTO"), [s, c] = d({
		width: n.find(({ key: e }) => e === "PC")?.width ?? n[0].width,
		height: 0
	}), l = (e) => ({
		width: e?.innerWidth ?? 0,
		height: e?.innerHeight ?? 0
	}), f = i(() => {
		let e = t.current;
		c(l(e?.export.getDesignerWindow()));
	}, []), p = i((e) => {
		let n = Qr(e);
		t.current?.export.setCanvasScale(n / 100);
	}, []), m = i(() => {
		t.current?.export.reload();
	}, []), g = i(() => {
		t.current?.export.fitCanvasToViewport();
	}, []);
	o(() => {
		let n, r;
		return e.ctx.pluginManager.onPluginReadyOk("Designer").then((e) => {
			t.current = e, r = e.export.getDesignerWindow(), n = f, r?.addEventListener("resize", n), f();
		}), () => {
			n && r?.removeEventListener("resize", n);
		};
	}, []), o(() => {
		let t = (t) => {
			if (!(t.metaKey || t.ctrlKey) || t.altKey) return;
			let n = t.target;
			n?.isContentEditable || [
				"INPUT",
				"TEXTAREA",
				"SELECT"
			].includes(n?.tagName || "") || ([
				"+",
				"=",
				"Add"
			].includes(t.key) ? (t.preventDefault(), p(e.zoom + Zr)) : [
				"-",
				"_",
				"Subtract"
			].includes(t.key) ? (t.preventDefault(), p(e.zoom - Zr)) : t.key === "0" && (t.preventDefault(), p(100)));
		};
		return window.addEventListener("keydown", t), () => window.removeEventListener("keydown", t);
	}, [e.zoom, p]), o(() => {
		let e = (e) => {
			e.target?.closest("button, input, textarea, select, [role=\"button\"], .ant-segmented") || p(100);
		};
		return window.addEventListener("dblclick", e), () => window.removeEventListener("dblclick", e);
	}, [p]);
	let _ = i(at((e) => {
		t.current?.export.setCanvasWidth(e), window.setTimeout(() => {
			t.current?.export.fitCanvasToViewport(), f();
		}, 0);
	}, 100), [f]), v = (e) => {
		let r = t.current;
		if (r) {
			if (e === "AUTO") r.export.setCanvasWidth("100%"), window.setTimeout(() => {
				r.export.fitCanvasToViewport(), f();
			}, 0);
			else {
				let t = n.find(({ key: t }) => t === e);
				t && (r.export.setCanvasWidth(t.width), window.setTimeout(() => {
					r.export.fitCanvasToViewport(), f();
				}, 0));
			}
			a(String(e));
		}
	};
	return /* @__PURE__ */ z("div", {
		className: Jr.toolbar,
		children: [
			/* @__PURE__ */ z("div", {
				className: Jr.viewportControl,
				children: [/* @__PURE__ */ R("span", {
					className: Jr.sectionLabel,
					children: "Viewport"
				}), /* @__PURE__ */ R(A, {
					value: r,
					onChange: v,
					options: [{
						label: /* @__PURE__ */ R(N, {
							title: `Render size: ${s.width}px × ${s.height}px`,
							children: /* @__PURE__ */ z("span", { children: [/* @__PURE__ */ R("span", {
								onClick: () => v("AUTO"),
								children: "Auto"
							}), r === "AUTO" && /* @__PURE__ */ R(T, {
								size: "small",
								style: { marginLeft: "10px" },
								controls: !1,
								changeOnWheel: !0,
								suffix: "px",
								value: s.width,
								min: Math.min(...n.map(({ width: e }) => e)),
								max: Math.max(...n.map(({ width: e }) => e)),
								onChange: (e) => {
									c((t) => ({
										...t,
										width: Number(e)
									})), _(Number(e));
								}
							})] })
						}),
						value: "AUTO"
					}, ...n.map(({ key: e, label: t, width: n }) => ({
						label: /* @__PURE__ */ R(N, {
							title: `${t}: ${n}px`,
							children: /* @__PURE__ */ R("span", { children: R(e === "PC" ? Ce : e === "IPAD" ? ce : e === "MOBILE" ? Ee : he, {}) })
						}),
						value: e
					}))]
				})]
			}),
			/* @__PURE__ */ z("div", {
				className: Jr.zoomControl,
				children: [
					/* @__PURE__ */ R(N, {
						title: "Zoom out (Ctrl/Cmd -)",
						children: /* @__PURE__ */ R(h, {
							size: "small",
							type: "text",
							icon: /* @__PURE__ */ R(Fe, {}),
							onClick: () => p(e.zoom - Zr)
						})
					}),
					/* @__PURE__ */ R(N, {
						title: "Set zoom percentage",
						children: /* @__PURE__ */ R(T, {
							size: "small",
							controls: !1,
							min: Yr,
							max: Xr,
							suffix: "%",
							value: e.zoom,
							onChange: (e) => p(Number(e))
						})
					}),
					/* @__PURE__ */ R(N, {
						title: "Zoom in (Ctrl/Cmd +)",
						children: /* @__PURE__ */ R(h, {
							size: "small",
							type: "text",
							icon: /* @__PURE__ */ R(Pe, {}),
							onClick: () => p(e.zoom + Zr)
						})
					}),
					/* @__PURE__ */ R(x, { type: "vertical" }),
					/* @__PURE__ */ R(N, {
						title: "Reset zoom (Ctrl/Cmd 0 or double-click anywhere)",
						children: /* @__PURE__ */ R(h, {
							size: "small",
							type: "text",
							icon: /* @__PURE__ */ R(de, {}),
							onClick: () => p(100)
						})
					}),
					/* @__PURE__ */ R(N, {
						title: "Fit canvas to visible area",
						children: /* @__PURE__ */ R(h, {
							size: "small",
							type: "text",
							icon: /* @__PURE__ */ R(be, {}),
							onClick: g
						})
					}),
					/* @__PURE__ */ R(x, { type: "vertical" }),
					/* @__PURE__ */ R(N, {
						title: "Refresh canvas",
						children: /* @__PURE__ */ R(h, {
							size: "small",
							type: "text",
							icon: /* @__PURE__ */ R(Ae, {}),
							onClick: m
						})
					})
				]
			}),
			/* @__PURE__ */ R(N, {
				title: "Canvas viewport size and zoom",
				children: /* @__PURE__ */ R("div", {
					className: Jr.canvasStatus,
					children: /* @__PURE__ */ R(re, {
						bordered: !1,
						children: `${s.width} × ${s.height}`
					})
				})
			})
		]
	});
}, ei = ({ instance: e, direction: t, insideBoundary: n, getMaterials: r, onAdd: i }) => {
	let a = e._NODE_MODEL, [s, c] = d(null), u = l(() => r(a), [r, a]);
	return o(() => {
		c(null);
	}, [e, a]), o(() => {
		if (s === null) return;
		let t = window.setTimeout(() => {
			let t = e.getDom();
			(!t || !t.isConnected) && c(null);
		}, 2e3), n = (e) => {
			let t = e.target;
			t instanceof Element && (t.closest(`.${W.quickAddList}`) || c(null));
		}, r = () => c(null), i = e.getDom()?.ownerDocument;
		return document.addEventListener("pointerdown", n), i?.addEventListener("click", r, !0), () => {
			window.clearTimeout(t), document.removeEventListener("pointerdown", n), i?.removeEventListener("click", r, !0);
		};
	}, [e, s]), /* @__PURE__ */ R("div", {
		className: `${W.quickAddBox} ${W[t]}`,
		children: ["before", "after"].map((e) => /* @__PURE__ */ R(D, {
			open: s === e,
			onOpenChange: (t) => c(t ? e : null),
			trigger: "click",
			placement: t === "vertical" ? e === "before" ? "top" : "bottom" : e === "before" ? "left" : "right",
			overlayInnerStyle: { padding: 0 },
			content: /* @__PURE__ */ R("div", {
				className: W.quickAddList,
				children: u.map((t) => /* @__PURE__ */ z("button", {
					className: W.quickAddItem,
					type: "button",
					onClick: () => {
						i(a, t, e === "before" ? "BEFORE" : "AFTER"), c(null);
					},
					children: [/* @__PURE__ */ R("span", {
						className: W.quickAddName,
						children: (t.schema.componentName || t.title).toUpperCase()
					}), /* @__PURE__ */ R("span", {
						className: W.quickAddTitle,
						children: t.title
					})]
				}, t.id || t.title))
			}),
			children: /* @__PURE__ */ R("button", {
				type: "button",
				className: `${W.quickAddButton} ${W[e]} ${n?.[e] ? W.inside : ""}`,
				"aria-label": `Add ${e}`,
				onClick: () => c(e),
				children: /* @__PURE__ */ R(De, {})
			})
		}, e))
	});
}, ti = class extends e.Component {
	layoutRef;
	customAdvanceHook;
	pageRuntimeListeners = /* @__PURE__ */ new Set();
	quickAddPositionFrame = null;
	removeQuickAddPositionListeners = null;
	constructor(t) {
		super(t), this.state = {
			pageModel: t.pluginCtx.pageModel,
			canvasScale: 1,
			canvasFooterView: null,
			hoverToolbarView: null,
			selectToolbarView: null,
			ghostView: null,
			portalView: null,
			quickAddNode: null,
			selectRectViewRender: null,
			hoverRectViewRender: null,
			dropViewRender: null
		}, this.layoutRef = e.createRef(), this.customAdvanceHook = new qr({
			getPortalViewCtx: this.getPortalViewCtx,
			ctx: this.props.pluginCtx,
			layoutRef: this.layoutRef
		});
	}
	getPortalViewCtx = () => ({
		setView: (e) => {
			this.setState({ portalView: e });
		},
		clearView: () => {
			this.setState({ portalView: null });
		}
	});
	async updateRenderComponents(e = {}) {
		let t = {
			...this.props.pluginCtx.config.components || {},
			...e
		};
		this.props.pluginCtx.config.components = t;
		let { layoutRef: n } = this;
		if (!n.current) {
			console.warn("layout not ready ok");
			return;
		}
		await n.current.ready(), n.current?.designRenderRef?.current?.updateComponents(t);
	}
	componentDidMount() {
		let { i18n: e } = this.props.pluginCtx;
		Object.keys(zr).forEach((t) => {
			e.addResourceBundle(t, `plugin:${Rr}`, zr[t], !0, !0);
		}), this.init();
	}
	componentWillUnmount() {
		this.removeQuickAddPositionListeners?.(), this.quickAddPositionFrame !== null && cancelAnimationFrame(this.quickAddPositionFrame);
	}
	bindQuickAddPositionListeners = () => {
		this.removeQuickAddPositionListeners?.();
		let e = this.layoutRef.current?.iframeContainer.iframe?.contentDocument, t = () => {
			this.quickAddPositionFrame === null && (this.quickAddPositionFrame = requestAnimationFrame(() => {
				this.quickAddPositionFrame = null, this.state.quickAddNode && this.forceUpdate();
			}));
		}, n = [window];
		e && n.push(e), n.forEach((e) => e.addEventListener("scroll", t, !0)), window.addEventListener("resize", t), this.removeQuickAddPositionListeners = () => {
			n.forEach((e) => e.removeEventListener("scroll", t, !0)), window.removeEventListener("resize", t);
		};
	};
	getIframeDom() {
		return this.layoutRef.current?.iframeContainer;
	}
	reloadRender() {
		this.layoutRef.current?.reload(), this.props.pluginCtx.pageModel.reloadPage();
	}
	setCanvasFooterView = (e) => {
		this.setState({ canvasFooterView: e });
	};
	subscribePageRuntime = (e) => (this.pageRuntimeListeners.add(e), e(this.getIframeDom()?.getWindow() || null), () => {
		this.pageRuntimeListeners.delete(e);
	});
	onPageRuntimeReady = (e) => {
		this.pageRuntimeListeners.forEach((t) => t(e));
	};
	async init() {
		let { layoutRef: e } = this, { pluginCtx: t } = this.props;
		if (!e.current) {
			console.warn("layout not ready ok");
			return;
		}
		await e.current.ready();
		let n = e.current;
		this.bindQuickAddPositionListeners(), t.emitter.emit("ready", { UIInstance: this }), n.dnd.emitter.on("click", ({ event: e }) => {
			t.getWorkbench().onGlobalClick(e);
		}), this.props.pluginCtx.pageModel.emitter.on("onPageChange", ({ node: t }) => {
			e.current?.designRenderRef?.current?.rerender(t);
		}), this.props.pluginCtx.pageModel.emitter.on("onReloadPage", ({ node: t }) => {
			e.current?.designRenderRef?.current?.rerender(t);
		}), t.pluginReadyOk();
	}
	onNodeDragging = async (e) => {
		let t = e.extraData, n = t?.dragNode;
		if (n) return n.material?.value.advanceCustom?.onDragging?.(n, {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: e,
			extra: t
		});
	};
	onNodeDragEnd = async () => {
		this.setState({
			...this.state,
			dropViewRender: this.props.pluginCtx.config.dropViewRender
		});
	};
	onNodeDrop = async (e) => {
		let { layoutRef: t } = this, n = this.props.pluginCtx.pageModel, r = e.extraData, i = {
			before: "BEFORE",
			after: "AFTER",
			current: "CHILD_START"
		}[r?.dropPosInfo?.pos || "after"], a = r?.dragNode;
		if (a && await a.material?.value.advanceCustom?.onDrop?.(a, {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: e,
			extra: r
		}) === !1) return !1;
		if (!r?.dropNode) return console.warn("cancel drop, because drop node is null"), !1;
		if (r.dropType === "NEW_ADD") {
			if (a && await a.material?.value.advanceCustom?.onNewAdd?.(a, {
				dropNode: r.dropNode,
				context: this.props.pluginCtx,
				viewPortal: this.getPortalViewCtx(),
				event: e,
				extra: r
			}) === !1) return !1;
			r.dropNode?.nodeType === "NODE" ? n?.addNode(r.dragNode, r.dropNode, i) : n?.addNode(r.dragNode, r.dropNode, "CHILD_START");
		} else {
			if (r.dropNode?.id === r.dragNode?.id) return console.warn("dragNode and dropNode id is the same"), !1;
			if (!n.moveNodeById(r.dragNode?.id || "", r?.dropNode?.id || "", i)) return console.warn("drop failed"), !1;
		}
		return this.props.pluginCtx.emitter.emit("onDrop", e), new Promise((e) => {
			setTimeout(async () => {
				if (a && await this.onSelectNode(a, null) === !1) return t.current?.selectNode(""), e(!1);
				t.current?.selectNode(r.dragNode?.id || ""), e(!0);
			}, 16);
		});
	};
	onSelectNode = async (e, t) => {
		let { pluginCtx: n } = this.props, { layoutRef: r } = this;
		if (!e) return n.engine.updateCurrentSelectNode(null), r.current?.selectNode(""), this.setState({
			selectToolbarView: null,
			quickAddNode: null
		}), !1;
		let i = await e.material?.value.advanceCustom?.onSelect?.(e, {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: t,
			extra: {}
		});
		if (i === !1) return i;
		let a = this.getToolbarView(e);
		return this.setState({
			selectToolbarView: a,
			quickAddNode: e,
			selectRectViewRender: this.customAdvanceHook.getSelectRectViewRender(e) || this.props.pluginCtx.config.selectRectViewRender
		}), setTimeout(() => {
			n.engine.updateCurrentSelectNode(e);
		}, 16.66), !0;
	};
	onDragStart = async (e) => {
		let t = e.extraData, n = t?.dragNode;
		if (!n) return !1;
		let r = {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: e,
			extra: t
		}, i = await n.material?.value.advanceCustom?.canDragNode?.(n, {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: e,
			extra: {}
		});
		if (i === !1) return i;
		let a = await n.material?.value.advanceCustom?.onDragStart?.(n, { ...r });
		if (a === !1) return a;
		let o = this.getGhostView(n, r);
		return this.setState({
			...this.state,
			ghostView: o,
			dropViewRender: this.customAdvanceHook.getDropViewRender(n) || this.props.pluginCtx.config.dropViewRender
		}), !0;
	};
	getGhostView = (e, t) => {
		let n = /* @__PURE__ */ R(Kr, { node: e }), r = this.customAdvanceHook.getGhostViewRender(e) || this.props.pluginCtx.config.ghostViewRender;
		return r && (n = /* @__PURE__ */ R(r, {
			node: e,
			params: t
		})), n;
	};
	toSelectNode = async (e) => {
		let t = this.props.pluginCtx.pageModel.getNode(e);
		return await this.onSelectNode(t || null, null) !== !1 && (this.layoutRef.current?.selectNode(e), !0);
	};
	toCopyNode = async (e) => {
		let t = this.props.pluginCtx.pageModel.getNode(e), n = await this.customAdvanceHook.onCopy(t);
		if (n) return this.toSelectNode(n.id), !0;
	};
	toDeleteNode = async (e) => {
		let t = this.props.pluginCtx.pageModel.getNode(e);
		if (t) return await this.customAdvanceHook.onDelete(t) !== !1 && (this.toSelectNode(""), !0);
	};
	toHidden = (e) => {
		let t = this.props.pluginCtx.pageModel.getNode(e);
		if (!t) return;
		let n = t.value.configure.devState ?? {};
		return n.condition = !1, t.value.configure.devState = n, t.updateValue(), !0;
	};
	getToolbarView = (e) => {
		let t = {
			nodeList: Gr(e, 5),
			toSelectNode: this.toSelectNode,
			toCopy: this.toCopyNode,
			toDelete: this.toDeleteNode,
			toHidden: this.toHidden
		}, n = Ur(t), r = /* @__PURE__ */ R(Wr, { ...t }), i = this.customAdvanceHook.getToolbarViewRender(e) || this.props.pluginCtx.config.toolbarViewRender;
		return i && (r = /* @__PURE__ */ R(i, {
			node: e,
			context: this.props.pluginCtx,
			toolBarItems: n.map,
			toolBarItemList: n.list
		})), r;
	};
	getQuickAddMaterials = (e) => {
		let t = this.props.pluginCtx.pageModel.materialsModel.getAllSnippets().flatMap((e) => e.list.flatMap((e) => e.list)), n = e.material?.value.advanceCustom?.quickAddMaterials;
		if (n) return typeof n == "function" ? n(e, t) : n;
		let r = this.props.pluginCtx.engine.props.quickAddMaterials;
		return r ? typeof r == "function" ? r(e, t) : r : t;
	};
	onQuickAdd = (e, t, n) => {
		if (!t.schema.componentName) return;
		let r = this.props.pluginCtx.pageModel.createNode({
			...t.schema,
			componentName: t.schema.componentName
		});
		r && (this.props.pluginCtx.pageModel.addNode(r, e, n), setTimeout(() => this.toSelectNode(r.id), 16));
	};
	renderQuickAddView = () => {
		if (this.props.pluginCtx.meta?.quickAddView !== !0) return null;
		let e = this.state.quickAddNode, t = e ? this.layoutRef.current?.designRenderRef.current?.getInstancesById(e.id) : [], n = this.layoutRef.current?.state.currentSelectInstance, r = n?._NODE_ID === e?.id ? n : t?.find((e) => e._UNIQUE_ID === n?._UNIQUE_ID) || t?.[0];
		if (!e || !r) return null;
		let i = r.getDom(), a = r._NODE_MODEL.material?.value.rootSelector;
		if (a && i && (i = i.querySelector?.(a) || i), !i || !("getBoundingClientRect" in i)) return null;
		let o = i, s = o.getBoundingClientRect(), c = this.layoutRef.current?.iframeContainer.iframe, l = this.layoutRef.current?.canvasWorkspaceRef.current;
		if (!c || !l) return null;
		let u = c.getBoundingClientRect(), d = l.getBoundingClientRect(), f = c.clientWidth ? u.width / c.clientWidth : 1, p = c.clientHeight ? u.height / c.clientHeight : 1, m = {
			top: u.top + s.top * p,
			bottom: u.top + (s.top + s.height) * p,
			left: u.left + s.left * f,
			right: u.left + (s.left + s.width) * f
		}, h = (() => {
			let e = o.parentElement;
			if (!e) return "vertical";
			let t = window.getComputedStyle(e), n = window.getComputedStyle(o);
			return t.display === "flex" && ["row", "row-reverse"].includes(t.flexDirection) || [
				"inline",
				"inline-block",
				"float",
				"grid"
			].includes(n.display) ? "horizontal" : "vertical";
		})();
		return bt(/* @__PURE__ */ R("div", {
			style: {
				position: "absolute",
				left: u.left - d.left + s.left * f,
				top: u.top - d.top + s.top * p,
				width: s.width * f,
				height: s.height * p,
				pointerEvents: "none",
				zIndex: 1e3
			},
			children: /* @__PURE__ */ R(ei, {
				instance: r,
				direction: h,
				insideBoundary: {
					before: h === "vertical" ? m.top - 52 - 13 < d.top : m.left - 52 - 13 < d.left,
					after: h === "vertical" ? m.bottom + 52 + 13 > d.bottom : m.right + 52 + 13 > d.right
				},
				getMaterials: this.getQuickAddMaterials,
				onAdd: this.onQuickAdd
			})
		}), l);
	};
	onHoverNode = (e, t, n) => {
		this.props.pluginCtx.emitter.emit("onHover", e);
		let r = e?.material;
		r || console.warn("material not found", e);
		let i = {
			context: this.props.pluginCtx,
			viewPortal: this.getPortalViewCtx(),
			event: n,
			extra: {}
		}, a = this.getGhostView(t, i), o = {
			hoverToolbarView: /* @__PURE__ */ R("div", {
				className: W.hoverTips,
				children: r?.value.title || r?.componentName
			}),
			ghostView: a,
			hoverRectViewRender: this.customAdvanceHook.getHoverRectViewRender(e) || this.props.pluginCtx.config.hoverRectViewRender
		};
		t || (o.ghostView = null), this.setState({ ...o });
	};
	nodeCanDrag = async (e) => {
		let t = e.extraData?.dragNode;
		return await this.customAdvanceHook.canDrag({
			dragNode: t,
			eventObj: e
		});
	};
	nodeCanDrop = async (e) => {
		let t = e.extraData, n = t?.dragNode;
		return await this.customAdvanceHook.canDrop({
			dragNode: n,
			eventObj: e,
			...t
		});
	};
	innerSelectRectViewRender = (e) => {
		let { selectRectViewRender: t } = this.state, { pluginCtx: n } = this.props, r = t, i = n.engine.getActiveNode();
		return !r || !i ? /* @__PURE__ */ R(L, {}) : /* @__PURE__ */ R(r, {
			node: i,
			componentInstance: e.instance,
			componentInstanceIndex: e.index,
			params: {
				viewPortal: this.getPortalViewCtx(),
				context: this.props.pluginCtx,
				extra: {}
			}
		});
	};
	innerHoverRectViewRender = (e) => {
		let { hoverRectViewRender: t } = this.state, n = t;
		return n ? /* @__PURE__ */ R(n, {
			node: e.instance._NODE_MODEL,
			componentInstance: e.instance,
			componentInstanceIndex: e.index,
			params: {
				viewPortal: this.getPortalViewCtx(),
				context: this.props.pluginCtx,
				extra: {}
			}
		}) : /* @__PURE__ */ R(L, {});
	};
	innerDropViewRender = (e) => {
		let { dropViewRender: t } = this.state, n = t;
		return n ? /* @__PURE__ */ R(n, {
			...e,
			node: e.instance._NODE_MODEL,
			componentInstance: e.instance,
			componentInstanceIndex: e.index,
			params: {
				viewPortal: this.getPortalViewCtx(),
				context: this.props.pluginCtx,
				extra: {}
			}
		}) : /* @__PURE__ */ R(L, {});
	};
	onNodeSizeChange = (e, t) => {
		console.log("[nodeSize change]", {
			node: e,
			event: t
		}), Rn(e, t.extraData, this.props.pluginCtx.engine.props.responsiveSizes);
	};
	render() {
		let { layoutRef: e, props: t, onSelectNode: n, onDragStart: r, onHoverNode: i, onNodeDrop: a, onNodeDragging: o, onNodeDragEnd: s, onNodeSizeChange: c } = this, { pageModel: l, hoverToolbarView: u, selectToolbarView: d, ghostView: f, portalView: p, canvasFooterView: m, selectRectViewRender: h, hoverRectViewRender: g, dropViewRender: _ } = this.state, { pluginCtx: v } = t, y = v.assetsPackageListManager.getList() || [], b = v.engine.props.renderJSUrl || "./render.umd.js", x = {};
		return h && (x.selectRectViewRender = this.innerSelectRectViewRender), g && (x.hoverRectViewRender = this.innerHoverRectViewRender), _ && (x.dropViewRender = this.innerDropViewRender), d && (x.selectToolbarView = this.state.selectToolbarView), /* @__PURE__ */ z("div", {
			className: W.canvasRoot,
			children: [
				/* @__PURE__ */ R("div", {
					className: W.layoutWrapper,
					children: /* @__PURE__ */ R(kt, {
						beforeInitRender: t.pluginCtx.config.beforeInitRender,
						customRender: t.pluginCtx.config.customRender,
						ref: e,
						pageModel: l,
						renderJSUrl: b,
						...t,
						canvasToolbarView: /* @__PURE__ */ R($r, {
							ctx: v,
							zoom: this.state.canvasScale * 100
						}),
						onPageRuntimeReady: this.onPageRuntimeReady,
						onCanvasScaleChange: (e) => this.setState({ canvasScale: e }),
						hoverToolBarView: u,
						selectBoxStyle: {},
						hoverBoxStyle: {},
						nodeCanDrag: this.nodeCanDrag,
						nodeCanDrop: this.nodeCanDrop,
						onSelectNode: n,
						onNodeDragStart: r,
						onHoverNode: i,
						onNodeDrop: a,
						onNodeDragging: o,
						onNodeDraEnd: s,
						onNodeSizeChange: c,
						...x,
						ghostView: f,
						assets: y,
						pluginCtx: this.props.pluginCtx
					})
				}),
				this.renderQuickAddView(),
				m,
				p && bt(p, document.body)
			]
		});
	}
}, ni = 0, ri = (e) => Math.max(1, e - 0), ii = () => {
	let t = e.createRef();
	return {
		name: Rr,
		PLUGIN_NAME: Rr,
		async init(e) {
			e.name = Rr, e.getWorkbench().replaceBodyView(/* @__PURE__ */ R(ti, {
				ref: t,
				pluginCtx: e
			}));
		},
		async destroy(e) {
			console.log("destroy", e);
		},
		export: () => ({
			setMode(e) {
				return t.current?.layoutRef.current?.setMode(e);
			},
			setPreviewMode() {
				return t.current?.layoutRef.current?.setMode(At.PREVIEW);
			},
			setEditMode() {
				return t.current?.layoutRef.current?.setMode(At.EDIT);
			},
			setCanvasWidth(e) {
				let n = t.current?.getIframeDom();
				if (n?.containerDom) {
					let t = e;
					typeof e == "number" && (t = `${ri(e)}px`), n.containerDom.style.width = String(t), n.containerDom.style.margin = "0";
				}
			},
			setCanvasScale(e) {
				t.current?.layoutRef.current?.setCanvasScale(e);
			},
			fitCanvasToViewport() {
				t.current?.layoutRef.current?.fitCanvasToViewport();
			},
			setCanvasFooterView(e) {
				t.current?.setCanvasFooterView(e);
			},
			subscribePageRuntime(e) {
				return t.current?.subscribePageRuntime(e) || (() => {});
			},
			getIframeDom() {
				return t.current?.getIframeDom();
			},
			getInstance: () => t.current,
			getDnd: () => t.current?.layoutRef.current?.dnd,
			selectNode: async (e) => await t.current?.toSelectNode(e),
			copyNode: async (e) => await t.current?.toCopyNode(e),
			deleteNode: async (e) => await t.current?.toDeleteNode(e),
			getSelectedNodeId: () => t.current?.layoutRef.current?.state.currentSelectId,
			clearSelectNode: () => {
				t.current?.layoutRef.current?.clearSelectNode();
			},
			updatePage: (e) => {
				t.current?.layoutRef.current?.designRenderRef?.current?.rerender(e);
			},
			reload: () => {
				t.current?.reloadRender();
			},
			getComponentInstances: (e) => t.current?.layoutRef.current?.designRenderRef.current?.getInstancesById(e) || [],
			getDynamicComponentInstances: (e) => (t.current?.layoutRef.current?.designRenderRef.current?.renderRef.current?.dynamicComponentInstanceMap)?.get(e) || [],
			getLayoutRef: () => t.current?.layoutRef,
			getDesignerWindow: () => t.current?.layoutRef.current?.iframeContainer.getWindow(),
			updateRenderComponents: (e) => t.current?.updateRenderComponents(e)
		}),
		meta: { engine: { version: "1.0.0" } }
	};
};
ii.PLUGIN_NAME = Rr;
//#endregion
//#region src/plugins/OutlineTree/util.tsx
var ai = (e, t) => e ? e.getAttribute(t) || ai(e.parentElement, t) : null, oi = (e, t, n) => {
	let r = (e, t) => {
		let i = e.children || [];
		Array.isArray(i) || (i = []), i = i.filter((e) => typeof e != "string");
		let a = n.materialsModel.findByComponentName(e.componentName)?.value.title, o = n.getNode(e.id || ""), s = {
			title: e.title || a || e.componentName,
			key: e.id,
			children: [],
			parent: t,
			features: di(o),
			canDropPos: o?.isContainer() ? void 0 : ["after", "before"]
		}, c = [], l = {
			title: "SLOT",
			key: `${e.id}-SLOT`,
			children: c,
			canBeSelected: !1,
			canDropPos: !1,
			parent: null,
			containerRender: ({ treeNodeView: e }) => /* @__PURE__ */ R("div", {
				style: {
					border: "1px solid #a97cf8",
					borderTopWidth: "6px",
					marginRight: "2px",
					marginTop: "5px"
				},
				children: e
			})
		}, u = e.props || {}, d = (t, r, i) => {
			if (Ze(t)) {
				let a = t, o = n.getNode(e.id), s = "";
				if (o) {
					let e = f(o, [...i, r]);
					s = qe(e);
				}
				let u = r;
				s && (u = qe(s) || r);
				let d = {
					title: u,
					key: `${e.id}-${i.join("_")}`,
					children: [],
					canBeSelected: !1,
					canDrag: !1,
					canDropPos: ["current"],
					parent: l
				}, p = [];
				p = a.value && !Array.isArray(a.value) ? [a.value] : a.value, d.children = oi(p, d, n), c.push(d);
				return;
			}
			if (lt(t)) {
				let e = t;
				Object.keys(e).forEach((t) => {
					d(e[t], t, [...i, r]);
				});
			}
			Array.isArray(t) && t.forEach((e, t) => {
				d(e, String(t), [...i, r]);
			});
		}, f = (e, t) => mi(e)[t.map((e) => String(parseInt(e, 10)) === e ? "$NUM" : e).join(".")] || "";
		Object.keys(u).forEach((e) => {
			d(u[e], e, []);
		}), c.length > 0 && (s.children?.push(l), l.parent = s);
		let p = i.map((e) => r(e, s)) || [];
		return s.children = [...s.children, ...p], s;
	};
	return Array.isArray(e) ? e.map((e) => r(e, t)) : r(e, t);
}, si = (e, t) => {
	let n = e.componentsTree, r = n.children || [];
	Array.isArray(r) || (r = []);
	let i = {
		title: "Page",
		key: n.id || "globalState",
		rootNode: !0,
		children: []
	};
	return i.children = oi(r, i, t), [i];
}, ci = (e, t) => {
	if (t.length === 0) return e !== void 0;
	if (t[0] === "$NUM") return Array.isArray(e) && e.some((e) => ci(e, t.slice(1)));
	if (!lt(e) && !Array.isArray(e)) return !1;
	let n = t[0];
	if (Array.isArray(e)) {
		let r = Number(n);
		return Number.isInteger(r) && r >= 0 && r < e.length ? ci(e[r], t.slice(1)) : !1;
	}
	return Object.prototype.hasOwnProperty.call(e, n) ? ci(e[n], t.slice(1)) : !1;
}, li = (e) => {
	let t = e.getPlainProps();
	if (!t) return !1;
	let n = e.value.configure?.propsSetter || {};
	return Object.values(n).some((e) => e?.setter === "FunctionSetter" && ci(t, e.name.split("."))) || ui(t);
}, ui = (e) => Array.isArray(e) ? e.some((e) => ui(e)) : lt(e) ? e.type === "FUNCTION" || Object.values(e).some((e) => ui(e)) : !1, di = (e) => {
	if (!e) return [];
	let t = [];
	return Object.keys(e.value.state || {}).length > 0 && t.push("state"), (e.value.eventListener || []).length > 0 && t.push("event"), li(e) && t.push("function"), t;
}, fi = (e, t) => {
	let n = [];
	n = Array.isArray(e) ? e : [e];
	let r = !1, i = (e, t) => {
		r || (t(e) ? r = !0 : e.children?.forEach((e) => {
			i(e, t);
		}));
	};
	n.forEach((e) => {
		i(e, t);
	});
};
function pi(e) {
	let { point: t, dom: n } = e, r, i = t, a = n.getBoundingClientRect(), o = a.height, s = a.x + 50, c = a.y + Math.round(o / 2);
	return r = i.y > c ? "after" : "before", i.x > s && r === "after" && (r = "current"), {
		pos: r,
		direction: "vertical"
	};
}
var mi = (e) => {
	let t = {}, n = e.material?.value.props;
	if (!n) return t;
	let r = (e, n) => {
		if (lt(e)) {
			let i = [...n], a = e, o = a.componentName;
			if (o === "ArraySetter") {
				let e = a.props?.item.setters || [], o = t[n.join(".")], s = "";
				s = typeof o == "string" ? o : o.label, i.push("$NUM"), e.forEach((e) => {
					s = `${s}`, t[i.join(".")] = s, r(e, i);
				});
			} else o === "ShapeSetter" && (a.props?.elements || []).forEach((e) => {
				let n = [...i];
				n.push(e.name), t[n.join(".")] = e.title, (e.setters || []).forEach((e) => {
					r(e, [...n]);
				});
			});
		}
	};
	return n.forEach((e) => {
		let n = null;
		n = et(e) ? e.content : e;
		let i = [];
		i = Array.isArray(n) ? n : [n], i.forEach((e) => {
			let n = [e.name];
			t[n.join(".")] = e.title, e.setters?.forEach((e) => {
				r(e, n);
			});
		});
	}), t;
}, hi = /* @__PURE__ */ function(e) {
	return e.DRAGGING = "DRAGGING", e.NORMAL = "NORMAL", e;
}({}), gi = e.createContext({
	state: {
		treeData: [],
		currentSelectNodeKeys: [],
		expandKeys: [],
		multiSelect: !1,
		dragState: "NORMAL",
		pageModel: null
	},
	updateState: () => {},
	onSelectNode: async () => !0,
	onDeleteNode: async () => !0,
	onCopyNode: async () => !0
}), G = {
	contentBox: "_contentBox_79vrl_2",
	nodeBox: "_nodeBox_79vrl_13",
	nodeContent: "_nodeContent_79vrl_19",
	toolbarBox: "_toolbarBox_79vrl_19",
	selected: "_selected_79vrl_20",
	nodeArrow: "_nodeArrow_79vrl_47",
	expanded: "_expanded_79vrl_52",
	nodeRenderView: "_nodeRenderView_79vrl_56",
	nodeTitle: "_nodeTitle_79vrl_65",
	iconItem: "_iconItem_79vrl_84",
	featureTags: "_featureTags_79vrl_98",
	featureTag: "_featureTag_79vrl_98",
	"featureTag-state": "_featureTag-state_79vrl_120",
	"featureTag-event": "_featureTag-event_79vrl_126",
	"featureTag-function": "_featureTag-function_79vrl_132",
	nodeChildren: "_nodeChildren_79vrl_138",
	dropAnchorLine: "_dropAnchorLine_79vrl_155",
	arrowSpan: "_arrowSpan_79vrl_166"
}, _i = "data-drag-key", vi = (e) => {
	let t = u({ titleEditable: !1 }), { level: n = 0, item: r, paths: i = ["0"] } = e, [s, c] = d(!0), { state: l, updateState: f, onSelectNode: p, onDeleteNode: m, getDesignerHandler: h, onCopyNode: g } = a(gi), [_, v] = d(t.current?.titleEditable), [y, b] = d("");
	t.current.titleEditable = _;
	let x = l.expandKeys.find((e) => e === r.key), S = (e) => {
		let t = l.expandKeys;
		e === void 0 ? x ? t = t.filter((e) => e !== r.key) : t.push(r.key || "") : e === !0 ? x || t.push(r.key || "") : x && (t = t.filter((e) => e !== r.key)), f({ expandKeys: t });
	}, C = l.currentSelectNodeKeys.find((e) => e === r.key), T = u(null), E = async () => {
		if (S(!0), _) {
			T?.current?.focus();
			return;
		}
		if (r.canBeSelected !== void 0 && r.canBeSelected === !1) return;
		let e = l.currentSelectNodeKeys;
		if (!l.multiSelect) {
			r.key ? await p?.({
				keys: [r.key],
				node: r
			}) && f({ currentSelectNodeKeys: [String(r.key)] }) : p?.({
				keys: [],
				node: r
			});
			return;
		}
		C ? e = e.filter((e) => e !== r.key) : e.push(String(r.key)), p?.({
			keys: e,
			node: r
		}), f({ currentSelectNodeKeys: e });
	}, D = 20 * n, O = r.canBeSelected ?? !0, k = { [_i]: r.key }, A = u(), j = u();
	j.current = l, A.current = (e) => {
		let t = l.expandKeys, n = Array.from(/* @__PURE__ */ new Set([...t, e]));
		f({ expandKeys: n });
	};
	let ee = u(null);
	o(() => {
		let n = 0;
		ee.current?.addEventListener("mouseenter", () => {
			n = window.setTimeout(() => {
				j.current?.dragState === hi.DRAGGING && A.current?.(r.key || "");
			}, 800);
		}), ee.current?.addEventListener("mouseleave", () => {
			clearTimeout(n);
		});
		let i = (e) => {
			if (t.current.titleEditable) {
				if (e.target === T.current?.input) return;
				v(!1), M.updateValue();
			}
		}, a;
		return (async () => {
			let t = ((await e.pluginCtx.pluginManager.get("Designer"))?.export)?.getDesignerWindow();
			t?.addEventListener("click", i), a = t || null;
		})(), document.addEventListener("click", i), () => {
			n && clearTimeout(n), document.removeEventListener("click", i), a?.removeEventListener("click", i);
		};
	}, []);
	let M = l.pageModel?.getNode(r.key || ""), te = () => {
		let e = !s;
		if (!M) return;
		let t = M.value.configure.devState ?? {};
		t.condition = e, M.value.configure.devState = t, M.updateValue(), c(e);
	}, ne = r.title;
	r.titleViewRender && (ne = r.titleViewRender({
		item: r,
		titleView: r.title
	}));
	let re = /* @__PURE__ */ z("div", {
		className: G.nodeBox,
		children: [/* @__PURE__ */ z("div", {
			className: P([G.nodeContent, C && O && G.selected]),
			style: {
				marginLeft: `${-D}px`,
				paddingLeft: `${D + 8}px`
			},
			onMouseMove: async () => {
				if (!r.key) return;
				let e = (await h?.())?.getDynamicComponentInstances(r.key);
				e?._CONDITION !== void 0 && c(e?._CONDITION);
			},
			children: [
				r.children?.length ? /* @__PURE__ */ R("span", {
					style: { paddingRight: "5px" },
					className: G.arrowSpan,
					onClickCapture: () => S(),
					children: /* @__PURE__ */ R(je, { className: P([G.nodeArrow, x && G.expanded]) })
				}) : null,
				/* @__PURE__ */ z("div", {
					className: G.nodeRenderView,
					...k,
					ref: ee,
					onClick: E,
					onDoubleClick: () => {
						if (!M) return;
						let e = M, t = e.materialsModel.findByComponentName(e.value.componentName)?.value.title, n = e.value.title || t || e.value.componentName || "";
						b(n), v(!0), setTimeout(() => {
							T.current?.focus();
						}, 16.66);
					},
					children: [/* @__PURE__ */ z("div", {
						className: G.nodeTitle,
						children: [!_ && ne, _ && /* @__PURE__ */ R("div", {
							style: { paddingRight: "10px" },
							children: /* @__PURE__ */ R(w, {
								size: "small",
								maxLength: 20,
								style: {},
								ref: T,
								value: y,
								onPressEnter: () => {
									v(!1), M.updateValue();
								},
								onChange: (e) => {
									M.value.title = e.target.value, b(e.target.value);
								}
							})
						})]
					}), !_ && r.features?.length ? /* @__PURE__ */ R("div", {
						className: G.featureTags,
						children: r.features.map((e) => /* @__PURE__ */ R("span", {
							className: P(G.featureTag, G[`featureTag-${e}`]),
							children: e === "state" ? "S" : e === "event" ? "E" : "F"
						}, e))
					}) : null]
				}),
				!_ && !r.rootNode && /* @__PURE__ */ z("div", {
					className: G.toolbarBox,
					children: [
						/* @__PURE__ */ z("div", {
							className: G.iconItem,
							children: [!s && /* @__PURE__ */ R(ve, { onClick: te }), s && /* @__PURE__ */ R(_e, { onClick: te })]
						}),
						/* @__PURE__ */ R("div", {
							className: G.iconItem,
							onClick: () => {
								g(r.key || "");
							},
							children: /* @__PURE__ */ R(fe, {})
						}),
						/* @__PURE__ */ R("div", {
							className: G.iconItem,
							onClick: () => {
								m(r.key || "");
							},
							children: /* @__PURE__ */ R(me, {})
						})
					]
				})
			]
		}), /* @__PURE__ */ R("div", {
			className: P([G.nodeChildren, C && G.selected]),
			style: {
				paddingLeft: "20px",
				height: x ? "auto" : "0"
			},
			children: x && r.children?.map((t, r) => {
				let a = `${t.key}-${r}`;
				return /* @__PURE__ */ R(vi, {
					item: t,
					paths: [...i, r],
					level: n + 1,
					pluginCtx: e.pluginCtx
				}, a);
			})
		})]
	});
	return r.containerRender ? r.containerRender({
		item: r,
		treeNodeView: re
	}) : re;
}, yi = class extends e.Component {
	domRef;
	disposeCbList = [];
	sensor;
	constructor(t) {
		super(t), this.domRef = e.createRef(), this.state = {
			treeData: [],
			currentSelectNodeKeys: [],
			expandKeys: [],
			multiSelect: t.multiSelect || !1,
			dropPosInfo: {
				x: 0,
				y: 0
			},
			pageModel: t.pluginCtx.pageModel,
			dragState: hi.NORMAL
		};
	}
	getDesignerHandler = async () => (await this.props.pluginCtx.pluginManager.get("Designer"))?.export;
	updateTreeDataFromNode = () => {
		let { pluginCtx: e } = this.props, { pageModel: t } = e, n = si(t.export(), t);
		this.setState({ treeData: n });
	};
	getParentKeyPaths = (e) => {
		let { treeData: t } = this.state, n = null;
		if (fi(t, (t) => t.key === e && (n = t, !0)), n) {
			let e = n?.parent, t = [];
			for (; e;) e.key && t.push(e.key), e = e.parent;
			return t;
		}
		return [];
	};
	scrollNodeToView = (e) => {
		document.querySelector(`[${_i}="${e}"]`)?.scrollIntoView?.({
			behavior: "smooth",
			block: "center"
		});
	};
	async componentDidMount() {
		this.updateTreeDataFromNode();
		let { pluginCtx: e } = this.props, { pageModel: t } = e;
		t.emitter.on("*", () => {
			this.updateTreeDataFromNode();
		}), e.globalEmitter.on("onSelectNodeChange", ({ node: e }) => {
			this.toSelectTreeNode(e);
		}), e.getWorkbench().emitter.on("leftPanelVisible", ({ visible: t, panelName: n }) => {
			if (t && n === "OutlineTree") {
				console.log("visible, panelName", t, n);
				let r = e.engine.getActiveNode();
				r && this.toSelectTreeNode(r);
			}
		});
		let n = e.engine.getActiveNode();
		n && this.toSelectTreeNode(n), await this.props.pluginCtx.pluginManager.onPluginReadyOk("Designer"), this.registerDragEvent(), this.props.pluginCtx.engine.pageModel.emitter.on("onReloadPage", () => {
			this.registerDragEvent();
		});
	}
	toSelectTreeNode = (e) => {
		if (!e) {
			this.setState({ currentSelectNodeKeys: [] });
			return;
		}
		let t = this.getParentKeyPaths(e.id);
		V.debug("onSelectNodeChange parent path", t, e);
		let n = Array.from(/* @__PURE__ */ new Set([...this.state.expandKeys, ...t]));
		V.debug("onSelectNodeChange newExpandKeys", n, e), this.setState({
			currentSelectNodeKeys: [e.id],
			expandKeys: n
		}), setTimeout(() => {
			this.scrollNodeToView(e.id);
		}, 16);
	};
	containNode = (e, t) => {
		let n = null;
		return fi(e, (e) => e.key === t.key && (n = e, !0)), n;
	};
	getTreeNodeByKey = (e) => {
		let { treeData: t } = this.state, n = null;
		return fi(t, (t) => t.key === e && (n = t, !0)), n;
	};
	registerDragEvent = async () => {
		if (!this.domRef.current) return;
		let e = new jt({
			container: this.domRef.current,
			name: "OutlineTree",
			eventPriority: 999,
			mainDocument: document
		}), { pluginCtx: t } = this.props, n = t.pageModel, r = await this.getDesignerHandler(), i = r.getDnd();
		e.setCanDrag(async (t) => {
			let i = t.event.target;
			if (!i) return;
			let a = ai(i, _i);
			if (!a) return;
			let o = n.getNode(a), s = this.getTreeNodeByKey(a);
			if (s?.canDrag !== void 0 && s?.canDrag === !1) return;
			let c = await r.getInstance()?.customAdvanceHook.canDrag({
				dragNode: o,
				eventObj: {
					extraData: {},
					...t,
					from: t.event,
					fromSensor: e,
					fromPointer: t.pointer
				}
			});
			if (c === !1) return !1;
			if (!o) {
				console.log("targetNode not found");
				return;
			}
			let l = {
				...t,
				extraData: {
					dragNode: o,
					dragNodeUID: o.id
				}
			};
			return typeof c == "object" && (l.extraData.dragNode = c.dragNode, l.extraData.dragNodeUID = c.dragNode?.id || ""), l;
		}), e.setCanDrop(async (t) => {
			let i = t.event.target;
			if (!i) return V.debug("drop dom not found"), t;
			let a = ai(i, _i);
			if (!a) return V.debug("targetNodeId dom not found", t, i, _i), t;
			let o = this.getTreeNodeByKey(a);
			if (o?.canDropPos !== void 0 && o.canDropPos === !1) return V.debug("node can not be drop by tree node config"), t;
			let s = n.getNode(a);
			if (!s) return V.debug("targetNode not found"), t;
			let c = t.extraData?.dragNode;
			if (!c) return V.debug("startNode not found"), t;
			if (c?.id === s.id) return V.debug("startNode and dropNode is the same"), t;
			if (c.contains(s.id)) return V.debug("startNode contain dropNode"), t;
			let l = pi({
				point: t.pointer,
				dom: i
			});
			if (Array.isArray(o?.canDropPos) && !o?.canDropPos.includes(l.pos)) return !1;
			V.info("can dropNode", s);
			let u = {
				...t,
				extraData: {
					...t.extraData,
					dropPosInfo: l,
					dropNode: s,
					dropNodeUID: s.id
				}
			}, d = await r.getInstance()?.customAdvanceHook.canDrop({
				dragNode: u.extraData.dragNode,
				dropNode: s,
				eventObj: {
					...u,
					from: u.event,
					fromSensor: e,
					fromPointer: u.pointer
				}
			});
			return d !== !1 && (typeof d == "object" && (u.extraData = {
				...u.extraData,
				...d
			}), u);
		}), i.registerSensor(e), e.emitter.on("dragging", (e) => {
			let t = e.extraData.dropNode;
			if (this.setState({ dragState: hi.DRAGGING }), !t) {
				this.setState({ dropPosInfo: null });
				return;
			}
			let n = document.querySelectorAll(`[${_i}="${t.id}"]`)?.[0];
			if (!n) return;
			let r = e.extraData?.dropPosInfo || {}, i = n.getBoundingClientRect(), a = {
				x: 0,
				y: 0
			};
			a.x = i.x, r.pos === "before" ? a.y = i.y : r.pos === "after" ? a.y = i.y + i.height : (a.y = i.y + i.height, a.x = i.x + 20), this.setState({ dropPosInfo: a });
		}), e.emitter.on("dragEnd", () => {
			this.setState({ dragState: hi.NORMAL });
		}), this.sensor = e;
	};
	render() {
		let { treeData: e, dragState: t, dropPosInfo: n } = this.state, { pluginCtx: r } = this.props;
		return /* @__PURE__ */ R(gi.Provider, {
			value: {
				sensor: this.sensor,
				state: this.state,
				getDesignerHandler: this.getDesignerHandler,
				onSelectNode: async ({ keys: e }) => {
					let t = await r.pluginManager.get("Designer");
					if (!t) return console.warn("Designer is empty"), !1;
					let n = e?.[0] || "";
					return r.pageModel.getNode(n) ? await t.export.selectNode(n) : !1;
				},
				updateState: (e) => {
					this.setState(e);
				},
				onDeleteNode: async (e) => {
					let t = await r.pluginManager.get("Designer");
					if (!t) return console.warn("Designer is empty"), !1;
					let n = t.export, i = e;
					if (!r.pageModel.getNode(i)) return ae.error("该节点不能删除"), !1;
					let a = await n.deleteNode(e);
					return a || ae.error("该节点不能删除"), a;
				},
				onCopyNode: async (e) => {
					let t = await r.pluginManager.get("Designer");
					return t ? await t.export.copyNode(e) : (console.warn("Designer is empty"), !1);
				}
			},
			children: /* @__PURE__ */ z("div", {
				className: G.contentBox,
				ref: this.domRef,
				children: [e.map((e, t) => /* @__PURE__ */ R(vi, {
					item: e,
					pluginCtx: this.props.pluginCtx
				}, e.key + `${t}`)), t === hi.DRAGGING && n && /* @__PURE__ */ R("div", {
					className: G.dropAnchorLine,
					style: {
						left: `${n.x}px`,
						top: `${n.y}px`
					}
				})]
			})
		});
	}
}, bi = {
	zh_CN: { pluginName: "大纲树" },
	en_US: { pluginName: "Layout Tree" }
}, xi = "OutlineTree", Si = `plugin:${xi}`, Ci = /* @__PURE__ */ new WeakMap(), wi = {
	name: xi,
	PLUGIN_NAME: xi,
	async init(e) {
		let { i18n: t } = e;
		Object.keys(bi).forEach((e) => {
			t.addResourceBundle(e, Si, bi[e], !0, !0);
		});
		let n = Ot(Si)(yi), r = Ot(Si)(({ t: e }) => /* @__PURE__ */ R(L, { children: e("pluginName") })), i = e.getWorkbench(), a = ({ node: e }) => {
			e && (i.state.currentActiveLeftPanel !== xi || !i.state.leftBoxVisible) && i.openLeftPanel(xi);
		};
		e.globalEmitter.on("onSelectNodeChange", a), Ci.set(e, a), i.addLeftPanel({
			title: /* @__PURE__ */ R(r, {}),
			name: xi,
			icon: /* @__PURE__ */ R(oe, {}),
			render: /* @__PURE__ */ R(n, { pluginCtx: e })
		}), e.pluginReadyOk();
	},
	async destroy(e) {
		let t = Ci.get(e);
		t && (e.globalEmitter.off("onSelectNodeChange", t), Ci.delete(e)), console.log("destroy", e);
	},
	export: () => ({}),
	meta: { engine: { version: "1.0.0" } }
};
wi.PLUGIN_NAME = xi;
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ActionFlowSetter/config.ts
var Ti = "chamn-action-drag-handler", Ei = "INPUT_HANDLE_ID", Di = "OUTPUT_HANDLE_ID", Oi = "REQUEST_API_FAILED_HANDLE_ID", ki = e.createContext({
	formName: "",
	formState: {},
	conditionConfig: {},
	updateContext: () => {},
	updateConditionConfig: () => {},
	customSetterMap: {}
}), Ai = {}, ji = () => {}, Mi = (e) => {
	Object.assign(Ai, e), ji?.();
}, Ni = class extends e.Component {
	updateContext;
	isMount = !1;
	constructor(e) {
		super(e), this.updateContext = (e, t) => {
			this.setState({
				formState: e,
				customSetterMap: Ai
			}), this.props.onValueChange?.(this.formatValue(e), t);
		}, ji = () => {
			this.isMount && this.setState({ customSetterMap: {
				...Ai,
				...this.props.customSetterMap
			} });
		}, Mi(e.customSetterMap || {}), this.state = {
			formName: e.name,
			formState: e.initialValue ?? {},
			conditionConfig: {},
			customSetterMap: e.customSetterMap || {},
			updateContext: this.updateContext,
			updateConditionConfig: (e, t) => {
				this.setState({ conditionConfig: {
					...this.state.conditionConfig,
					[e]: t
				} });
			}
		};
	}
	componentDidMount() {
		this.isMount = !0;
	}
	componentWillUnmount() {
		this.isMount = !1;
	}
	getFieldsValue = () => this.formatValue(this.state.formState);
	setFields = (e) => {
		this.setState({ formState: e });
	};
	formatValue = (e) => {
		let t = {}, n = this.state.conditionConfig;
		return Object.keys(e).forEach((r) => {
			(n[r]?.(e) ?? !0) && (t[r] = e[r]);
		}), t;
	};
	render() {
		let { state: e } = this, { children: t } = this.props;
		return /* @__PURE__ */ R(ki.Provider, {
			value: e,
			children: t
		});
	}
}, Pi = ({ onValueChange: e, setterContext: t, initialValue: n, ...r }) => {
	let [i, a] = d(r.value ?? n ?? ""), s = u(r.value ?? n);
	return o(() => {
		let e = r.value ?? n;
		e !== s.current && (s.current = e, a(e ?? ""));
	}, [r.value, n]), /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ R(w, {
			...r,
			value: i,
			onChange: (e) => {
				let t = e.target.value;
				a(t);
			},
			onBlur: (t) => {
				let n = t.target.value;
				s.current = n, r.onChange?.(t), e?.(n), r.onBlur?.(t);
			}
		})
	});
};
Pi.setterName = "字符设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/NumberSetter/index.tsx
var Fi = ({ onValueChange: e, setterContext: t, initialValue: n, ...r }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(T, {
		style: { width: "100%" },
		...r,
		value: r.value ?? n,
		onChange: (t) => {
			r.onChange?.(t), e?.(t);
		}
	})
});
Fi.setterName = "数字设置器";
//#endregion
//#region src/component/CustomSchemaForm/utils.ts
var Ii = (e = []) => e.map((e) => typeof e == "string" ? { componentName: e } : e), Li = {
	string: "StringSetter",
	number: "NumberSetter",
	boolean: "BooleanSetter",
	array: "ArraySetter",
	expression: "ExpressionSetter",
	function: "FunctionSetter",
	json: "JSONSetter"
}, Ri = (e) => e == null ? "string" : Array.isArray(e) ? "array" : typeof e == "object" ? e.type === "EXPRESSION" ? "expression" : e.type === "FUNCTION" ? "function" : "json" : typeof e, zi = (e, t) => {
	let n = Li[Ri(e)];
	return t.find((e) => e.componentName === n);
};
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ArraySetter/ArrayItem.tsx
function Bi(e) {
	let { index: t, keyPaths: n, setters: r } = e, i = { ...e.style }, a = { [t]: e.value }, s = u(null);
	return o(() => {
		s.current?.setFields({ [t]: e.value });
	}, [t, e.value]), /* @__PURE__ */ R("div", {
		style: i,
		children: /* @__PURE__ */ R(Ni, {
			ref: s,
			name: String(t),
			initialValue: a || {},
			onValueChange: e.onValueChange,
			customSetterMap: {},
			children: /* @__PURE__ */ R(_o, {
				suffix: /* @__PURE__ */ R("div", {
					style: {
						marginLeft: "8px",
						cursor: "pointer",
						fontSize: "12px"
					},
					children: /* @__PURE__ */ R(me, { onClick: e.onDelete })
				}),
				name: String(t),
				label: `${e.labelPrefix ?? `元素-${t}`}`,
				defaultCollapseOpen: e.defaultOpen,
				keyPaths: [...n, String(t)],
				setters: r
			})
		})
	});
}
var Vi = {
	dragItem: "_dragItem_4tovs_2",
	sortModalBox: "_sortModalBox_4tovs_13",
	addOneBtn: "_addOneBtn_4tovs_19"
}, Hi = ({ list: e, onValueChange: t, keyPaths: n, label: r, sortLabelKey: i, ...a }) => {
	let [s, c] = d([]);
	o(() => {
		let t = e.map((e, t) => ({
			val: e,
			oldIndex: t,
			id: I()
		}));
		c(t);
	}, [e, a.open]);
	let l = Zt(Xt(Jt, { activationConstraint: { distance: 15 } }), Xt(qt, { coordinateGetter: en }));
	function u(e) {
		let { active: n, over: r } = e;
		if (n.id !== r?.id) {
			let e = s.findIndex((e) => e.id === n?.id), i = s.findIndex((e) => e.id === r?.id), a = $t(s, e, i), o = a.map((e) => e.val);
			c(a), t?.(o);
		}
	}
	let [f, p] = d({
		x: 0,
		y: 0,
		scaleX: 1,
		scaleY: 1
	});
	return /* @__PURE__ */ R(E, {
		...a,
		title: `Sort:  ${r} [${n.join(".")}]`,
		styles: { mask: { backgroundColor: "rgba(0, 0, 0, 0.1)" } },
		modalRender: (e) => /* @__PURE__ */ R(Kt, {
			sensors: l,
			onDragEnd: ({ delta: e }) => {
				let t = {
					...f,
					...e,
					x: f.x + (e?.x || 0),
					y: f.y + (e?.y || 0)
				};
				p(t);
			},
			children: /* @__PURE__ */ R(Ui, {
				modal: e,
				transform: f
			})
		}),
		children: /* @__PURE__ */ R("div", {
			className: Vi.sortModalBox,
			children: /* @__PURE__ */ R(Kt, {
				sensors: l,
				onDragEnd: u,
				modifiers: [nn],
				children: /* @__PURE__ */ R(Qt, {
					items: s,
					children: s.map(({ id: e, val: t }, n) => /* @__PURE__ */ R(Wi, {
						id: e,
						index: n,
						label: t[i || ""]
					}, e))
				})
			})
		})
	});
}, Ui = ({ modal: e, transform: t }) => {
	let n = u(I()), { setNodeRef: r, attributes: i, listeners: a, transform: o } = Yt({ id: n.current }), s = {
		...t,
		...o,
		x: t.x + (o?.x || 0),
		y: t.y + (o?.y || 0)
	};
	return /* @__PURE__ */ R("div", {
		ref: r,
		style: {
			pointerEvents: "auto",
			transform: Gt.Transform.toString(s)
		},
		...i,
		...a,
		children: e
	});
}, Wi = (e) => {
	let { attributes: t, listeners: n, setNodeRef: r, transform: i, transition: a } = tn({ id: e.id }), o = {
		transform: Gt.Transform.toString(i),
		transition: a
	}, s = e.label || `Ele ${e.index}`;
	return /* @__PURE__ */ R("div", {
		className: Vi.dragItem,
		ref: r,
		style: o,
		...t,
		...n,
		children: s
	});
};
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ArraySetter/index.tsx
function Gi(e) {
	return Array.isArray(e) ? e : [];
}
var Ki = ({ onValueChange: e, setterContext: t, item: { setters: n, initialValue: r }, sortLabelKey: i, initialValue: a, itemLabelPrefix: s, itemLabelPrefixKey: c, ...u }) => {
	let { keyPaths: f, label: p } = t, m = l(() => Gi(u.value ?? a), [a, u.value]), [g, _] = d(!1), v = Ii(n || [{ component: "StringSetter" }]), [y, x] = d(null);
	return o(() => {
		t.setCollapseHeaderExt && t.setCollapseHeaderExt?.(/* @__PURE__ */ R(h, {
			type: "text",
			size: "small",
			style: { color: "gray" },
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), _(!0);
			},
			children: "sort"
		}));
	}, [t]), /* @__PURE__ */ z(b, {
		theme: { token: { borderRadius: 4 } },
		children: [
			m.map((t, n) => /* @__PURE__ */ R(Bi, {
				labelPrefix: t[c || i || ""] || s,
				style: { paddingBottom: "10px" },
				index: n,
				defaultOpen: y === n,
				keyPaths: f,
				value: t,
				onValueChange: (t) => {
					m[n] = t[n], e?.([...m]);
				},
				setters: v,
				onDelete: () => {
					let t = [...m];
					t.splice(n, 1), e?.(t);
				}
			}, n)),
			/* @__PURE__ */ R(h, {
				className: Vi.addOneBtn,
				size: "small",
				onClick: () => {
					let t = [...m];
					x(t.length), e?.([...t, r ?? ""]);
				},
				children: "Add One"
			}),
			/* @__PURE__ */ R(Hi, {
				label: p,
				sortLabelKey: i,
				onValueChange: (t) => {
					e?.([...t]);
				},
				open: g,
				list: m,
				keyPaths: f,
				onCancel: () => {
					_(!1);
				},
				onOk: () => {
					_(!1);
				}
			})
		]
	});
};
Ki.setterName = "数组设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ShapeSetter/index.tsx
var qi = ({ onValueChange: e, elements: t, value: n, setterContext: r, initialValue: i }) => {
	let { keyPaths: a } = r, s = u(null);
	return o(() => {
		s.current?.setFields(n || {});
	}, [n]), /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ R(Ni, {
			ref: s,
			name: a.join("."),
			initialValue: n || i || {},
			onValueChange: (t) => {
				e?.(t);
			},
			customSetterMap: {},
			children: t.map((e, t) => {
				let n = Ii(e.setters), r = qe(e.title), i = Je(e.title) || e?.description;
				return /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(_o, {
					name: e.name,
					label: r,
					tips: i,
					condition: e.condition,
					keyPaths: [...a, e.name],
					setters: n
				}) }, t);
			})
		})
	});
};
qi.setterName = "对象设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/FunctionSetter/defaultDts.ts?raw
var Ji = "type SetStateInternal<T> = {\n  _(\n    partial:\n      | T\n      | Partial<T>\n      | {\n          _(state: T): T | Partial<T>;\n        }['_'],\n    replace?: boolean | undefined\n  ): void;\n}['_'];\nexport interface StoreApi<T> {\n  setState: SetStateInternal<T>;\n  getState: () => T;\n  subscribe: (listener: (state: T, prevState: T) => void) => () => void;\n  /**\n   * @deprecated Use `unsubscribe` returned by `subscribe`\n   */\n  destroy: () => void;\n}\n\ntype PageState = any;\n\ntype NodeId = keyof PageState;\n\ntype MethodsManager = any;\n\ntype GlobalState = any;\n\ntype CurrentNodeState = any;\n\ntype PageStateManager<K extends keyof PageState> = {\n  state: PageState[K];\n  updateState: (newState: Partial<PageState[K]>) => void;\n};\n\ntype PageStateManagerMap = {\n  [K in keyof PageState]: PageStateManager<K>;\n};\n\ntype ContextType = {\n  /** 渲染函数的入口参数 */\n  params?: Record<any, any>;\n  /** 全局状态 */\n  globalState?: GlobalState;\n  /** 更新全局状态 */\n  updateGlobalState?: (newState: Partial<GlobalState>) => void;\n  /** 存储当前节点的数据，不具有响应性, 可能不是最新的值, 可以直接赋值 **/\n  staticVar?: Record<string | number, any>;\n  methods?: Record<string, (...arg: any) => any>;\n  /** 当前节点状态 **/\n  state?: CurrentNodeState;\n  /** 更新当前节点状态 */\n  updateState?: (newState: Partial<CurrentNodeState>) => void;\n  /** 获取当前节点状态最新 */\n  /**  用于访访问和管理页面被注册为全局的局部 state 快照，在闭包中使用会存在值不是最新的情况 */\n  stateManager: PageStateManagerMap;\n  /** 循环数据 */\n  loopData?: {\n    item: any;\n    index: number;\n  };\n  /** 组件节点的 Ref, 可以通过 current 直接调用节点提供的方法，需要判断是否在存在 */\n  nodeRefs?: { get: (/** 节点 id */ nodeId: NodeId) => { current?: any } };\n  /** 运行时全局的 store 管理 */\n  storeManager?: StoreManager<NodeId>;\n  /** 第三方辅助库 */\n  thirdLibs?: Record<string, any>;\n};\n\ndeclare class StoreManager<T extends NodeId> {\n  storeMap: Map<T, StoreApi<PageState[T]>>;\n  getStore(storeName: T): StoreApi<PageState[T]> | undefined;\n  getState(nodeId: T): any;\n  getStateObj(nodeId: T): {\n    state: PageState[T];\n    updateState: (newState: Partial<PageState[T]>) => void;\n  };\n  setState(nodeId: NodeId, newState: Partial<PageState[T]>): void | undefined;\n  connect<T extends NodeId>(name: string, cb: (newState: PageState[T]) => void): () => void;\n  getStateSnapshot(): PageState;\n  destroy(): void;\n}\n\ntype UpdaterMap = {\n  [K in NodeId /** 更新对应 nodeId 的数据 **/]: (newState: Partial<PageState[K]>) => void;\n};\n\ndeclare global {\n  /** 运行时上下文 */\n  const $CTX: ContextType;\n\n  /** 当前节点的 state */\n  const $STATE: CurrentNodeState;\n\n  /** global state */\n  const $G_STATE: GlobalState;\n\n  /** 当前页面所有节点的 state */\n  const $ALL_STATE: PageState;\n\n  /** 状态更新函数 */\n  const $U_STATE: UpdaterMap;\n\n  /** 节点方法调用 */\n  const $M: MethodsManager;\n\n  /** 当前节点 ID */\n  const $N_ID: string;\n\n  /** 存储所有节点的 id  */\n  const $IDS: Record<NodeId, NodeId>;\n\n  /** 上一个 API 返回的数据，可能不存在 */\n  const $RESPONSE: any;\n\n  /** 循环数据，如果存在 */\n  const $LOOP_DATA: ContextType['loopData'];\n\n  /** 函数在配置面板传入的参数 */\n  const $PARAMS: ContextType['params'];\n\n  /** 事件传入的第一个参数，如果需要获取第二个参数，请使用 $ARGS 数组获取*/\n  const $EVENT_PARAMS: any;\n\n  /** 事件对象 */\n  const $EVENT: MouseEvent;\n\n  /** 函数执行时传入的入参 */\n  const $ARGS: any[];\n\n  /** action flow 中的局部变量 */\n  const $ACTION_VAR_SPACE: any;\n\n  /** 页面运行时的 props */\n  const $PAGE_PROPS: Record<string, any>;\n}\n", Yi = { expressionCodeEditor: "_expressionCodeEditor_1wlyd_2" };
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/FunctionSetter/helper.ts
async function Xi(e, t) {
	let n = an("typescript");
	await n.addSource({
		name: e,
		samples: [t]
	});
	let r = new rn();
	return r.addInput(n), await on({
		inputData: r,
		lang: "typescript",
		rendererOptions: {
			"just-types": "true",
			"nice-property-names": "false",
			"acronym-style": "original"
		}
	});
}
var Zi = async (e, t) => {
	let n = {}, r = [];
	tt(e, (e) => {
		n[e.id] = {
			stateTypeDefined: "",
			methodsTypeDefined: ""
		}, e.value.state && r.push((async () => {
			let t = `CNode${e.id.toUpperCase()}`, r = e.id;
			e.value.componentName === We.ROOT_CONTAINER && (t = "GlobalState", r = "GlobalState");
			let i = await Xi(t, JSON.stringify(e.value.state));
			n[r] = {
				stateTypeDefined: i.lines.join("\n"),
				methodsTypeDefined: ""
			};
		})());
	}), await Promise.all(r);
	let i = n.GlobalState;
	delete n.GlobalState;
	let a = "";
	a += "type PageState = {\n";
	let o = [];
	Object.keys(n).forEach((e) => {
		if (n[e].stateTypeDefined) {
			let t = Qi(`CNode${e.toUpperCase()}`, n[e].stateTypeDefined);
			a += `  '${e}': ${t},\n`, o.push(`'${e}'`);
		}
	}), a += "};\n\n";
	let s = Ji.replace("type PageState = any;", a);
	s = s.replace("type NodeId = any;", `type NodeId = ${o.join(" | ")};`), i?.stateTypeDefined && (s = s.replace("type GlobalState = any;", i.stateTypeDefined), s = s.replace("Partial<GlobalState>", Qi("GlobalState", i.stateTypeDefined)));
	let c = (await Xi("CurrentNodeState", JSON.stringify(t.value.state || {}))).lines.join("\n");
	return s = s.replace("type CurrentNodeState = any;", c), s = s.replace("Partial<CurrentNodeState>", Qi("CurrentNodeState", c)), s;
}, Qi = (e, t, n) => {
	let r = t.replace(`export interface ${e}`, "").trim();
	return n?.isPartial ? `Partial<${r}>` : r;
}, $i = ({ onValueChange: e, initialValue: t, setterContext: n, editorOptions: r, mode: i = "modal", ...a }) => {
	let o = u(null), [s, c] = d(!1), l = () => {
		let t = o.current?.getValue() || "";
		e?.({
			type: Re.EXPRESSION,
			value: t
		});
	}, f = {};
	(a.lineNumber === !1 || i === "inline") && (f = {
		lineNumbers: "off",
		lineDecorationsWidth: 0,
		lineNumbersMinChars: 0,
		glyphMargin: !1
	});
	let p = /* @__PURE__ */ R(Br, {
		beforeMount: async (e) => {
			e.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
				noSemanticValidation: !0,
				noSyntaxValidation: !1
			}), e.languages.typescript.javascriptDefaults.setCompilerOptions({
				target: e.languages.typescript.ScriptTarget.ES5,
				allowNonTsExtensions: !0
			});
			let t = await Zi(n.pluginCtx.pageModel, n.nodeModel), r = "ts:filename/chameleon.default.variable.d.ts";
			e.languages.typescript.javascriptDefaults.addExtraLib(t, r), e.editor.getModel(e.Uri.parse(r)) || e.editor.createModel(Ji, "typescript", e.Uri.parse(r));
		},
		onDidMount: (e) => {
			o.current = e;
		},
		initialValue: a.value?.value ?? t,
		language: "javascript",
		options: {
			automaticLayout: !0,
			tabSize: 2,
			minimap: { enabled: !1 },
			folding: !1,
			hover: {},
			...f,
			...r || {}
		},
		onChange: () => {
			i === "inline" && l();
		}
	});
	return i === "inline" ? /* @__PURE__ */ R("div", {
		className: Yi.expressionCodeEditor,
		style: {
			border: "1px solid rgba(0,0,0, 0.2)",
			...a.containerStyle || {},
			height: "100px"
		},
		children: p
	}) : /* @__PURE__ */ z(b, {
		theme: { token: { borderRadius: 4 } },
		children: [/* @__PURE__ */ R(h, {
			size: "small",
			style: {
				marginTop: "5px",
				width: "100%",
				color: "#676767",
				fontSize: "12px"
			},
			onClick: () => {
				c(!0);
			},
			children: a.value?.value || "Edit Expression"
		}), /* @__PURE__ */ R(E, {
			destroyOnHidden: !0,
			open: s,
			title: "Expression Editor",
			onCancel: () => c(!1),
			width: "calc(100vw - 100px)",
			onOk: () => {
				l(), c(!1);
			},
			style: { maxWidth: "800px" },
			styles: { body: { height: "300px" } },
			children: /* @__PURE__ */ R("div", {
				style: { height: "100%" },
				children: s && p
			})
		})]
	});
};
$i.setterName = "表达式";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/BooleanSetter/index.tsx
var ea = ({ onValueChange: e, initialValue: t, setterContext: n, ...r }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(te, {
		...r,
		checked: r.value ?? t,
		onChange: (t, n) => {
			r.onChange?.(t, n), e?.(t);
		}
	})
});
ea.setterName = "Bool 设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/SelectSetter/index.tsx
var ta = ({ onValueChange: e, setterContext: t, initialValue: n, ...r }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(j, {
		showSearch: !0,
		style: { width: "100%" },
		...r,
		value: r.value ?? n,
		onChange: (t, n) => {
			r.onChange?.(t, n), e?.(t);
		}
	})
});
ta.setterName = "选择设置器";
//#endregion
//#region src/component/MoveableModal/index.tsx
var na = (e) => {
	let t = Zt(Xt(Jt, { activationConstraint: { distance: 15 } })), [n, r] = d({
		x: 0,
		y: 0,
		scaleX: 1,
		scaleY: 1
	});
	return /* @__PURE__ */ R(E, {
		...e,
		styles: { mask: {
			backgroundColor: "rgba(0, 0, 0, 0.1)",
			pointerEvents: "none"
		} },
		modalRender: (e) => /* @__PURE__ */ R(Kt, {
			sensors: t,
			onDragEnd: ({ delta: e }) => {
				let t = {
					...n,
					...e,
					x: n.x + (e?.x || 0),
					y: n.y + (e?.y || 0)
				};
				r(t);
			},
			children: /* @__PURE__ */ R(ra, {
				modal: e,
				transform: n,
				setModalTransform: r
			})
		})
	});
}, ra = ({ modal: e, transform: t, setModalTransform: n }) => {
	let r = u(I()), { setNodeRef: i, attributes: a, listeners: o, transform: s } = Yt({ id: r.current }), c = {
		...t,
		...s,
		x: t.x + (s?.x || 0),
		y: t.y + (s?.y || 0)
	};
	return /* @__PURE__ */ z("div", {
		style: {
			pointerEvents: "auto",
			transform: Gt.Transform.toString(c)
		},
		children: [/* @__PURE__ */ R("div", {
			onDoubleClick: () => {
				n((e) => ({
					...e,
					x: 0,
					y: 0
				}));
			},
			ref: i,
			style: {
				cursor: "move",
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				height: "55px",
				zIndex: 1
			},
			...a,
			...o
		}), e]
	});
}, ia = {
	options: {
		automaticLayout: !0,
		tabSize: 2,
		suggestOnTriggerCharacters: !1,
		minimap: { enabled: !1 }
	},
	style: {
		height: "200px",
		border: "1px solid #d9d9d9",
		borderRadius: "4px"
	}
}, aa = ({ editor: e, value: t, initialValue: n, onChange: r, height: i, editorOptions: a }) => {
	let s = u(), c = u();
	return c.current = t, o(() => {
		let e = tr(s.current?.getValue() || "", {});
		JSON.stringify(t) !== JSON.stringify(e) && s.current?.setValue(JSON.stringify(t, null, 2));
	}, [t]), /* @__PURE__ */ R("div", {
		style: { height: i || ia.style.height },
		children: /* @__PURE__ */ R(Br, {
			onDidMount: (t) => {
				e.current = t, s.current = t;
			},
			onChange: r,
			initialValue: JSON.stringify(t ?? (n || {}), null, 2),
			language: "json",
			options: {
				...ia.options,
				...a
			}
		})
	});
}, oa = ({ onValueChange: e, initialValue: t, mode: n = "modal", editorOptions: r, setterContext: i, ...a }) => {
	let o = u(null), [s, c] = d(!1), l = () => {
		let t = o.current?.getValue() || "";
		try {
			let n = JSON.parse(t);
			e?.(n);
		} catch (e) {
			console.warn(e);
		}
	};
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: n === "inline" ? /* @__PURE__ */ R("div", {
			style: ia.style,
			children: /* @__PURE__ */ R(aa, {
				editor: o,
				value: a.value,
				initialValue: t,
				onChange: l,
				editorOptions: r || {}
			})
		}) : /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(h, {
			size: "small",
			style: {
				marginTop: "5px",
				width: "100%",
				color: "#676767",
				fontSize: "12px"
			},
			onClick: () => c(!0),
			children: "Edit"
		}), /* @__PURE__ */ R(na, {
			destroyOnHidden: !0,
			open: s,
			title: "JSON Editor",
			width: "800px",
			onCancel: () => c(!1),
			onOk: () => {
				l(), c(!1);
			},
			children: s && /* @__PURE__ */ R(aa, {
				editor: o,
				value: a.value,
				initialValue: t,
				height: "500px",
				editorOptions: r || {}
			})
		})] })
	});
};
oa.setterName = "JSON 设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/FunctionSetter/index.tsx
var sa = ({ onValueChange: e, initialValue: t, setterContext: n, editorOptions: r, ...i }) => {
	Zi(n.pluginCtx.pageModel, n.nodeModel);
	let a = u(null), [o, s] = d(!1), c = () => {
		let t = a.current?.getValue() || "";
		e?.({
			type: Re.FUNCTION,
			value: t
		});
	}, l = {};
	i.lineNumber === !1 && (l = {
		lineNumbers: "off",
		lineDecorationsWidth: 0,
		lineNumbersMinChars: 0,
		glyphMargin: !1
	});
	let f = /* @__PURE__ */ R(Br, {
		beforeMount: async (e) => {
			e.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
				noSemanticValidation: !0,
				noSyntaxValidation: !1
			}), e.languages.typescript.javascriptDefaults.setCompilerOptions({
				target: e.languages.typescript.ScriptTarget.ES5,
				allowNonTsExtensions: !0
			});
			let t = await Zi(n.pluginCtx.pageModel, n.nodeModel), r = "ts:filename/chameleon.default.variable.d.ts";
			e.languages.typescript.javascriptDefaults.addExtraLib(t, r), e.editor.getModel(e.Uri.parse(r)) || e.editor.createModel(Ji, "typescript", e.Uri.parse(r));
		},
		onDidMount: (e) => {
			a.current = e;
		},
		initialValue: i.value?.value ?? (t || "function run() {\n}"),
		language: "javascript",
		options: {
			automaticLayout: !0,
			tabSize: 2,
			minimap: { enabled: i.minimap ?? !0 },
			...l,
			...r || {}
		},
		onChange: () => {
			i.mode === "inline" && c();
		}
	});
	return i.mode === "inline" ? /* @__PURE__ */ R("div", {
		style: {
			border: "1px solid rgba(0,0,0, 0.2)",
			...i.containerStyle || {}
		},
		children: f
	}) : /* @__PURE__ */ z(b, {
		theme: { token: { borderRadius: 4 } },
		children: [/* @__PURE__ */ R(h, {
			size: "small",
			style: {
				marginTop: "5px",
				width: "100%",
				color: "#676767",
				fontSize: "12px"
			},
			onClick: () => {
				s(!0);
			},
			children: "Edit Function"
		}), /* @__PURE__ */ R(E, {
			centered: !0,
			destroyOnHidden: !0,
			open: o,
			title: "Function Editor",
			onCancel: () => s(!1),
			width: "calc(100vw - 100px)",
			onOk: () => {
				c(), s(!1);
			},
			style: { maxWidth: "1300px" },
			styles: { body: {
				minHeight: "500px",
				height: "calc(100vh - 280px)"
			} },
			children: /* @__PURE__ */ R("div", {
				style: { height: "100%" },
				children: o && f
			})
		})]
	});
};
sa.setterName = "函数设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/TextAreaSetter/index.tsx
var ca = ({ onValueChange: e, setterContext: t, initialValue: n, valueValidator: r, ...i }) => {
	let [a, s] = d(""), [c, l] = d(i.value ?? n ?? ""), f = u(i.value ?? n);
	o(() => {
		let e = i.value ?? n;
		e !== f.current && (f.current = e, l(e ?? ""));
	}, [i.value, n]);
	let p = (e) => {
		r !== void 0 && (r(e) ? s("") : s("error"));
	};
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ R(w.TextArea, {
			status: a,
			...i,
			value: c,
			onChange: (e) => {
				let t = e.target.value;
				l(t), p(t);
			},
			onBlur: (t) => {
				let n = t.target.value;
				f.current = n, i.onChange?.(t), e?.(n), i.onBlur?.(t);
			}
		})
	});
};
ca.setterName = "长文本设置器";
var la = {
	inputAuto: "_inputAuto_gk0d2_2",
	active: "_active_gk0d2_6"
}, ua = {
	cssColors: {
		aliceblue: "#f0f8ff",
		antiquewhite: "#faebd7",
		aqua: "#00ffff",
		aquamarine: "#7fffd4",
		azure: "#f0ffff",
		beige: "#f5f5dc",
		bisque: "#ffe4c4",
		black: "#000000",
		blanchedalmond: "#ffebcd",
		blue: "#0000ff",
		blueviolet: "#8a2be2",
		brown: "#a52a2a",
		burlywood: "#deb887",
		cadetblue: "#5f9ea0",
		chartreuse: "#7fff00",
		chocolate: "#d2691e",
		coral: "#ff7f50",
		cornflowerblue: "#6495ed",
		cornsilk: "#fff8dc",
		crimson: "#dc143c",
		cyan: "#00ffff",
		darkblue: "#00008b",
		darkcyan: "#008b8b",
		darkgoldenrod: "#b8860b",
		darkgray: "#a9a9a9",
		darkgreen: "#006400",
		darkgrey: "#a9a9a9",
		darkkhaki: "#bdb76b",
		darkmagenta: "#8b008b",
		darkolivegreen: "#556b2f",
		darkorange: "#ff8c00",
		darkorchid: "#9932cc",
		darkred: "#8b0000",
		darksalmon: "#e9967a",
		darkseagreen: "#8fbc8f",
		darkslateblue: "#483d8b",
		darkslategray: "#2f4f4f",
		darkslategrey: "#2f4f4f",
		darkturquoise: "#00ced1",
		darkviolet: "#9400d3",
		deeppink: "#ff1493",
		deepskyblue: "#00bfff",
		dimgray: "#696969",
		dimgrey: "#696969",
		dodgerblue: "#1e90ff",
		firebrick: "#b22222",
		floralwhite: "#fffaf0",
		forestgreen: "#228b22",
		fuchsia: "#ff00ff",
		gainsboro: "#dcdcdc",
		ghostwhite: "#f8f8ff",
		goldenrod: "#daa520",
		gold: "#ffd700",
		gray: "#808080",
		green: "#008000",
		greenyellow: "#adff2f",
		grey: "#808080",
		honeydew: "#f0fff0",
		hotpink: "#ff69b4",
		indianred: "#cd5c5c",
		indigo: "#4b0082",
		ivory: "#fffff0",
		khaki: "#f0e68c",
		lavenderblush: "#fff0f5",
		lavender: "#e6e6fa",
		lawngreen: "#7cfc00",
		lemonchiffon: "#fffacd",
		lightblue: "#add8e6",
		lightcoral: "#f08080",
		lightcyan: "#e0ffff",
		lightgoldenrodyellow: "#fafad2",
		lightgray: "#d3d3d3",
		lightgreen: "#90ee90",
		lightgrey: "#d3d3d3",
		lightpink: "#ffb6c1",
		lightsalmon: "#ffa07a",
		lightseagreen: "#20b2aa",
		lightskyblue: "#87cefa",
		lightslategray: "#778899",
		lightslategrey: "#778899",
		lightsteelblue: "#b0c4de",
		lightyellow: "#ffffe0",
		lime: "#00ff00",
		limegreen: "#32cd32",
		linen: "#faf0e6",
		magenta: "#ff00ff",
		maroon: "#800000",
		mediumaquamarine: "#66cdaa",
		mediumblue: "#0000cd",
		mediumorchid: "#ba55d3",
		mediumpurple: "#9370db",
		mediumseagreen: "#3cb371",
		mediumslateblue: "#7b68ee",
		mediumspringgreen: "#00fa9a",
		mediumturquoise: "#48d1cc",
		mediumvioletred: "#c71585",
		midnightblue: "#191970",
		mintcream: "#f5fffa",
		mistyrose: "#ffe4e1",
		moccasin: "#ffe4b5",
		navajowhite: "#ffdead",
		navy: "#000080",
		oldlace: "#fdf5e6",
		olive: "#808000",
		olivedrab: "#6b8e23",
		orange: "#ffa500",
		orangered: "#ff4500",
		orchid: "#da70d6",
		palegoldenrod: "#eee8aa",
		palegreen: "#98fb98",
		paleturquoise: "#afeeee",
		palevioletred: "#db7093",
		papayawhip: "#ffefd5",
		peachpuff: "#ffdab9",
		peru: "#cd853f",
		pink: "#ffc0cb",
		plum: "#dda0dd",
		powderblue: "#b0e0e6",
		purple: "#800080",
		rebeccapurple: "#663399",
		red: "#ff0000",
		rosybrown: "#bc8f8f",
		royalblue: "#4169e1",
		saddlebrown: "#8b4513",
		salmon: "#fa8072",
		sandybrown: "#f4a460",
		seagreen: "#2e8b57",
		seashell: "#fff5ee",
		sienna: "#a0522d",
		silver: "#c0c0c0",
		skyblue: "#87ceeb",
		slateblue: "#6a5acd",
		slategray: "#708090",
		slategrey: "#708090",
		snow: "#fffafa",
		springgreen: "#00ff7f",
		steelblue: "#4682b4",
		tan: "#d2b48c",
		teal: "#008080",
		thistle: "#d8bfd8",
		tomato: "#ff6347",
		turquoise: "#40e0d0",
		violet: "#ee82ee",
		wheat: "#f5deb3",
		white: "#ffffff",
		whitesmoke: "#f5f5f5",
		yellow: "#ffff00",
		yellowgreen: "#9acd32"
	},
	cssKeyValue: {
		"align-content": { values: [
			"center",
			"flex-end",
			"flex-start",
			"space-around",
			"space-between",
			"stretch"
		] },
		"align-items": { values: [
			"baseline",
			"center",
			"flex-end",
			"flex-start",
			"stretch"
		] },
		"align-self": { values: [
			"auto",
			"normal",
			"self-start",
			"self-end",
			"baseline",
			"center",
			"start",
			"end",
			"flex-end",
			"flex-start",
			"safe",
			"stretch",
			"unsafe"
		] },
		all: { values: [] },
		animation: { values: [] },
		"animation-delay": { values: [] },
		"animation-direction": { values: [
			"alternate",
			"alternate-reverse",
			"normal",
			"reverse"
		] },
		"animation-duration": { values: [] },
		"animation-fill-mode": { values: [
			"backwards",
			"both",
			"forwards",
			"none"
		] },
		"animation-iteration-count": { values: ["infinite"] },
		"animation-name": { values: ["none"] },
		"animation-play-state": { values: ["paused", "running"] },
		"animation-timing-function": { values: [
			"cubic-bezier()",
			"ease",
			"ease-in",
			"ease-in-out",
			"ease-out",
			"linear",
			"step-end",
			"step-start",
			"steps()"
		] },
		"backface-visibility": { values: ["hidden", "visible"] },
		background: {
			values: [],
			type: "color"
		},
		"background-attachment": { values: [
			"fixed",
			"local",
			"scroll"
		] },
		"background-blend-mode": { values: [
			"color",
			"color-burn",
			"color-dodge",
			"darken",
			"difference",
			"exclusion",
			"hard-light",
			"hue",
			"lighten",
			"luminosity",
			"multiply",
			"normal",
			"overlay",
			"saturation",
			"screen",
			"soft-light"
		] },
		"background-clip": { values: [
			"border-box",
			"content-box",
			"padding-box"
		] },
		"background-color": {
			values: [],
			type: "color"
		},
		"background-image": { values: [
			"image()",
			"linear-gradient()",
			"radial-gradient()",
			"repeating-linear-gradient()",
			"repeating-radial-gradient()",
			"url()"
		] },
		"background-origin": { values: [
			"border-box",
			"content-box",
			"padding-box"
		] },
		"background-position": { values: [
			"left",
			"center",
			"right",
			"bottom",
			"top"
		] },
		"background-repeat": { values: [
			"no-repeat",
			"repeat",
			"repeat-x",
			"repeat-y",
			"round",
			"space"
		] },
		"background-size": { values: [
			"auto",
			"contain",
			"cover"
		] },
		border: { values: [] },
		"border-collapse": { values: ["collapse", "separate"] },
		"border-color": {
			values: [],
			type: "color"
		},
		"border-spacing": { values: [] },
		"border-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-bottom": { values: [] },
		"border-bottom-color": {
			values: [],
			type: "color"
		},
		"border-bottom-left-radius": { values: [] },
		"border-bottom-right-radius": { values: [] },
		"border-bottom-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-bottom-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-image": { values: ["url()"] },
		"border-image-outset": { values: [] },
		"border-image-slice": { values: [] },
		"border-image-source": { values: [] },
		"border-image-repeat": { values: [
			"repeat",
			"round",
			"space",
			"stretch"
		] },
		"border-image-width": { values: ["auto"] },
		"border-left": { values: [] },
		"border-left-color": {
			values: [],
			type: "color"
		},
		"border-left-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-left-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-radius": { values: [] },
		"border-right": { values: [] },
		"border-right-color": {
			values: [],
			type: "color"
		},
		"border-right-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-right-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-top": { values: [] },
		"border-top-color": {
			values: [],
			type: "color"
		},
		"border-top-left-radius": { values: [] },
		"border-top-right-radius": { values: [] },
		"border-top-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-top-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"box-decoration-break": { values: ["clone", "slice"] },
		"box-shadow": { values: ["none"] },
		"box-sizing": { values: ["border-box", "content-box"] },
		bottom: { values: ["auto"] },
		"break-after": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"break-before": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"break-inside": { values: [
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region"
		] },
		"caption-side": { values: ["bottom", "top"] },
		"caret-color": {
			values: ["auto"],
			type: "color"
		},
		clear: { values: [
			"both",
			"left",
			"none",
			"right"
		] },
		clip: { values: ["auto"] },
		color: {
			values: [],
			type: "color"
		},
		columns: { values: [] },
		"column-count": { values: [] },
		"column-fill": { values: ["auto", "balance"] },
		"column-gap": { values: ["normal"] },
		"column-rule": { values: [] },
		"column-rule-color": {
			values: [],
			type: "color"
		},
		"column-rule-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"column-rule-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"column-span": { values: ["all", "none"] },
		"column-width": { values: ["auto"] },
		content: { values: [
			"attr()",
			"close-quote",
			"no-close-quote",
			"no-open-quote",
			"normal",
			"none",
			"open-quote"
		] },
		"counter-increment": { values: ["none"] },
		"counter-reset": { values: ["none"] },
		cursor: { values: /* @__PURE__ */ "alias.all-scroll.auto.cell.col-resize.context-menu.copy.crosshair.default.e-resize.ew-resize.grab.grabbing.help.move.n-resize.ne-resize.nesw-resize.no-drop.none.not-allowed.ns-resize.nw-resize.nwse-resize.pointer.progress.row-resize.s-resize.se-resize.sw-resize.text.vertical-text.w-resize.wait.zoom-in.zoom-out".split(".") },
		direction: { values: ["ltr", "rtl"] },
		display: { values: [
			"block",
			"contents",
			"flex",
			"flow-root",
			"grid",
			"inline",
			"inline-block",
			"inline-flex",
			"inline-grid",
			"inline-table",
			"list-item",
			"none",
			"run-in",
			"subgrid",
			"table",
			"table-caption",
			"table-cell",
			"table-column",
			"table-column-group",
			"table-footer-group",
			"table-header-group",
			"table-row",
			"table-row-group"
		] },
		"empty-cells": { values: ["hide", "show"] },
		fill: { values: [] },
		filter: { values: [
			"blur()",
			"brightness()",
			"contrast()",
			"custom()",
			"drop-shadow()",
			"grayscale()",
			"hue-rotate()",
			"invert()",
			"none",
			"opacity()",
			"sepia()",
			"saturate()",
			"url()"
		] },
		flex: { values: ["auto", "none"] },
		"flex-basis": { values: ["auto"] },
		"flex-direction": { values: [
			"column",
			"column-reverse",
			"row",
			"row-reverse"
		] },
		"flex-flow": { values: [
			"column",
			"column-reverse",
			"nowrap",
			"row",
			"row-reverse",
			"wrap",
			"wrap-reverse"
		] },
		"flex-grow": { values: [] },
		"flex-shrink": { values: [] },
		"flex-wrap": { values: [
			"nowrap",
			"wrap",
			"wrap-reverse"
		] },
		float: { values: [
			"left",
			"right",
			"none",
			"inline-start",
			"inline-end"
		] },
		"flow-into": {
			values: ["none"],
			type: "named-flow"
		},
		"flow-from": {
			values: ["none"],
			type: "named-flow"
		},
		font: { values: [] },
		"font-display": { values: [
			"auto",
			"block",
			"swap",
			"fallback",
			"optional"
		] },
		"font-family": { values: [
			"auto",
			"cursive",
			"fantasy",
			"monospace",
			"sans-serif",
			"serif"
		] },
		"font-feature-settings": { values: ["normal"] },
		"font-kerning": { values: [
			"auto",
			"none",
			"normal"
		] },
		"font-language-override": { values: ["normal"] },
		"font-size": { values: [
			"xx-small",
			"x-small",
			"small",
			"medium",
			"large",
			"x-large",
			"xx-large",
			"xxx-large",
			"larger",
			"smaller"
		] },
		"font-size-adjust": { values: ["auto", "none"] },
		"font-stretch": { values: [
			"condensed",
			"expanded",
			"extra-condensed",
			"extra-expanded",
			"normal",
			"semi-condensed",
			"semi-expanded",
			"ultra-condensed",
			"ultra-expanded"
		] },
		"font-style": { values: [
			"italic",
			"normal",
			"oblique"
		] },
		"font-synthesis": { values: [
			"none",
			"style",
			"weight"
		] },
		"font-variant": { values: ["normal", "small-caps"] },
		"font-variant-alternates": { values: ["normal"] },
		"font-variant-caps": { values: [
			"normal",
			"small-caps",
			"all-small-caps",
			"petite-caps",
			"all-petite-caps",
			"unicase",
			"titling-caps"
		] },
		"font-variant-east-asian": { values: ["normal"] },
		"font-variant-ligatures": { values: ["normal", "none"] },
		"font-variant-numeric": { values: ["normal"] },
		"font-variant-position": { values: [
			"normal",
			"sub",
			"super"
		] },
		"font-weight": { values: [
			"bold",
			"bolder",
			"lighter",
			"normal",
			"100",
			"200",
			"300",
			"400",
			"500",
			"600",
			"700",
			"800",
			"900"
		] },
		gap: { values: ["revert-layer"] },
		grid: { values: [] },
		"grid-area": { values: [] },
		"grid-auto-columns": { values: [] },
		"grid-auto-flow": { values: [
			"row",
			"column",
			"dense"
		] },
		"grid-auto-rows": { values: [] },
		"grid-column": { values: ["auto"] },
		"grid-column-end": { values: [] },
		"grid-column-gap": { values: [] },
		"grid-column-start": { values: [] },
		"grid-gap": { values: [] },
		"grid-row": { values: ["auto"] },
		"grid-row-end": { values: [] },
		"grid-row-start": { values: [] },
		"grid-row-gap": { values: [] },
		"grid-template": { values: ["none"] },
		"grid-template-areas": { values: [] },
		"grid-template-columns": { values: ["auto"] },
		"grid-template-rows": { values: ["auto"] },
		"hanging-punctuation": { values: [
			"allow-end",
			"first",
			"force-end",
			"last",
			"none"
		] },
		height: { values: [
			"auto",
			"max-content",
			"min-content",
			"fit-content"
		] },
		hyphens: { values: [
			"auto",
			"manual",
			"none"
		] },
		"image-orientation": { values: [] },
		"image-resolution": { values: ["from-image", "snap"] },
		isolation: { values: ["auto", "isolate"] },
		"justify-content": { values: [
			"center",
			"flex-end",
			"flex-start",
			"space-around",
			"space-between"
		] },
		"justify-items": { values: [
			"auto",
			"normal",
			"stretch",
			"center",
			"start",
			"end",
			"flex-start",
			"flex-end",
			"self-start",
			"self-end",
			"left",
			"right",
			"baseline",
			"first",
			"last",
			"safe",
			"unsafe",
			"legacy"
		] },
		"justify-self": { values: [
			"auto",
			"normal",
			"stretch",
			"center",
			"start",
			"end",
			"flex-start",
			"flex-end",
			"self-start",
			"self-end",
			"left",
			"right",
			"baseline",
			"first",
			"last",
			"safe",
			"unsafe"
		] },
		left: { values: ["auto"] },
		"letter-spacing": { values: ["normal"] },
		"line-height": { values: ["normal"] },
		"list-style": { values: [
			"none",
			"url()",
			"armenian",
			"circle",
			"decimal",
			"decimal-leading-zero",
			"disc",
			"georgian",
			"inside",
			"lower-alpha",
			"lower-greek",
			"lower-latin",
			"lower-roman",
			"outside",
			"square",
			"upper-alpha",
			"upper-latin",
			"upper-roman"
		] },
		"list-style-image": { values: ["none", "url()"] },
		"list-style-position": { values: ["inside", "outside"] },
		"list-style-type": { values: [
			"armenian",
			"circle",
			"decimal",
			"decimal-leading-zero",
			"disc",
			"georgian",
			"lower-alpha",
			"lower-greek",
			"lower-latin",
			"lower-roman",
			"none",
			"square",
			"upper-alpha",
			"upper-latin",
			"upper-roman"
		] },
		margin: { values: ["auto"] },
		"margin-bottom": { values: ["auto"] },
		"margin-left": { values: ["auto"] },
		"margin-right": { values: ["auto"] },
		"margin-top": { values: ["auto"] },
		"max-height": { values: ["none"] },
		"max-width": { values: ["none"] },
		"min-height": { values: [] },
		"min-width": { values: [] },
		"mix-blend-mode": { values: [
			"color",
			"color-burn",
			"color-dodge",
			"darken",
			"difference",
			"exclusion",
			"hard-light",
			"hue",
			"lighten",
			"luminosity",
			"multiply",
			"normal",
			"overlay",
			"saturation",
			"screen",
			"soft-light"
		] },
		"object-fit": { values: [
			"contain",
			"cover",
			"fill",
			"none",
			"scale-down"
		] },
		"object-position": { values: [
			"left",
			"center",
			"right",
			"bottom",
			"top"
		] },
		opacity: { values: [] },
		order: { values: [] },
		orphans: { values: [] },
		outline: { values: [] },
		"outline-color": {
			values: ["invert"],
			type: "color"
		},
		"outline-offset": { values: [] },
		"outline-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"outline-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		overflow: { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-x": { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-y": { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-wrap": { values: [
			"normal",
			"anywhere",
			"break-word"
		] },
		padding: { values: [] },
		"padding-bottom": { values: [] },
		"padding-left": { values: [] },
		"padding-right": { values: [] },
		"padding-top": { values: [] },
		"page-break-after": { values: [
			"always",
			"auto",
			"avoid",
			"left",
			"right"
		] },
		"page-break-before": { values: [
			"always",
			"auto",
			"avoid",
			"left",
			"right"
		] },
		"page-break-inside": { values: ["auto", "avoid"] },
		perspective: { values: ["none"] },
		"perspective-origin": { values: [
			"bottom",
			"center",
			"left",
			"right",
			"top"
		] },
		"pointer-events": { values: [
			"all",
			"auto",
			"fill",
			"none",
			"painted",
			"stroke",
			"visible",
			"visibleFill",
			"visiblePainted",
			"visibleStroke"
		] },
		position: { values: [
			"absolute",
			"fixed",
			"relative",
			"static",
			"sticky"
		] },
		quotes: { values: ["none"] },
		"region-break-after": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"region-break-before": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"region-break-inside": { values: [
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region"
		] },
		"region-fragment": { values: ["auto", "break"] },
		resize: { values: [
			"both",
			"horizontal",
			"none",
			"vertical"
		] },
		right: { values: ["auto"] },
		"scroll-behavior": { values: ["auto", "smooth"] },
		"scroll-snap-type": { values: [
			"none",
			"x",
			"y",
			"block",
			"inline",
			"both",
			"mandatory",
			"proximity"
		] },
		src: { values: ["url()"] },
		"shape-image-threshold": { values: [] },
		"shape-inside": { values: [
			"auto",
			"circle()",
			"ellipse()",
			"outside-shape",
			"polygon()",
			"rectangle()"
		] },
		"shape-margin": { values: [] },
		"shape-outside": { values: [
			"none",
			"circle()",
			"ellipse()",
			"polygon()",
			"inset()",
			"margin-box",
			"border-box",
			"padding-box",
			"content-box",
			"url()",
			"image()",
			"linear-gradient()",
			"radial-gradient()",
			"repeating-linear-gradient()",
			"repeating-radial-gradient()"
		] },
		"tab-size": { values: [] },
		"table-layout": { values: ["auto", "fixed"] },
		"text-align": { values: [
			"start",
			"end",
			"center",
			"left",
			"justify",
			"right",
			"match-parent",
			"justify-all"
		] },
		"text-align-last": { values: [
			"center",
			"left",
			"justify",
			"right"
		] },
		"text-decoration": { values: [
			"line-through",
			"none",
			"overline",
			"underline"
		] },
		"text-decoration-color": {
			values: [],
			type: "color"
		},
		"text-decoration-line": { values: [
			"line-through",
			"none",
			"overline",
			"underline"
		] },
		"text-decoration-skip": { values: [
			"edges",
			"ink",
			"none",
			"objects",
			"spaces"
		] },
		"text-decoration-style": { values: [
			"dashed",
			"dotted",
			"double",
			"solid",
			"wavy"
		] },
		"text-emphasis": { values: [] },
		"text-emphasis-color": {
			values: [],
			type: "color"
		},
		"text-emphasis-position": { values: [
			"above",
			"below",
			"left",
			"right"
		] },
		"text-emphasis-style": { values: [
			"circle",
			"dot",
			"double-circle",
			"filled",
			"none",
			"open",
			"sesame",
			"triangle"
		] },
		"text-indent": { values: [] },
		"text-justify": { values: [
			"auto",
			"none",
			"inter-word",
			"inter-character"
		] },
		"text-overflow": { values: ["clip", "ellipsis"] },
		"text-shadow": { values: [] },
		"text-rendering": { values: [
			"auto",
			"geometricPrecision",
			"optimizeLegibility",
			"optimizeSpeed"
		] },
		"text-transform": { values: [
			"capitalize",
			"full-width",
			"lowercase",
			"none",
			"uppercase"
		] },
		"text-underline-position": { values: [
			"alphabetic",
			"auto",
			"below",
			"left",
			"right"
		] },
		top: { values: ["auto"] },
		transform: { values: [
			"matrix()",
			"matrix3d()",
			"none",
			"perspective()",
			"rotate()",
			"rotate3d()",
			"rotateX()",
			"rotateY()",
			"rotateZ()",
			"scale()",
			"scale3d()",
			"scaleX()",
			"scaleY()",
			"scaleZ()",
			"skewX()",
			"skewY()",
			"translate()",
			"translate3d()",
			"translateX()",
			"translateY()",
			"translateZ()"
		] },
		"transform-origin": { values: [
			"bottom",
			"center",
			"left",
			"right",
			"top"
		] },
		"transform-style": { values: ["flat", "preserve-3d"] },
		transition: { values: [] },
		"transition-delay": { values: [] },
		"transition-duration": { values: [] },
		"transition-property": { values: ["all", "none"] },
		"transition-timing-function": { values: [
			"cubic-bezier()",
			"ease",
			"ease-in",
			"ease-in-out",
			"ease-out",
			"linear",
			"step-end",
			"step-start",
			"steps()"
		] },
		"unicode-bidi": { values: [
			"bidi-override",
			"embed",
			"normal"
		] },
		"unicode-range": { values: [] },
		"user-select": { values: [
			"all",
			"auto",
			"contain",
			"none",
			"text"
		] },
		"vertical-align": { values: [
			"baseline",
			"bottom",
			"middle",
			"sub",
			"super",
			"text-bottom",
			"text-top",
			"top"
		] },
		visibility: { values: [
			"collapse",
			"hidden",
			"visible"
		] },
		"white-space": { values: [
			"normal",
			"nowrap",
			"pre",
			"pre-line",
			"pre-wrap"
		] },
		widows: { values: [] },
		width: { values: [
			"auto",
			"max-content",
			"min-content",
			"fit-content"
		] },
		"will-change": { values: [
			"auto",
			"contents",
			"opacity",
			"scroll-position"
		] },
		"word-break": { values: [
			"normal",
			"break-all",
			"keep-all"
		] },
		"word-spacing": { values: ["normal"] },
		"z-index": { values: ["auto"] }
	}
}, da = ua.cssKeyValue;
ua.cssColors;
var fa = Object.keys(ua.cssKeyValue), pa = ({ onValueChange: e, propertyKey: t = "", value: n, initialValue: r }) => {
	let i = u(null), [a, s] = d(n ?? (r || "")), [c, f] = d(!1), p = () => {
		e?.(a);
	};
	o(() => {
		s(n);
	}, [n]);
	let h = l(() => (da[t]?.values || []).map((e) => ({ value: e })), [t]);
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ R(m, {
			ref: i,
			popupMatchSelectWidth: 200,
			variant: "borderless",
			value: a,
			onChange: (e) => {
				s(e), p();
			},
			style: { flex: 1 },
			onFocus: () => {
				f(!0);
			},
			onBlur: () => {
				f(!1);
			},
			className: P([la.inputAuto, c && la.active]),
			placeholder: "value",
			options: h
		})
	});
};
pa.setterName = "CSS值设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ColorSetter/index.tsx
var ma = ({ onValueChange: e, initialValue: t, value: n }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(D, {
		trigger: "click",
		content: /* @__PURE__ */ R(sn, {
			color: n || t,
			onChange: (t) => {
				let n = `rgba(${t.rgb.r},${t.rgb.g},${t.rgb.b}, ${t.rgb.a || 1})`;
				e?.(n);
			}
		}),
		placement: "bottomLeft",
		styles: { body: { padding: 0 } },
		arrow: { pointAtCenter: !1 },
		children: /* @__PURE__ */ R(w, {
			placeholder: "color",
			value: n,
			onChange: (t) => {
				e?.(t.target.value);
			},
			prefix: /* @__PURE__ */ R("div", { style: {
				backgroundColor: n || "transparent",
				width: "10px",
				height: "10px",
				borderRadius: "4px",
				overflow: "hidden"
			} })
		})
	})
});
ma.setterName = "颜色设置器";
//#endregion
//#region src/config/colorPickerColorList.ts
var ha = [{
	label: "Recommended",
	colors: /* @__PURE__ */ "#000000.#000000E0.#000000A6.#00000073.#00000040.#00000026.#0000001A.#00000012.#0000000A.#00000005.#F5222D.#FA8C16.#FADB14.#8BBB11.#52C41A.#13A8A8.#1677FF.#2F54EB.#722ED1.#EB2F96.#F5222D4D.#FA8C164D.#FADB144D.#8BBB114D.#52C41A4D.#13A8A84D.#1677FF4D.#2F54EB4D.#722ED14D.#EB2F964D".split(".")
}], ga = ({ onValueChange: e, initialValue: t, value: n, setterContext: r, ...i }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(y, {
		showText: !0,
		allowClear: !0,
		value: n ?? t,
		onChangeComplete: (t) => {
			e?.(t.toRgbString());
		},
		presets: ha,
		...i
	})
});
ga.setterName = "颜色设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/SliderSetter/index.tsx
var _a = ({ onValueChange: e, setterContext: t, initialValue: n, ...r }) => /* @__PURE__ */ R(ee, {
	...r,
	value: r.value ?? n,
	onChange: (t) => {
		r.onChange?.(t), e?.(t);
	}
});
_a.setterName = "滑动条设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/RadioGroupSetter/index.tsx
var va = ({ onValueChange: e, value: t, initialValue: n, setterContext: r, ...i }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(O.Group, {
		onChange: (t) => {
			e?.(t.target.value);
		},
		defaultValue: n,
		value: t,
		...i
	})
});
va.setterName = "单选设置器";
var ya = {
	cssSizeInput: "_cssSizeInput_1wgi1_2",
	valueInput: "_valueInput_1wgi1_11",
	unitSelect: "_unitSelect_1wgi1_19",
	noUnit: "_noUnit_1wgi1_51"
}, ba = {
	inputNumberPlus: "_inputNumberPlus_1hb66_2",
	delIcon: "_delIcon_1hb66_5"
}, xa = ({ min: e, max: t, value: n, onChange: r, addonAfter: i, ...a }) => {
	let o = (e) => {
		r?.(e);
	}, s = (n) => {
		let r = n;
		e !== void 0 && (r = Math.max(e, r)), t !== void 0 && (r = Math.min(t, r)), o(r);
	}, c = l(() => {
		if (n === void 0) return !0;
		let r = n;
		return e !== void 0 && (r = Math.max(e, r)), t !== void 0 && (r = Math.min(t, r)), r === n;
	}, [
		t,
		e,
		n
	]);
	return /* @__PURE__ */ R("div", {
		className: ba.inputNumberPlus,
		children: /* @__PURE__ */ R("div", {
			style: {
				display: "flex",
				position: "relative"
			},
			children: /* @__PURE__ */ R(w, {
				allowClear: !0,
				...a,
				status: c ? void 0 : "error",
				value: n,
				onClear: () => {
					o(void 0);
				},
				onChange: (e) => {
					let t = parseInt(e.target.value || "0", 10);
					s(t);
				},
				addonAfter: i
			})
		})
	});
}, Sa = [
	{
		value: "px",
		label: "px"
	},
	{
		value: "%",
		label: "%"
	},
	{
		value: "vw",
		label: "vw"
	},
	{
		value: "vh",
		label: "vh"
	},
	{
		value: "rem",
		label: "rem"
	}
], Ca = function(e) {
	let t = u({
		status: "",
		start: {
			x: 0,
			y: 0,
			cumulativeX: 0,
			cumulativeY: 0
		},
		processing: {
			x: 0,
			y: 0,
			cumulativeX: 0,
			cumulativeY: 0
		},
		mouseDown: !1
	}), n = i(() => {
		t.current.mouseDown = !1;
		let { processing: n } = t.current;
		e?.onEnd?.({ ...n }), t.current.status = "", t.current.processing.cumulativeX = 0, t.current.processing.cumulativeY = 0;
	}, [e]), r = i(() => {
		t.current.mouseDown = !0;
	}, []), a = i((r) => {
		if (!t.current.mouseDown) return;
		let { start: i, processing: a } = t.current, o = r.clientX - i.x, s = r.clientY - i.y;
		if (t.current.status !== "running" && (Math.abs(o) > 10 || Math.abs(s) > 10)) {
			t.current.status = "running";
			let n = t.current.start;
			n.x = r.clientX, n.y = r.clientY, e?.onStart?.({ ...n });
		}
		if (t.current.status !== "running") return;
		a.x = r.clientX, a.y = r.clientY, a.cumulativeX = r.clientX - i.x, a.cumulativeY = r.clientY - i.y;
		let [c, l] = e?.limitCumulative?.x || [];
		if (c !== void 0 && a.cumulativeX < c) {
			n(r);
			return;
		}
		if (l !== void 0 && a.cumulativeX > l) {
			n(r);
			return;
		}
		e?.onChange?.({ ...a });
	}, [e, n]);
	return o(() => {
		let e = Mt(document.body, "mousemove", (e) => {
			a(e);
		}), t = Mt(document.body, "mouseup", (e) => {
			n(e);
		}), r = Mt(document.body, "mouseleave", (e) => {
			n(e);
		});
		return () => {
			e(), t(), r();
		};
	}, [n, a]), { onMouseDown: r };
}, K = (e) => {
	let t = String(e.value), [n, r] = d({
		value: 0,
		status: ""
	}), a = u(), o = u("px"), s = u(!1), c = u(null), f = u(), p = l(() => {
		let n = {
			value: void 0,
			unit: "px"
		};
		if (e.value === void 0) return n;
		let r = parseFloat(e.value || "");
		isNaN(r) || (n.value = r);
		let i = "px";
		return n.value !== void 0 && (i = t.replace(String(n.value), "").trim()), [
			"px",
			"%",
			"rem",
			"vw",
			"vx"
		].includes(i) && (n.unit = i || "px"), n;
	}, [t, e.value]), m = l(() => e.unitList ? e.unitList.map((e) => Sa.find((t) => t.value === e)).filter(Boolean) : Sa, [e.unitList]), h = l(() => ({
		min: typeof e.min == "number" ? e.min : e.min?.[p.unit],
		max: typeof e.max == "number" ? e.max : e.max?.[p.unit]
	}), [e, p]), g = l(() => {
		let e = { ...p };
		return n.status === "dragging" && (e.value = n.value), e;
	}, [p, n]), _ = i((t) => {
		let n = `${t.value}${t.unit}`;
		t.value === void 0 && (n = void 0), e.onValueChange?.(n);
	}, [e]), v = i(() => {
		c.current = null, !(!s.current || f.current === void 0) && (_({
			value: f.current,
			unit: o.current
		}), f.current = void 0);
	}, [_]), y = i((e) => {
		f.current = e, c.current === null && (c.current = window.requestAnimationFrame(v));
	}, [v]), x = i((t, n) => {
		let r = { ...t };
		e.cumulativeTransform && (r = e.cumulativeTransform(r));
		let i = n ?? 0;
		isNaN(i) && (i = 0);
		let a = e.dragAxis === "y" ? r.cumulativeY : e.dragAxis === "both" ? Math.abs(r.cumulativeX) >= Math.abs(r.cumulativeY) ? r.cumulativeX : r.cumulativeY : r.cumulativeX, o = i + a;
		return h.min !== void 0 && (o = Math.max(o, h.min)), h.max !== void 0 && (o = Math.min(o, h.max)), o;
	}, [
		h.max,
		h.min,
		e
	]), S = i((e) => {
		a.current = p.value, o.current = p.unit, s.current = !0, r({
			status: "dragging",
			value: x(e, p.value)
		});
	}, [
		p.unit,
		p.value,
		x
	]), C = i((e) => {
		let t = x(e, a.current);
		r({
			status: "dragging",
			value: t
		}), y(t);
	}, [x, y]), w = i((e) => {
		if (!s.current) return;
		let t = x(e, a.current);
		c.current !== null && (window.cancelAnimationFrame(c.current), c.current = null), f.current = void 0, _({
			value: t,
			unit: o.current
		}), s.current = !1, a.current = void 0, r({
			status: "",
			value: 0
		});
	}, [x, _]), T = u({
		onStart: S,
		onChange: C,
		onEnd: w
	});
	T.current = {
		onStart: S,
		onChange: C,
		onEnd: w
	};
	let E = Ca({
		onStart: (e) => T.current.onStart(e),
		onChange: (e) => T.current.onChange(e),
		onEnd: (e) => T.current.onEnd(e),
		limitCumulative: { x: [-60, void 0] }
	}), D = e.unit === !1 ? null : /* @__PURE__ */ R("span", {
		className: ya.unitSelect,
		children: /* @__PURE__ */ R(j, {
			size: e.size,
			defaultValue: "",
			value: g.unit,
			onChange: (e) => {
				_({
					value: g.value,
					unit: e
				});
			},
			popupMatchSelectWidth: !1,
			options: m
		})
	});
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 2 } },
		children: /* @__PURE__ */ z("div", {
			className: P([
				ya.cssSizeInput,
				e?.className,
				e.unit === !1 && ya.noUnit
			]),
			...E,
			style: e.style,
			children: [/* @__PURE__ */ R(xa, {
				className: ya.valueInput,
				size: e.size,
				value: g.value,
				min: h.min,
				max: h.max,
				onChange: (e) => {
					_({
						value: e,
						unit: g.unit
					});
				}
			}), D]
		})
	});
}, wa = ({ onValueChange: e, setterContext: t, initialValue: n, ...r }) => /* @__PURE__ */ R(b, {
	theme: { token: { borderRadius: 4 } },
	children: /* @__PURE__ */ R(K, {
		min: 0,
		...r,
		value: r.value ?? n,
		onValueChange: (t) => {
			e?.(t);
		}
	})
});
wa.setterName = "CSS size 设置器";
var q = {
	label: "_label_brdnj_2",
	font: "_font_brdnj_9",
	"m-p": "_m-p_brdnj_12",
	fontOption: "_fontOption_brdnj_16",
	row: "_row_brdnj_21",
	styleUIPanel: "_styleUIPanel_brdnj_25",
	inputWidth: "_inputWidth_brdnj_29"
}, Ta = [
	"width",
	"height",
	"min-width",
	"max-width",
	"min-height",
	"max-height",
	"flex",
	"display",
	"flex-direction",
	"justify-content",
	"align-items",
	"flex-wrap"
];
function Ea(e) {
	return e.reduce((e, t) => ({
		...e,
		[t]: ""
	}), {});
}
var Da = {
	px: 2048,
	vw: 100,
	vh: 100,
	rem: 100
}, Oa = n((e, t) => {
	let { t: n } = Dt(), [r, a] = d(e.initialValue ?? Ea(Ta)), o = i((t, n) => {
		a((r) => {
			let i = {
				...r,
				...dt(t, Ta)
			};
			return n !== !0 && e.onChange?.(i), i;
		});
	}, [e]);
	s(t, () => ({
		setValue: (e) => o({
			...Ea(Ta),
			...e
		}, !0),
		setEmptyValue: () => {
			a(Ea(Ta));
		}
	}), [o]);
	let c = l(() => e.value ?? r, [e.value, r]);
	return /* @__PURE__ */ z("div", { children: [
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				className: "flex",
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "layout:"
				}), /* @__PURE__ */ z(O.Group, {
					value: c.display,
					size: "small",
					buttonStyle: "solid",
					onChange: (e) => {
						o({ display: e.target.value });
					},
					children: [
						/* @__PURE__ */ R(O.Button, {
							value: "block",
							children: "Block"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "flex",
							children: "Flex"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "inline-block",
							children: "InlineB"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "inline",
							children: "Inline"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "none",
							children: "None"
						})
					]
				})]
			})
		}),
		c.display === "flex" && /* @__PURE__ */ z(L, { children: [
			/* @__PURE__ */ R(k, {
				className: q.row,
				children: /* @__PURE__ */ z(_, {
					span: 24,
					style: {
						display: "flex",
						flexDirection: "row",
						alignItems: "center"
					},
					children: [/* @__PURE__ */ R("span", {
						className: q.label,
						children: "AxisD:"
					}), /* @__PURE__ */ R("div", {
						style: {
							width: "200px",
							marginLeft: "3px"
						},
						children: /* @__PURE__ */ R(O.Group, {
							size: "small",
							value: c["flex-direction"],
							buttonStyle: "outline",
							options: [
								{
									label: /* @__PURE__ */ R(vn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "row"
								},
								{
									label: /* @__PURE__ */ R(_n, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "row-reverse"
								},
								{
									label: /* @__PURE__ */ R(gn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "column"
								},
								{
									label: /* @__PURE__ */ R(yn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "column-reverse"
								},
								{
									label: /* @__PURE__ */ R(wn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: ""
								}
							],
							onChange: (e) => {
								o({ "flex-direction": e.target.value || "" });
							},
							optionType: "button"
						})
					})]
				})
			}),
			/* @__PURE__ */ R(k, {
				className: q.row,
				children: /* @__PURE__ */ z(_, {
					span: 24,
					style: {
						display: "flex",
						flexDirection: "row",
						alignItems: "center"
					},
					children: [/* @__PURE__ */ R("span", {
						className: q.label,
						children: "MAxis:"
					}), /* @__PURE__ */ R("div", {
						style: {
							width: "200px",
							marginLeft: "3px"
						},
						children: /* @__PURE__ */ R(O.Group, {
							size: "small",
							value: c["justify-content"],
							buttonStyle: "outline",
							options: [
								{
									label: /* @__PURE__ */ R(ln, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "flex-start"
								},
								{
									label: /* @__PURE__ */ R(cn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "flex-end"
								},
								{
									label: /* @__PURE__ */ R(En, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "center"
								},
								{
									label: /* @__PURE__ */ R(dn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "space-between"
								},
								{
									label: /* @__PURE__ */ R(un, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "space-around"
								},
								{
									label: /* @__PURE__ */ R(wn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: ""
								}
							],
							onChange: (e) => {
								o({ "justify-content": e.target.value || "" });
							},
							optionType: "button"
						})
					})]
				})
			}),
			/* @__PURE__ */ R(k, {
				className: q.row,
				children: /* @__PURE__ */ z(_, {
					span: 24,
					style: {
						display: "flex",
						flexDirection: "row",
						alignItems: "center"
					},
					children: [/* @__PURE__ */ R("span", {
						className: q.label,
						children: "CAxis:"
					}), /* @__PURE__ */ R("div", {
						style: {
							width: "200px",
							marginLeft: "3px"
						},
						children: /* @__PURE__ */ R(O.Group, {
							size: "small",
							value: c["align-items"],
							buttonStyle: "outline",
							options: [
								{
									label: /* @__PURE__ */ R(pn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "flex-start"
								},
								{
									label: /* @__PURE__ */ R(fn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "flex-end"
								},
								{
									label: /* @__PURE__ */ R(Tn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "center"
								},
								{
									label: /* @__PURE__ */ R(hn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "space-between"
								},
								{
									label: /* @__PURE__ */ R(mn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: "space-around"
								},
								{
									label: /* @__PURE__ */ R(wn, {
										size: 14,
										style: {
											top: "3px",
											position: "relative"
										}
									}),
									value: ""
								}
							],
							onChange: (e) => {
								o({ "align-items": e.target.value || "" });
							},
							optionType: "button"
						})
					})]
				})
			}),
			/* @__PURE__ */ R(k, {
				className: q.row,
				children: /* @__PURE__ */ z(_, {
					span: 12,
					className: "flex",
					children: [/* @__PURE__ */ R("span", {
						className: q.label,
						children: "flex:"
					}), /* @__PURE__ */ R(K, {
						className: q.inputWidth,
						unit: !1,
						min: 0,
						max: Da,
						value: c.flex,
						onValueChange: (e) => {
							o({ flex: e || "" });
						},
						size: "small"
					})]
				})
			})
		] }),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [
					/* @__PURE__ */ R("span", {
						className: q.label,
						children: "width:"
					}),
					/* @__PURE__ */ R(N, {
						title: n("style.dimension.widthMediaOverride"),
						children: /* @__PURE__ */ R(Se, { style: { marginRight: "4px" } })
					}),
					/* @__PURE__ */ R(K, {
						style: { width: "180px" },
						min: 0,
						max: Da,
						value: c.width,
						onValueChange: (e) => {
							o({ width: e });
						},
						className: q.inputWidth,
						size: "small"
					}),
					/* @__PURE__ */ R(h, {
						size: "small",
						style: { marginLeft: "10px" },
						onClick: () => {
							o({ width: "100%" });
						},
						children: /* @__PURE__ */ R(xn, { size: 14 })
					})
				]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [
					/* @__PURE__ */ R("span", {
						className: q.label,
						children: "height:"
					}),
					/* @__PURE__ */ R(N, {
						title: n("style.dimension.heightMediaOverride"),
						children: /* @__PURE__ */ R(Se, { style: { marginRight: "4px" } })
					}),
					/* @__PURE__ */ R(K, {
						min: 0,
						style: { width: "180px" },
						max: Da,
						value: c.height,
						onValueChange: (e) => {
							o({ height: e });
						},
						className: q.inputWidth,
						size: "small"
					}),
					/* @__PURE__ */ R(h, {
						size: "small",
						style: { marginLeft: "10px" },
						onClick: () => {
							o({ height: "100%" });
						},
						children: /* @__PURE__ */ R(Sn, { size: 14 })
					})
				]
			})
		}),
		/* @__PURE__ */ z("div", { children: [/* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ z(_, {
				span: 12,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "minW:"
				}), /* @__PURE__ */ R(K, {
					className: q.inputWidth,
					min: 0,
					max: Da,
					value: c["min-width"],
					onValueChange: (e) => {
						o({ "min-width": e });
					},
					size: "small"
				})]
			}), /* @__PURE__ */ z(_, {
				span: 12,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "minH:"
				}), /* @__PURE__ */ R(K, {
					min: 0,
					max: Da,
					value: c["min-height"],
					onValueChange: (e) => {
						o({ "min-height": e });
					},
					className: q.inputWidth,
					size: "small"
				})]
			})]
		}), /* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ z(_, {
				span: 12,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "maxW:"
				}), /* @__PURE__ */ R(K, {
					className: q.inputWidth,
					min: 0,
					max: Da,
					value: c["max-width"],
					onValueChange: (e) => {
						o({ "max-width": e });
					},
					size: "small"
				})]
			}), /* @__PURE__ */ z(_, {
				span: 12,
				style: {
					display: "flex",
					alignItems: "center"
				},
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "maxH:"
				}), /* @__PURE__ */ R(K, {
					className: q.inputWidth,
					min: 0,
					max: Da,
					value: c["max-height"],
					onValueChange: (e) => {
						o({ "max-height": e });
					},
					size: "small"
				})]
			})]
		})] })
	] });
}), ka = {
	px: 2048,
	vw: 100,
	vh: 100,
	rem: 100
}, Aa = "100px", ja = () => ({
	left: "",
	right: "",
	top: "",
	bottom: ""
}), Ma = n((e, t) => {
	let [n, r] = d(e.initialValue ?? ja()), a = l(() => [
		"left",
		"top",
		"right",
		"bottom"
	].map((t) => `${e.prefix}-${t}`), [e.prefix]), o = i((t, n) => {
		r((r) => {
			let i = {
				...r,
				...t
			}, o = Object.keys(i).reduce((t, n) => (n === "all" ? t[`${e.prefix}`] = i?.[n] : t[`${e.prefix}-${n}`] = i?.[n], t), {});
			return n !== !0 && e.onChange?.(dt(o, a)), i;
		});
	}, [a, e]), c = i((t, n) => Object.keys(t || {}).filter((e) => e.includes(n)).reduce((n, r) => (r.replace(`${e.prefix}`, "") === "" ? n.all = t?.[r] : n[r.replace(`${e.prefix}-`, "")] = t?.[r], n), {}), [e.prefix]);
	s(t, () => ({
		setValue: (t) => {
			o({
				...ja(),
				...c(t, e.prefix)
			}, !0);
		},
		setEmptyValue: () => {
			o({ ...ja() }, !0);
		}
	}), [
		c,
		e.prefix,
		o
	]);
	let u = l(() => {
		let t = c(e.value || {}, e.prefix);
		return e.value === void 0 ? n : t;
	}, [
		c,
		e.value,
		e.prefix,
		n
	]);
	return /* @__PURE__ */ z("div", { children: [/* @__PURE__ */ z(k, {
		className: q.row,
		children: [/* @__PURE__ */ z(_, {
			span: 12,
			style: {
				display: "flex",
				alignItems: "center"
			},
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label, q["m-p"]]),
				children: "T:"
			}), /* @__PURE__ */ R(K, {
				min: 0,
				max: ka,
				value: u.top,
				onValueChange: (e) => {
					o({ top: e });
				},
				style: { width: Aa },
				size: "small"
			})]
		}), /* @__PURE__ */ z(_, {
			span: 12,
			style: {
				display: "flex",
				alignItems: "center"
			},
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label, q["m-p"]]),
				children: "L:"
			}), /* @__PURE__ */ R(K, {
				min: 0,
				max: ka,
				value: u.left,
				onValueChange: (e) => {
					o({ left: e });
				},
				style: { width: Aa },
				size: "small"
			})]
		})]
	}), /* @__PURE__ */ R("div", { children: /* @__PURE__ */ z(k, {
		className: q.row,
		children: [/* @__PURE__ */ z(_, {
			span: 12,
			style: {
				display: "flex",
				alignItems: "center"
			},
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label, q["m-p"]]),
				children: "B:"
			}), /* @__PURE__ */ R(K, {
				min: 0,
				max: ka,
				value: u.bottom,
				onValueChange: (e) => {
					o({ bottom: e });
				},
				style: { width: Aa },
				size: "small"
			})]
		}), /* @__PURE__ */ z(_, {
			span: 12,
			style: { display: "flex" },
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label, q["m-p"]]),
				children: "R:"
			}), /* @__PURE__ */ R(K, {
				style: { width: Aa },
				min: 0,
				max: ka,
				value: u.right,
				onValueChange: (e) => {
					o({ right: e });
				},
				size: "small"
			})]
		})]
	}) })] });
}), Na = n(function(e, t) {
	let [n, r] = d();
	return s(t, () => ({ updateColor: (e) => {
		r(e);
	} })), /* @__PURE__ */ R(y, {
		...e,
		value: n,
		onChange: (e) => {
			r(e);
		},
		onChangeComplete: (t) => {
			e.onChange?.(t.toRgbString());
		}
	});
}), Pa = [
	"font-size",
	"color",
	"text-align",
	"font-weight"
], Fa = {
	px: 100,
	vw: 100,
	vh: 100,
	rem: 100
}, Ia = [
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Left"
		}),
		value: "left"
	},
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Center"
		}),
		value: "center"
	},
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Right"
		}),
		value: "Right"
	}
], La = [
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Regular"
		}),
		value: "400"
	},
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Medium"
		}),
		value: "500"
	},
	{
		label: /* @__PURE__ */ R("span", {
			className: q.fontOption,
			children: "Bold"
		}),
		value: "700"
	}
], Ra = () => ({
	"font-size": "",
	color: "",
	"text-align": "",
	"font-weight": ""
}), za = n((e, t) => {
	let [n, r] = d(e.initialValue ?? Ra()), a = u(null), o = i((t, n) => {
		r((r) => {
			let i = {
				...r,
				...t
			};
			return n !== !0 && e.onChange?.(i), i;
		});
	}, [e]);
	s(t, () => ({
		setValue: (e) => {
			a.current?.updateColor(e?.color || ""), o({
				...Ra(),
				...dt(e, Pa)
			}, !0);
		},
		setEmptyValue: () => {
			o({ ...Ra() }, !0);
		}
	}), [o]);
	let c = l(() => e.value ?? n, [e.value, n]);
	return /* @__PURE__ */ z("div", { children: [
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: P([q.label]),
					children: "Color:"
				}), /* @__PURE__ */ R(Na, {
					ref: a,
					showText: !0,
					size: "small",
					onChange: (e) => {
						o({ color: e });
					},
					presets: ha
				})]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Size:"
			}), /* @__PURE__ */ R(K, {
				min: 0,
				max: Fa,
				value: c["font-size"],
				onValueChange: (e) => {
					o({ "font-size": e });
				},
				style: { width: "158px" },
				size: "small"
			})] })
		}),
		/* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label]),
				children: "Align:"
			}), /* @__PURE__ */ R(O.Group, {
				options: Ia,
				onChange: ({ target: { value: e } }) => {
					o({ "text-align": e });
				},
				value: c["text-align"]
			})]
		}),
		/* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ R("span", {
				className: P([q.label]),
				children: "Weight:"
			}), /* @__PURE__ */ R(O.Group, {
				options: La,
				onChange: ({ target: { value: e } }) => {
					o({ "font-weight": e });
				},
				value: c["font-weight"]
			})]
		})
	] });
}), Ba = ["border", "border-radius"], Va = {
	px: 100,
	vw: 100,
	vh: 100,
	rem: 100
}, Ha = () => ({
	border: "",
	"border-radius": ""
}), Ua = n((e, t) => {
	let [n, r] = d(e.initialValue ?? Ha()), a = u(null), o = i((t, n) => {
		r((r) => {
			let i = {
				...r,
				...t
			};
			return n !== !0 && e.onChange?.(i), i;
		});
	}, [e]);
	s(t, () => ({
		setValue: (e) => {
			let t = Ha();
			Object.keys(e).length ? o({
				...t,
				...dt(e, Ba)
			}, !0) : o(t, !0);
		},
		setEmptyValue: () => {
			o({ ...Ha() }, !0);
		}
	}), [o]);
	let c = l(() => {
		let e = n.border || "", t = e.split(" "), r = {
			size: t[0] || "",
			type: t[1] || "",
			color: e.replace(" ", "").replace(t[0], "").replace(t[1], "")
		};
		return a.current?.updateColor(r.color), r;
	}, [n]), f = (e) => {
		o({ border: `${e.size || "0px"} ${e.type || "none"} ${e.color || "transparent"}`.trim() });
	};
	return /* @__PURE__ */ z("div", { children: [
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				style: { position: "relative" },
				span: 24,
				children: [
					/* @__PURE__ */ R(le, {
						style: {
							position: "absolute",
							right: 0,
							top: "5px",
							color: "#4e4e4e",
							cursor: "pointer"
						},
						onClick: () => {
							o({ border: void 0 });
						}
					}),
					/* @__PURE__ */ R("span", {
						className: q.label,
						children: "Size:"
					}),
					/* @__PURE__ */ R(K, {
						min: 0,
						max: Va,
						value: c.size,
						style: { width: "100px" },
						unitList: ["px"],
						onValueChange: (e) => {
							f({
								...c,
								size: e || ""
							});
						},
						size: "small"
					})
				]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: P([q.label]),
					children: "Color:"
				}), /* @__PURE__ */ R(Na, {
					ref: a,
					showText: !0,
					size: "small",
					value: c.color || "",
					onChange: (e) => {
						f({
							...c,
							color: e
						});
					},
					presets: ha
				})]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: P([q.label]),
					children: "Type:"
				}), /* @__PURE__ */ z(O.Group, {
					value: c.type,
					size: "small",
					onChange: (e) => {
						f({
							...c,
							type: e.target.value || ""
						});
					},
					children: [
						/* @__PURE__ */ R(O.Button, {
							value: "solid",
							children: "Solid"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "dashed",
							children: "Dashed"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "dotted",
							children: "Dotted"
						}),
						/* @__PURE__ */ R(O.Button, {
							value: "none",
							children: "None"
						})
					]
				})]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Radius:"
			}), /* @__PURE__ */ R(K, {
				min: 0,
				max: Va,
				value: n["border-radius"],
				onValueChange: (e) => {
					o({ "border-radius": e });
				},
				style: { width: "158px" },
				size: "small"
			})] })
		})
	] });
}), Wa = [
	"background-color",
	"background-image",
	"background-repeat",
	"background-size"
], Ga = () => ({
	"background-color": "",
	"background-image": "",
	"background-size": "",
	"background-repeat": ""
}), Ka = n((e, t) => {
	let [n, r] = d(e.initialValue ?? Ga()), a = u(null), o = i((t, n) => {
		r((r) => {
			let i = {
				...r,
				...t
			};
			return a.current?.updateColor(i["background-color"]), n !== !0 && e.onChange?.(i), i;
		});
	}, [e]);
	s(t, () => ({
		setValue: (e) => {
			let t = Ga();
			Object.keys(e).length ? o({
				...t,
				...dt(e, Wa)
			}, !0) : o(t, !0);
		},
		setEmptyValue: () => {
			let e = Ga();
			o(e, !0);
		}
	}), [o]);
	let c = l(() => e.value ?? n, [e.value, n]);
	return /* @__PURE__ */ z("div", { children: [
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: P([q.label]),
					children: "Color:"
				}), /* @__PURE__ */ R(Na, {
					ref: a,
					showText: !0,
					size: "small",
					value: c["background-color"] || "",
					onChange: (e) => {
						o({ "background-color": e });
					},
					presets: ha
				})]
			})
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: q.label,
					children: "Image:"
				}), /* @__PURE__ */ R(w, {
					style: { flex: 1 },
					size: "small",
					value: /url\(['|"|*]?(.+?)['|"|*]?\)/.exec(c["background-image"])?.[1] || "",
					onChange: (e) => {
						console.log(`url("${e.target.value}")`), o({ "background-image": `url("${e.target.value}")` });
					}
				})]
			})
		}),
		/* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Size:"
			}), /* @__PURE__ */ z(O.Group, {
				size: "small",
				defaultValue: "a",
				buttonStyle: "solid",
				value: c["background-size"],
				onChange: (e) => {
					o({ "background-size": e.target.value });
				},
				children: [
					/* @__PURE__ */ R(O.Button, {
						value: "contain",
						children: "Contain"
					}),
					/* @__PURE__ */ R(O.Button, {
						value: "cover",
						children: "Cover"
					}),
					/* @__PURE__ */ R(O.Button, {
						value: "auto",
						children: "Auto"
					})
				]
			})]
		}),
		/* @__PURE__ */ z(k, {
			className: q.row,
			children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Repeat:"
			}), /* @__PURE__ */ z(O.Group, {
				size: "small",
				buttonStyle: "solid",
				value: c["background-repeat"],
				onChange: (e) => {
					o({ "background-repeat": e.target.value });
				},
				children: [/* @__PURE__ */ R(O.Button, {
					value: "repeat",
					children: "Repeat"
				}), /* @__PURE__ */ R(O.Button, {
					value: "no-repeat",
					children: "NoRepeat"
				})]
			})]
		})
	] });
}), qa = () => ({ "box-shadow": "" }), Ja = n((e, t) => {
	let [n, r] = d(e.initialValue ?? qa()), a = u(null), o = l(() => {
		let t = Wn((e.value?.["box-shadow"] ?? n["box-shadow"]) || "")[0] || {};
		return a.current?.updateColor(t.color || ""), t;
	}, [e.value, n]), c = i((t, n) => {
		r((r) => {
			console.log("set val", r, t);
			let i = e.value?.["box-shadow"], a = {
				...Wn(i || "")[0] || {},
				...t
			}, o = `${a.offsetX || "0"} ${a.offsetY || "0"} ${a.blur || "0"} ${a.spread || "0"} ${a.color || "transparent"}`, s = {
				...r,
				"box-shadow": o
			};
			return n !== !0 && e.onChange?.(s), s;
		});
	}, [e]);
	return s(t, () => ({
		setValue: (e) => {
			c({
				...qa(),
				...Wn(e["box-shadow"] || "")[0]
			}, !0);
		},
		setEmptyValue: () => {
			c({ ...qa() }, !0);
		}
	}), [c]), /* @__PURE__ */ z("div", { children: [
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "OffsetX:"
			}), /* @__PURE__ */ R(K, {
				min: -40,
				max: 40,
				unitList: ["px"],
				value: o.offsetX,
				onValueChange: (e) => {
					c({
						...o,
						offsetX: e
					});
				},
				style: { width: "158px" },
				size: "small"
			})] })
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "OffsetY:"
			}), /* @__PURE__ */ R(K, {
				min: -40,
				max: 40,
				unitList: ["px"],
				value: o.offsetY,
				onValueChange: (e) => {
					c({
						...o,
						offsetY: e
					});
				},
				style: { width: "158px" },
				size: "small"
			})] })
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Blur:"
			}), /* @__PURE__ */ R(K, {
				min: -40,
				max: 40,
				unitList: ["px"],
				value: o.blur,
				onValueChange: (e) => {
					c({
						...o,
						blur: e
					});
				},
				style: { width: "158px" },
				size: "small"
			})] })
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, { children: [/* @__PURE__ */ R("span", {
				className: q.label,
				children: "Spread:"
			}), /* @__PURE__ */ R(K, {
				min: -40,
				max: 40,
				unitList: ["px"],
				value: o.spread,
				onValueChange: (e) => {
					c({
						...o,
						spread: e
					});
				},
				style: { width: "158px" },
				size: "small"
			})] })
		}),
		/* @__PURE__ */ R(k, {
			className: q.row,
			children: /* @__PURE__ */ z(_, {
				span: 24,
				style: { display: "flex" },
				children: [/* @__PURE__ */ R("span", {
					className: P([q.label]),
					children: "Color:"
				}), /* @__PURE__ */ R(Na, {
					ref: a,
					showText: !0,
					size: "small",
					onChange: (e) => {
						c({
							...o,
							color: e
						});
					},
					presets: ha
				})]
			})
		})
	] });
}), Ya = { cssCodeEditor: "_cssCodeEditor_1vl7z_2" };
//#endregion
//#region src/component/CSSCodeEditor/helper.ts
function Xa(e) {
	let t = {}, n = ft.parse(e, { context: "stylesheet" });
	return ft.walk(n, {
		visit: "Rule",
		enter(e) {
			if (e.type === "Rule" && e.prelude.type === "SelectorList") {
				let n = ft.generate(e.prelude), r = {};
				if (e.block.type === "Block") {
					for (let t of e.block.children.toArray()) if (t.type === "Declaration") {
						let e = t.property;
						r[e] = ft.generate(t.value);
					}
				}
				t[n] = r;
			}
		}
	}), t;
}
//#endregion
//#region src/component/CSSCodeEditor/index.tsx
var Za = (e = {}) => {
	let t = ".node {\n";
	return Object.keys(e).forEach((n) => {
		t += `  ${n}: ${e[n]};\n`;
	}), t += "}", t;
}, Qa = n((e, t) => {
	let n = u(null), r = u({});
	return s(t, () => ({
		setEmptyValue: () => {
			r.current = {}, n.current?.setValue(Za({}));
		},
		setValue: (e) => {
			st(e, r.current) || (r.current = e, n.current?.setValue(Za(e)));
		}
	}), []), /* @__PURE__ */ R("div", {
		className: Ya.cssCodeEditor,
		style: {
			paddingTop: "10px",
			width: "100%",
			height: "150px",
			border: "1px solid rgba(0,0,0,0.2)",
			position: "relative",
			borderRadius: "4px"
		},
		children: /* @__PURE__ */ R(Br, {
			language: "css",
			onDidMount: (e) => {
				n.current = e, n.current?.setValue(Za(r.current || {}));
			},
			onChange: (t) => {
				let n = Xa(t || "")[".node"] || {};
				r.current = n, e.onValueChange?.(n);
			},
			options: {
				tabSize: 2,
				minimap: { enabled: !1 },
				folding: !1,
				lineNumbers: "off",
				hover: {}
			}
		})
	});
}), J = {
	visualSize: "_visualSize_kxmf6_2",
	header: "_header_kxmf6_10",
	dimensions: "_dimensions_kxmf6_11",
	hint: "_hint_kxmf6_26",
	diagram: "_diagram_kxmf6_33",
	layer: "_layer_kxmf6_44",
	margin: "_margin_kxmf6_50",
	border: "_border_kxmf6_57",
	padding: "_padding_kxmf6_64",
	layerName: "_layerName_kxmf6_71",
	top: "_top_kxmf6_78",
	bottom: "_bottom_kxmf6_79",
	right: "_right_kxmf6_86",
	left: "_left_kxmf6_87",
	value: "_value_kxmf6_108",
	content: "_content_kxmf6_120",
	contentLabel: "_contentLabel_kxmf6_137",
	contentSize: "_contentSize_kxmf6_142"
}, $a = [
	"top",
	"right",
	"bottom",
	"left"
], eo = (e, t) => e[t] || "0px", to = [
	{
		name: "margin",
		color: "margin",
		keys: $a.map((e) => `margin-${e}`)
	},
	{
		name: "border",
		color: "border",
		keys: $a.map((e) => `border-${e}-width`)
	},
	{
		name: "padding",
		color: "padding",
		keys: $a.map((e) => `padding-${e}`)
	}
], no = (e) => {
	let t = e.ownerDocument.defaultView?.getComputedStyle(e);
	if (!t) return {};
	let n = $a.reduce((e, n) => ({
		...e,
		[`margin-${n}`]: t.getPropertyValue(`margin-${n}`),
		[`padding-${n}`]: t.getPropertyValue(`padding-${n}`),
		[`border-${n}-width`]: t.getPropertyValue(`border-${n}-width`)
	}), {}), { width: r, height: i } = e.getBoundingClientRect();
	return {
		width: `${Math.round(r)}`,
		height: `${Math.round(i)}`,
		...n
	};
}, ro = ({ value: e = {}, dom: t }) => {
	let n = t ? no(t) : e, r = (e) => /* @__PURE__ */ R("span", {
		className: J.value,
		children: eo(n, e).replace(/[^\d.-]/g, "") || "0"
	});
	return /* @__PURE__ */ R("section", {
		className: J.visualSize,
		"aria-label": "Visual size",
		children: /* @__PURE__ */ R("div", {
			className: J.diagram,
			children: to.map((e) => /* @__PURE__ */ z("div", {
				className: `${J.layer} ${J[e.color]}`,
				children: [
					/* @__PURE__ */ R("span", {
						className: J.layerName,
						children: e.name
					}),
					/* @__PURE__ */ R("span", {
						className: J.top,
						children: r(e.keys[0])
					}),
					/* @__PURE__ */ R("span", {
						className: J.right,
						children: r(e.keys[1])
					}),
					/* @__PURE__ */ R("span", {
						className: J.bottom,
						children: r(e.keys[2])
					}),
					/* @__PURE__ */ R("span", {
						className: J.left,
						children: r(e.keys[3])
					}),
					e.name === "padding" && /* @__PURE__ */ R("div", {
						className: J.content,
						children: /* @__PURE__ */ z("span", {
							className: J.contentSize,
							children: [
								eo(n, "width"),
								" × ",
								eo(n, "height")
							]
						})
					})
				]
			}, e.name))
		})
	});
}, io = n(({ value: e, initialVal: t, onValueChange: n, noCard: r, visualSizeDom: a }, c) => {
	let { t: f } = Dt(), [p, m] = d(localStorage.getItem("CHAMN_STYLE_EDITOR_MODE") || "VISUAL"), _ = u(null), y = u(null), x = u(null), S = u(null), C = u(null), w = u(null), T = u(null), E = u(null);
	o(() => {
		localStorage.setItem("CHAMN_STYLE_EDITOR_MODE", p);
	}, [p]);
	let D = l(() => [
		_,
		y,
		x,
		S,
		C,
		w,
		T
	], [
		_,
		y,
		x,
		S,
		C,
		w,
		T
	]), O = u(null), k = i((e) => {
		if (e) {
			if (O.current = e, p === "CODE") {
				E.current?.setValue(e);
				return;
			}
			D.forEach((t) => {
				setTimeout(() => {
					t.current?.setValue(e);
				});
			});
		}
	}, [D, p]), A = i((e) => {
		let t = {
			...O.current || {},
			...e
		};
		O.current = t;
		let r = ut(t, (e) => ct(e) || e === "");
		n?.(r);
	}, [n]);
	o(() => {
		k(O.current);
	}, [p, k]), s(c, () => ({
		setValue: k,
		setEmptyValue: () => k({})
	}), [k]);
	let j = l(() => [
		{
			key: "dimension",
			label: /* @__PURE__ */ z("span", { children: [
				"Dimension",
				" ",
				/* @__PURE__ */ R(N, {
					title: f("style.dimension.mediaOverride"),
					children: /* @__PURE__ */ R(Se, {})
				})
			] }),
			children: /* @__PURE__ */ R(Oa, {
				ref: _,
				initialValue: t,
				value: e,
				onChange: A
			})
		},
		{
			key: "margin",
			label: "Margin",
			children: /* @__PURE__ */ R(Ma, {
				prefix: "margin",
				ref: y,
				initialValue: t,
				value: e,
				onChange: A
			})
		},
		{
			key: "padding",
			label: "Padding",
			children: /* @__PURE__ */ R(Ma, {
				ref: x,
				initialValue: t,
				prefix: "padding",
				value: e,
				onChange: A
			})
		},
		{
			key: "background",
			label: "Background",
			children: /* @__PURE__ */ R(Ka, {
				ref: C,
				value: e,
				initialValue: t,
				onChange: A
			})
		},
		{
			key: "font",
			label: "Font",
			children: /* @__PURE__ */ R(za, {
				ref: T,
				initialValue: t,
				value: e,
				onChange: A
			})
		},
		{
			key: "border",
			label: "Border",
			children: /* @__PURE__ */ R(Ua, {
				ref: S,
				initialValue: t,
				onChange: A
			})
		},
		{
			key: "shadow",
			label: "Shadow",
			children: /* @__PURE__ */ R(Ja, {
				ref: w,
				initialValue: t,
				value: e,
				onChange: A
			})
		}
	], [
		t,
		A,
		f,
		e
	]), ee = /* @__PURE__ */ z(L, { children: [p === "CODE" && /* @__PURE__ */ R(Qa, {
		onValueChange: (e) => {
			O.current = e, n?.(e);
		},
		ref: E
	}), p !== "CODE" && /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(ro, {
		value: O.current || e,
		dom: a
	}), /* @__PURE__ */ R(v, {
		className: q.styleUIPanel,
		items: j,
		bordered: !1,
		defaultActiveKey: [
			"dimension",
			"background",
			"padding",
			"margin"
		],
		onChange: async () => {
			await H(), k(O.current);
		}
	})] })] });
	return /* @__PURE__ */ z(b, {
		theme: { token: { borderRadius: 2 } },
		children: [r && ee, !r && /* @__PURE__ */ R(g, {
			size: "small",
			type: "inner",
			title: /* @__PURE__ */ R("span", {
				style: { fontSize: "12px" },
				children: "Style"
			}),
			extra: /* @__PURE__ */ z(h, {
				type: "text",
				size: "small",
				onClick: () => {
					m((e) => e === "CODE" ? "VISUAL" : "CODE");
				},
				children: [p === "VISUAL" && /* @__PURE__ */ R(Cn, { size: 16 }), p !== "VISUAL" && /* @__PURE__ */ R(bn, { size: 16 })]
			}),
			style: {
				marginBottom: "10px",
				borderRadius: "8px"
			},
			children: ee
		})]
	});
}), ao = ({ value: e, setterContext: t, initialValue: n, ...r }) => {
	let a = u(null), s = t.nodeModel, [c, l] = d(null), f = u(), p = (() => {
		let { normalProperty: e } = zn(s.value.style || []);
		return Nn(e);
	})();
	o(() => {
		let e = !1, n, r = async () => {
			let i = (await t.pluginCtx.pluginManager.get("Designer"))?.export.getComponentInstances(s.id)?.[0]?.getDom?.();
			if (!e) {
				if (i) {
					l(i);
					return;
				}
				n = window.setTimeout(r, 50);
			}
		};
		return r(), () => {
			e = !0, n && window.clearTimeout(n), l(null);
		};
	}, [s, t.pluginCtx.pluginManager]);
	let m = i(() => {
		f.current = s;
		let { normalProperty: e } = zn(s.value.style || []);
		a.current?.setValue(Nn(e) || {});
	}, [s]);
	return o(() => (m(), s.emitter.on("onNodeChange", m), s.emitter.on("onReloadPage", m), () => {
		s.emitter.off("onNodeChange", m), s.emitter.off("onReloadPage", m);
	}), [
		s.emitter,
		s.id,
		m
	]), /* @__PURE__ */ R(io, {
		...r,
		initialVal: p,
		visualSizeDom: c,
		ref: a,
		onValueChange: (e) => {
			let t = Pn(e), { expressionProperty: n } = zn(s.value.style || []), r = [...t, ...n];
			st(s.value.style, r) || (s.value.style = r, s.updateValue());
		}
	});
}, oo = {
	_null_: null,
	_undefined_: void 0
}, so = ({ onValueChange: e, setterContext: t, initialValue: n, emptyValue: r, hiddenDefaultOption: i, ...a }) => {
	let s = l(() => {
		let e = [{
			label: "Undefined",
			value: "_undefined_"
		}, {
			label: "Null",
			value: "_null_"
		}];
		if (r) {
			if (i) return [{
				label: r,
				value: r
			}];
			e.push({
				label: r,
				value: r
			});
		}
		return e;
	}, [r, i]), c = l(() => {
		let e = n || a.value;
		return e === void 0 ? "_undefined_" : e === null ? "_null_" : e || "_undefined_";
	}, [n, a.value]);
	return o(() => {
		e?.(r ?? void 0);
	}, []), /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 6 } },
		children: /* @__PURE__ */ R(O.Group, {
			block: !0,
			options: s,
			defaultValue: n,
			optionType: "button",
			size: "small",
			...a,
			value: c,
			onChange: (t) => {
				let n = t.target.value;
				["_null_", "_undefined_"].includes(n) && (n = oo[n]), e?.(n);
			}
		})
	});
};
so.setterName = "空值设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/index.ts
var co = {
	FastLayoutSetter: ao,
	StringSetter: Pi,
	ArraySetter: Ki,
	ShapeSetter: qi,
	NumberSetter: Fi,
	ExpressionSetter: $i,
	BooleanSetter: ea,
	SelectSetter: ta,
	JSONSetter: oa,
	FunctionSetter: sa,
	TextAreaSetter: ca,
	CSSValueSetter: pa,
	ColorSetter: ma,
	SliderSetter: _a,
	AntDColorSetter: ga,
	RadioGroupSetter: va,
	CSSSizeSetter: wa,
	EmptyValueSetter: so
}, lo = {
	fieldBox: "_fieldBox_y8dlk_3",
	label: "_label_y8dlk_13",
	tipsLabel: "_tipsLabel_y8dlk_27",
	content: "_content_y8dlk_34",
	error: "_error_y8dlk_39",
	errorTipIcon: "_errorTipIcon_y8dlk_45"
}, Y = (t) => {
	let { children: n, label: i, tips: a, name: s, hiddenLabel: c } = t, [l, u] = d({
		isPass: !0,
		errorMsg: ""
	}), f = i, { formState: m, updateContext: h, updateConditionConfig: g } = e.useContext(ki);
	if (o(() => {
		t.condition && g(s, t.condition);
	}, [
		s,
		t.condition,
		g
	]), o(() => {
		let e = (t.condition ?? (() => !0))(m);
		t.onConditionValueChange?.(e);
	}, [m, t]), a) {
		let e = a;
		typeof a == "function" && (e = a()), f = /* @__PURE__ */ R(N, {
			title: /* @__PURE__ */ R("span", {
				style: {
					color: "rgba(255,255,255,0.9",
					fontSize: "12px"
				},
				children: e
			}),
			color: "rgba(50,50,50,0.8)",
			children: /* @__PURE__ */ R("span", {
				className: lo.tipsLabel,
				children: i
			})
		});
	}
	let _ = n;
	if (r(n)) {
		let r = { [t.valueChangeEventName ?? "onValueChange"]: async (e) => {
			let n = e;
			t.formatEventValue && (n = t.formatEventValue(e));
			let r = t.rules || [], i = await uo(t.name, n, r);
			i.isPass ? u({
				isPass: !0,
				errorMsg: ""
			}) : u(i), h({
				...m,
				[s]: n
			}, [s]);
		} };
		r.value = m[s], _ = e.cloneElement(n, r);
	}
	return (t.condition ?? (() => !0))(m) ? t.noStyle ? /* @__PURE__ */ R(L, { children: _ }) : /* @__PURE__ */ z("div", {
		className: P([lo.fieldBox, !l.isPass && lo.error]),
		style: { alignItems: t.labelAlign ?? "center" },
		children: [
			c !== !0 && /* @__PURE__ */ R("div", {
				className: lo.label,
				style: { width: t.labelWidth ?? "60px" },
				children: f
			}),
			/* @__PURE__ */ R("div", {
				className: lo.content,
				children: _
			}),
			!l.isPass && /* @__PURE__ */ R(D, {
				content: /* @__PURE__ */ R(p, {
					message: l.errorMsg,
					type: "error"
				}),
				children: /* @__PURE__ */ R(ke, { className: lo.errorTipIcon })
			})
		]
	}) : null;
}, uo = async (e, t, n = []) => {
	let r = !0, i = "";
	for (let a = 0; a < n.length; a++) {
		if (n[a].required && !t) {
			r = !1, i = `${e} is required.`;
			break;
		}
		if (n[a].validator) try {
			if (!await n[a].validator?.(t)) {
				r = !1, i = n[a]?.msg || `${e} is illegal `;
				break;
			}
		} catch (e) {
			r = !1, i = `${String(e)}`;
			break;
		}
	}
	return {
		isPass: r,
		errorMsg: i
	};
}, fo = {
	switchBtn: "_switchBtn_1lusr_2",
	shapeFieldBox: "_shapeFieldBox_1lusr_8",
	collapseHeader: "_collapseHeader_1lusr_9"
}, po = e.createContext({
	defaultSetterConfig: {},
	onSetterChange: () => {},
	customSetterMap: {}
}), mo = class extends e.Component {
	state = { hasError: !1 };
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidCatch(e, t) {
		console.error(`Setter render failed${this.props.setterName ? `: ${this.props.setterName}` : ""}`, e, t);
	}
	render() {
		return this.state.hasError ? /* @__PURE__ */ z("div", {
			style: {
				backgroundColor: "whitesmoke",
				margin: "5px 0",
				padding: "5px",
				borderRadius: "2px",
				color: "gray",
				fontSize: "12px"
			},
			children: [this.props.setterName || "Setter", " render failed."]
		}) : this.props.children;
	}
}, ho = ({ setters: e, keyPaths: t, currentSetter: n, setCurrentSetter: r, customSetterMap: i, ...s }) => {
	let { customSetterMap: c } = a(ki), { defaultSetterConfig: l } = a(po), u = {
		...co,
		...i || {},
		...c
	};
	o(() => {
		let n = l[t.join(".")]?.setter || "";
		r(e.find((e) => e.componentName === n) || zi(s.value, e) || e[0]);
	}, []);
	let d = null;
	return n?.componentName && (d = u[n?.componentName] || n.component), d ||= function() {
		return /* @__PURE__ */ R("div", {
			style: {
				backgroundColor: "whitesmoke",
				margin: "5px 0",
				padding: "5px",
				borderRadius: "2px",
				color: "gray"
			},
			children: `${n?.componentName} is not found.`
		});
	}, /* @__PURE__ */ R(mo, {
		setterName: n?.componentName,
		children: /* @__PURE__ */ R(d, { ...s })
	}, n?.componentName);
}, go = (e) => e == null || e === "" ? !1 : Array.isArray(e) ? e.length > 0 : typeof e != "object" || Object.keys(e).length > 0, _o = ({ setters: e, keyPaths: t, condition: n, defaultCollapseOpen: r, readOnly: i = !1, useField: o = !0, ...s }) => {
	let [c, u] = d(!0), { customSetterMap: f, formState: p } = a(ki), { onSetterChange: m, defaultSetterConfig: h, formRef: g, pluginCtx: _, nodeId: y } = a(po), b = {
		...co,
		...f
	}, x = l(() => i ? e : [...e, { componentName: Ge.EMPTY_VALUE_SETTER }], [e, i]), [C, w] = d(() => {
		let e = h[t.join(".")]?.setter || "";
		return x.find((t) => t.componentName === e) || x[0];
	}), T = x.map((e) => {
		let t = e?.componentName || "", n = b[t];
		return {
			key: e.componentName,
			label: n?.setterName || e.componentName
		};
	}), E = l(() => i || T.length === 1 ? null : /* @__PURE__ */ R("div", {
		className: fo.switchBtn,
		onClick: (e) => {
			e.preventDefault(), e.stopPropagation();
		},
		children: /* @__PURE__ */ R(S, {
			trigger: ["click"],
			menu: {
				selectable: !0,
				items: T,
				onClick: ({ key: e }) => {
					let n = x.find((t) => t.componentName === e);
					n && (w(n), m?.(t, n.componentName));
				},
				defaultSelectedKeys: [C?.componentName || ""]
			},
			children: /* @__PURE__ */ R(Ne, {})
		})
	}), [
		T,
		C?.componentName,
		x,
		m,
		t,
		i
	]), D = l(() => {
		let e = {
			...C?.props || {},
			initialValue: C?.initialValue
		}, t = x.find((e) => e.componentName === C?.componentName);
		return t && (e = {
			...e,
			...t.props
		}), e;
	}, [x, C]), [O, k] = d([]), A = null, j = C?.hiddenLabel === !0, ee = C?.labelWidth, M = C?.labelAlign || "center", te = C?.props?.collapse, ne = ["ArraySetter", "ShapeSetter"].includes(C?.componentName), re = l(() => ({
		formRef: g,
		pluginCtx: _,
		keyPaths: [...t],
		label: s.label,
		setCollapseHeaderExt: ne ? k : void 0,
		nodeModel: _?.pageModel.getNode(y)
	}), [
		g,
		t,
		y,
		_,
		s.label,
		ne
	]), N = l(() => {
		let e = { ...s.customSetterMap || {} };
		return o === !1 ? /* @__PURE__ */ R(ho, {
			setters: x,
			keyPaths: t,
			currentSetter: C,
			setCurrentSetter: w,
			...s,
			...D,
			customSetterMap: e,
			setterContext: re
		}) : /* @__PURE__ */ R(Y, {
			labelWidth: ee,
			labelAlign: M,
			hiddenLabel: j,
			condition: n,
			noStyle: !!ne,
			onConditionValueChange: (e) => {
				u(e);
			},
			...s,
			children: /* @__PURE__ */ R(ho, {
				setters: x,
				keyPaths: t,
				currentSetter: C,
				setCurrentSetter: w,
				...D,
				customSetterMap: e,
				setterContext: re
			})
		});
	}, [
		n,
		C,
		j,
		t,
		M,
		ee,
		s,
		re,
		D,
		x,
		ne,
		o
	]), ie = l(function() {
		let e = typeof te == "object" ? te : {};
		return (n) => /* @__PURE__ */ R(v, {
			bordered: !1,
			...e,
			style: {
				marginBottom: "10px",
				flex: 1
			},
			defaultActiveKey: [r ?? e.open ?? go(p[t.join(".")]) ? s.name : ""],
			items: [{
				key: s.name,
				label: /* @__PURE__ */ z("div", {
					className: fo.collapseHeader,
					children: [
						/* @__PURE__ */ R("span", {
							style: { flex: 1 },
							children: s.label
						}),
						n,
						E
					]
				}),
				children: N
			}]
		});
	}, [
		te,
		r,
		p,
		t,
		s.name,
		s.label,
		E,
		N
	]);
	return A = ["ArraySetter"].includes(C?.componentName || "") ? ie(O) : ["ShapeSetter"].includes(C?.componentName || "") ? /* @__PURE__ */ z("div", {
		className: fo.shapeFieldBox,
		children: [
			s.prefix ?? null,
			C?.props?.collapse === !1 && /* @__PURE__ */ R("div", {
				style: { width: "100%" },
				children: N
			}),
			te !== !1 && ie(),
			s.suffix ?? null
		]
	}) : /* @__PURE__ */ z("div", {
		style: {
			display: "flex",
			alignItems: M,
			paddingBottom: "8px"
		},
		children: [
			s.prefix ?? null,
			N,
			E,
			s.suffix ?? null
		]
	}), /* @__PURE__ */ R("div", {
		style: { display: c ? "block" : "none" },
		children: A
	});
}, vo = { CFromRenderBox: "_CFromRenderBox_13lda_2" }, yo = e.forwardRef((e, t) => {
	let { properties: n, initialValue: r, onValueChange: i, onSetterChange: a, defaultSetterConfig: o, pluginCtx: s, customSetterMap: c } = e, l = n;
	return /* @__PURE__ */ R(po.Provider, {
		value: {
			defaultSetterConfig: o,
			customSetterMap: c,
			onSetterChange: a,
			formRef: t,
			pluginCtx: s,
			nodeId: e.nodeId
		},
		children: /* @__PURE__ */ R(b, {
			theme: { token: { borderRadius: 4 } },
			children: /* @__PURE__ */ R("div", {
				className: vo.CFromRenderBox,
				children: /* @__PURE__ */ R(Ni, {
					ref: t,
					name: "root-form",
					initialValue: r,
					customSetterMap: c,
					onValueChange: (e) => {
						i?.(e);
					},
					children: l.map((e) => {
						if (et(e)) console.log("Current not Support type config for props, wait future....");
						else {
							let t = qe(e.title), n = Je(e.title) || e?.description, r = Ii(e.setters), i = [e.name];
							return /* @__PURE__ */ R(mo, {
								setterName: e.name,
								children: /* @__PURE__ */ R(_o, {
									condition: e.condition,
									keyPaths: i,
									setters: r,
									label: t,
									name: e.name || "",
									tips: n,
									readOnly: e.readOnly
								})
							}, e.name);
						}
					})
				})
			})
		})
	});
}), bo = (e, t) => {
	let n = (t) => {
		for (let r of t) {
			if (r.key === e) return r;
			if (r.children?.length) {
				let e = n(r.children);
				if (e) return e;
			}
		}
		return null;
	};
	return n(t);
}, xo = (e) => {
	let { open: t, onCancel: n, onOk: r, pageModel: i, value: a } = e, o = u(null), s = l(() => {
		if (!i) return;
		let e = si(i?.export(), i);
		return fi(e, (e) => (e.sourceData = {
			title: e.title,
			value: e.value
		}, e.value = e.key, e.title = /* @__PURE__ */ R("div", {
			style: {
				flexWrap: "nowrap",
				display: "flex",
				width: "150px"
			},
			children: e.title
		}), !1)), e;
	}, [i]);
	return /* @__PURE__ */ R(E, {
		open: t,
		onCancel: n,
		title: "选择节点",
		onOk: () => r({
			nodeId: a || "",
			title: ""
		}),
		children: /* @__PURE__ */ R("div", {
			ref: o,
			style: { width: "100%" },
			children: /* @__PURE__ */ R(ie, {
				virtual: !1,
				showSearch: !0,
				style: { width: "100%" },
				value: a,
				allowClear: !0,
				onClear: () => {
					r({
						nodeId: "",
						title: ""
					});
				},
				filterTreeNode: (e, t) => t.sourceData?.title.toLowerCase().indexOf(e.toLowerCase()) > -1,
				getPopupContainer: () => o.current,
				treeDefaultExpandAll: !0,
				onChange: (e) => {
					let t = bo(e, s ?? []);
					r({
						nodeId: e,
						title: t?.sourceData?.title
					});
				},
				treeData: s
			})
		})
	});
}, So = (e) => {
	let [t, n] = d(!1), [r, i] = d(e.value), a = l(() => {
		let t = e.pageModel.getNode(r?.nodeId || e.value);
		return t && (t.value.title || t.material?.value.title || r?.title) || "";
	}, [
		e.pageModel,
		e?.value,
		r?.nodeId,
		r?.title
	]);
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R(h, {
		style: { width: "200px" },
		onClick: () => n(!0),
		children: a ?? "选择节点"
	}), /* @__PURE__ */ R(xo, {
		open: t,
		onCancel: () => n(!1),
		onOk: (t) => {
			e.onChange?.(t), i(t), n(!1);
		},
		pageModel: e.pageModel,
		value: r?.nodeId || e.value
	})] });
}, Co = (e) => /* @__PURE__ */ R("div", { children: /* @__PURE__ */ z(M, { children: [/* @__PURE__ */ R(So, {
	pageModel: e.pageModel,
	value: e.value,
	onChange: (t) => {
		e.onChange?.({
			nodeId: t.nodeId,
			keyPath: e.value?.keyPath || ""
		});
	}
}), /* @__PURE__ */ R(w, {
	style: { width: 250 },
	value: e.value?.keyPath,
	onChange: (t) => {
		let { value: n } = t.target;
		e.onChange?.({
			nodeId: e.value?.nodeId || "",
			keyPath: String(n)
		});
	},
	placeholder: "variable name. support '.'"
})] }) }), wo = { line: "_line_mvkqx_2" };
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ActionFlowSetter/node/AssignValueNode/util.ts
function To(e) {
	if (!/^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(e)) return !1;
	try {
		return Function(`let ${e};`), !0;
	} catch {
		return !1;
	}
}
var Eo = {
	l: "_l_1lpc6_2",
	r: "_r_1lpc6_11",
	b: "_b_1lpc6_20",
	dragBox: "_dragBox_1lpc6_29",
	selectStatus: "_selectStatus_1lpc6_36"
}, Do = [
	{
		key: F.ASSIGN_VALUE,
		name: "赋值/创建变量",
		getInitData: () => ({
			id: I(),
			type: F.ASSIGN_VALUE,
			valueType: Le.STATE,
			currentValue: "",
			targetValueName: ""
		})
	},
	{
		key: F.JUMP_LINK,
		name: "页面跳转",
		getInitData: () => ({
			id: I(),
			type: F.JUMP_LINK,
			link: ""
		})
	},
	{
		key: F.REQUEST_API,
		name: "请求数据",
		getInitData: () => {
			let e = I();
			return {
				id: e,
				type: F.REQUEST_API,
				apiPath: "",
				method: "GET",
				header: {},
				query: {},
				responseVarName: `responseData_${e}`,
				afterSuccessResponse: [],
				afterFailedResponse: [{
					id: I(),
					type: F.RUN_CODE,
					value: "console.error(\"API request failed:\", $$response)"
				}]
			};
		}
	},
	{
		key: F.CALL_NODE_METHOD,
		name: "调用组件方法",
		getInitData: () => ({
			id: I(),
			type: F.CALL_NODE_METHOD,
			nodeId: "",
			methodName: "",
			args: [],
			returnVarName: ""
		})
	},
	{
		key: F.RUN_CODE,
		name: "运行代码",
		getInitData: () => {
			let e = I();
			return {
				id: e,
				type: F.RUN_CODE,
				name: `run_code_${e}`,
				value: "console.log('hello world');"
			};
		}
	}
], Oo = (e) => {
	let { title: t = "Next Step" } = e, [n, r] = d(!1), i = (e) => {
		r(e);
	}, a = Do.map((t) => /* @__PURE__ */ R("div", {
		onClick: () => {
			r(!1), e.onNewNodeAdd?.(t.getInitData());
		},
		style: {
			padding: "10px 20px",
			border: "1px solid #c3c3c3b8",
			borderRadius: "4px",
			textAlign: "center",
			fontSize: "12px",
			cursor: "pointer"
		},
		children: t.name
	}, t.key));
	return e.disabled ? e.children : /* @__PURE__ */ R(D, {
		onOpenChange: i,
		open: n,
		trigger: "hover",
		content: /* @__PURE__ */ R("div", {
			style: {
				display: "flex",
				flexWrap: "wrap",
				width: "300px",
				gap: "8px",
				justifyContent: "space-between"
			},
			children: a.map((e) => /* @__PURE__ */ R("div", {
				style: { flex: "0 0 calc(50% - 4px)" },
				children: e
			}, e.key))
		}),
		title: t,
		children: e.children
	});
}, ko = (e) => /* @__PURE__ */ R(Ft, {
	type: "target",
	id: Ei,
	position: Lt.Top,
	...e
}), Ao = (e) => /* @__PURE__ */ R(Ft, {
	type: "source",
	position: Lt.Bottom,
	id: Di,
	...e
}), jo = ({ nodeProps: e, customHandle: t, handleNewNodeAdd: n, useCardStyle: r, outputHandle: i, inputHandle: a, ...o }) => {
	let { data: s, isConnectable: c, selected: l } = e, u = Ut(), d = is(s, Di), f = (e) => {
		let t = u.getNode(String(s.id));
		if (!t) {
			console.error(`Not found node by id ${s.id}`);
			return;
		}
		let { newEdge: n, newNode: r } = as(t, e);
		u.addNodes(r), u.addEdges(n);
	}, p = /* @__PURE__ */ z(L, { children: [a !== !1 && /* @__PURE__ */ R(ko, { isConnectable: c }), i !== !1 && /* @__PURE__ */ R(Oo, {
		style: {
			position: "absolute",
			left: "50%",
			bottom: "0"
		},
		onNewNodeAdd: (e) => {
			t || (n ? n(e) : f(e));
		},
		disabled: d,
		children: /* @__PURE__ */ R(Ao, {
			isConnectable: c,
			style: {
				width: "10px",
				height: "10px"
			}
		})
	})] });
	return t && (p = t), r === !1 ? /* @__PURE__ */ z("div", {
		className: P([l ? Eo.selectStatus : ""]),
		children: [/* @__PURE__ */ R("div", {
			className: Ti,
			children: o.children
		}), p]
	}) : /* @__PURE__ */ z(g, {
		...o,
		classNames: { header: Ti },
		className: P([l ? Eo.selectStatus : ""]),
		styles: { body: { cursor: "default" } },
		extra: /* @__PURE__ */ z("div", {
			style: { display: "flex" },
			children: [o.extra, /* @__PURE__ */ R("div", {
				className: Eo.dragBox,
				children: /* @__PURE__ */ R(xe, {})
			})]
		}),
		children: [
			o.children,
			/* @__PURE__ */ R("div", { className: P([Ti, Eo.l]) }),
			/* @__PURE__ */ R("div", { className: P([Ti, Eo.r]) }),
			/* @__PURE__ */ R("div", { className: P([Ti, Eo.b]) }),
			p
		]
	});
}, Mo = t({
	pluginCtx: null,
	pageModel: null,
	onDataChange: () => {},
	nodeModel: null
}), No = () => {
	let e = a(Mo);
	if (!e) throw Error("useActionFlow must be used within ActionFlowProvider");
	return e;
}, Po = {
	fieldBox: "_fieldBox_1ofb2_2",
	switchBtn: "_switchBtn_1ofb2_8"
}, Fo = (e) => {
	let { setterList: t, defaultSetterName: n, ...r } = e, i = l(() => Ii(t), [t]), { onSetterChange: o, defaultSetterConfig: s, pluginCtx: c, nodeId: u, customSetterMap: f } = a(po), p = [e.name], [m, h] = d(() => {
		let e = s[p.join(".")]?.setter || n || "";
		return [...i].find((t) => t.componentName === e) || i[0];
	}), g = i.map((e) => {
		let t = {}[e?.componentName || ""];
		return {
			key: e.componentName,
			label: t?.setterName || e.componentName
		};
	}), _ = /* @__PURE__ */ R("div", {
		onClick: (e) => {
			e.preventDefault(), e.stopPropagation();
		},
		className: Po.switchBtn,
		children: /* @__PURE__ */ R(S, {
			trigger: ["click"],
			menu: {
				selectable: !0,
				items: g,
				onClick: ({ key: t }) => {
					let n = i.find((e) => e.componentName === t);
					n && (h(n), o?.(p, n.componentName), e.onSetterChange?.(n.componentName));
				},
				defaultSelectedKeys: [m?.componentName || ""]
			},
			children: /* @__PURE__ */ R(Ne, {})
		})
	});
	g.length === 1 && (_ = null);
	let v = l(() => {
		let e = {
			...m?.props || {},
			initialValue: m?.initialValue
		}, t = i.find((e) => e.componentName === m?.componentName);
		return t && (e = {
			...e,
			...t.props
		}), e;
	}, [i, m]);
	return /* @__PURE__ */ z("div", {
		className: Po.fieldBox,
		style: { alignItems: e.labelAlign ?? "center" },
		children: [/* @__PURE__ */ R(Y, {
			...r,
			children: /* @__PURE__ */ R(ho, {
				...v,
				setters: i,
				keyPaths: p,
				currentSetter: m,
				customSetterMap: f,
				setCurrentSetter: h,
				setterContext: {
					pluginCtx: c,
					keyPaths: [e.name],
					label: e.label,
					nodeModel: c?.pageModel.getNode(u)
				}
			})
		}), _]
	});
}, Io = (e) => {
	let { data: t } = e, { onDataChange: n, pageModel: r, pluginCtx: i, nodeModel: a } = No();
	er(t, Ve, {});
	let s = t[Ve], [c, l] = d(!1), f = u(null), [p, m] = d();
	return o(() => {
		let e = {
			id: t.id,
			type: t.type,
			valueType: t.valueType,
			currentValue: t.currentValue,
			targetValueName: t.targetValueName || ""
		};
		f.current?.setFields(e), m(e), l(!0);
	}, []), /* @__PURE__ */ R(po.Provider, {
		value: {
			defaultSetterConfig: s.defaultSetterMap || {},
			formRef: f,
			onSetterChange: (e, t) => {
				s.defaultSetterMap ||= {}, s.defaultSetterMap[e.join(".")] = {
					name: e.join("."),
					setter: t
				};
			},
			pluginCtx: i,
			nodeId: a?.id,
			customSetterMap: {}
		},
		children: /* @__PURE__ */ R("div", {
			style: {
				minHeight: "80px",
				minWidth: "100px"
			},
			children: /* @__PURE__ */ R(jo, {
				title: "Assign Value",
				nodeProps: e,
				children: /* @__PURE__ */ R(Ni, {
					ref: f,
					name: "jump Link",
					customSetterMap: co,
					onValueChange: (e) => {
						Object.assign(t, e), m(e), n();
					},
					children: c && /* @__PURE__ */ z(L, { children: [
						/* @__PURE__ */ R("div", {
							className: wo.line,
							children: /* @__PURE__ */ R(Y, {
								name: "valueType",
								label: "Var Type",
								valueChangeEventName: "onChange",
								formatEventValue: ({ target: { value: e } }) => e,
								children: /* @__PURE__ */ R(O.Group, {
									optionType: "button",
									buttonStyle: "solid",
									options: [{
										label: "Memory",
										value: Le.MEMORY
									}, {
										label: "Node",
										value: Le.STATE
									}]
								})
							})
						}),
						/* @__PURE__ */ z("div", {
							className: wo.line,
							children: [p?.valueType === "STATE" && /* @__PURE__ */ R(Y, {
								name: "targetValueName",
								label: "Var Name",
								valueChangeEventName: "onChange",
								children: /* @__PURE__ */ R(Co, { pageModel: r })
							}), p?.valueType === "MEMORY" && /* @__PURE__ */ R(Fo, {
								name: "targetValueName",
								label: "Var Name",
								labelWidth: "auto",
								labelAlign: "start",
								tips: "变量名必须以字母（a-z、A-Z）、下划线（_）或美元符号（$）开头。后续字符可以是字母、数字（0-9）、下划线或美元符号。变量名不能是保留关键字（例如 if、while 等）",
								setterList: [{
									componentName: "TextAreaSetter",
									props: { valueValidator: To }
								}]
							})]
						}),
						/* @__PURE__ */ R("div", {
							className: wo.line,
							style: { minWidth: "450px" },
							children: /* @__PURE__ */ R(Fo, {
								name: "currentValue",
								label: "Value",
								labelWidth: "60px",
								labelAlign: "start",
								setterList: rs
							})
						})
					] })
				})
			})
		})
	});
}, Lo = (e) => /* @__PURE__ */ R(jo, {
	nodeProps: e,
	useCardStyle: !1,
	inputHandle: !1,
	children: /* @__PURE__ */ R("div", {
		style: {
			minWidth: "100px",
			padding: "10px 20px",
			border: "1px solid #1a192b",
			borderRadius: "4px",
			textAlign: "center"
		},
		children: "Start"
	})
}), Ro = { line: "_line_mvkqx_2" };
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/ActionFlowSetter/node/CallNodeMethodNode/util.ts
function zo(e) {
	if (!/^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(e)) return !1;
	try {
		return Function(`let ${e};`), !0;
	} catch {
		return !1;
	}
}
var Bo = "args.", Vo = (e, t) => Qe(e) && (e?.material?.value.methods || []).find((e) => e.name === t)?.params?.map((e, t) => ({
	name: `${Bo}${t}`,
	title: {
		label: e.name || `arg[${t}]`,
		tip: e.description
	},
	valueType: "string",
	setters: rs
})) || [], Ho = (e) => Object.keys(e).map((e) => parseInt(e.replace(Bo, ""))).sort().map((t) => e[`${Bo}${t}`]), Uo = (e) => {
	let t = {};
	return e.forEach((e, n) => {
		t[`${Bo}${n}`] = e;
	}), t;
}, Wo = (e) => {
	let { data: t } = e, { pageModel: n, onDataChange: r, pluginCtx: i, nodeModel: a } = No();
	er(t, Ve, {});
	let s = t[Ve], c = u(null), [f, p] = d();
	o(() => {
		let e = {
			id: t.id || "",
			type: t.type,
			nodeId: t.nodeId,
			methodName: t.methodName,
			args: t.args,
			returnVarName: t.returnVarName
		};
		c.current?.setFields(e), p(e);
	}, []);
	let m = l(() => n.getNode(t.nodeId)?.material?.value.methods || [], [t.nodeId, n]), h = l(() => m?.map((e) => ({
		value: e.name,
		label: e.title
	})), [m]), g = l(() => Vo(n.getNode(f?.nodeId), f?.methodName || ""), [
		n,
		f?.nodeId,
		f?.methodName
	]), _ = (e, t) => {
		s.defaultSetterMap ||= {}, s.defaultSetterMap[e.join(".")] = {
			name: e.join("."),
			setter: t
		};
	};
	return /* @__PURE__ */ R(po.Provider, {
		value: {
			defaultSetterConfig: s.defaultSetterMap || {},
			formRef: c,
			onSetterChange: _,
			customSetterMap: { ...co }
		},
		children: /* @__PURE__ */ R("div", {
			style: {
				minHeight: "80px",
				minWidth: "100px"
			},
			children: /* @__PURE__ */ R(jo, {
				title: "Call Node Method",
				nodeProps: e,
				children: /* @__PURE__ */ z(Ni, {
					ref: c,
					name: "Call Node Method",
					customSetterMap: co,
					onValueChange: (e, n) => {
						n?.includes("nodeId") && (e = {
							...e,
							methodName: "",
							args: []
						}, setTimeout(() => {
							c.current?.setFields({
								...f,
								...e
							});
						})), Object.assign(t, e), p(e), r();
					},
					children: [
						/* @__PURE__ */ R("div", {
							className: Ro.line,
							children: /* @__PURE__ */ R(Y, {
								label: "组件",
								name: "nodeId",
								valueChangeEventName: "onChange",
								formatEventValue: (e) => e.nodeId,
								children: /* @__PURE__ */ R(So, { pageModel: n })
							})
						}),
						/* @__PURE__ */ R("div", {
							className: Ro.line,
							children: /* @__PURE__ */ R(Y, {
								name: "methodName",
								label: "方法",
								valueChangeEventName: "onChange",
								children: /* @__PURE__ */ R(j, {
									style: { width: 250 },
									allowClear: !0,
									options: h
								})
							})
						}),
						/* @__PURE__ */ R("div", {
							className: Ro.line,
							children: /* @__PURE__ */ R(Y, {
								name: "args",
								label: "参数",
								labelWidth: "60px",
								labelAlign: "start",
								condition: () => !!g.length,
								noStyle: !0,
								formatEventValue: (e) => Ho(e),
								children: /* @__PURE__ */ R(yo, {
									initialValue: Uo(t.args || []),
									pluginCtx: i,
									nodeId: a?.id,
									properties: g,
									onSetterChange: _,
									defaultSetterConfig: s.defaultSetterMap || {}
								})
							})
						}),
						/* @__PURE__ */ R("div", {
							className: Ro.line,
							children: /* @__PURE__ */ R(Y, {
								name: "returnVarName",
								label: "返回值变量名",
								labelWidth: "80px",
								tips: "变量名必须以字母（a-z、A-Z）、下划线（_）或美元符号（$）开头。后续字符可以是字母、数字（0-9）、下划线或美元符号。变量名不能是保留关键字（例如 if、while 等）",
								rules: [{ validator: async (e) => e === "" || zo(e) }],
								valueChangeEventName: "onChange",
								formatEventValue: (e) => e.target.value,
								children: /* @__PURE__ */ R(w, { allowClear: !0 })
							})
						})
					]
				})
			})
		})
	});
}, Go = (e) => {
	let { data: t } = e, { onDataChange: n } = No(), r = u(null), [i, a] = d(!1);
	o(() => {
		r.current?.setFields({ link: t.link }), a(!0);
	}, []);
	let s = l(() => Xe(t.link) ? "FunctionSetter" : Ye(t.link) ? "ExpressionSetter" : "TextAreaSetter", [t.link]);
	return /* @__PURE__ */ R("div", {
		style: {
			minHeight: "80px",
			minWidth: "100px"
		},
		children: /* @__PURE__ */ R(jo, {
			title: "Jump Link",
			nodeProps: e,
			children: /* @__PURE__ */ R(Ni, {
				ref: r,
				name: "jump Link",
				customSetterMap: co,
				onValueChange: (e) => {
					Object.assign(t, e), n();
				},
				children: i && /* @__PURE__ */ R(L, { children: /* @__PURE__ */ R(Fo, {
					name: "link",
					label: "link",
					labelWidth: "auto",
					labelAlign: "start",
					defaultSetterName: s,
					setterList: rs
				}) })
			})
		})
	});
}, Ko = [{
	componentName: "JSONSetter",
	labelAlign: "start",
	props: {
		mode: "inline",
		lineNumbers: "off",
		editorOptions: {
			lineNumbers: "off",
			lineDecorationsWidth: 0,
			lineNumbersMinChars: 0,
			glyphMargin: !1
		}
	}
}, {
	componentName: "FunctionSetter",
	labelAlign: "start",
	props: {
		mode: "inline",
		minimap: !1,
		containerStyle: {
			paddingTop: "10px",
			width: "470px",
			height: "150px"
		},
		lineNumber: !1
	}
}], qo = [
	{
		value: "GET",
		label: "GET"
	},
	{
		value: "POST",
		label: "POST"
	},
	{
		value: "PUT",
		label: "PUT"
	},
	{
		value: "PATCH",
		label: "PATCH"
	},
	{
		value: "DELETE",
		label: "DELETE"
	}
], Jo = { line: "_line_mvkqx_2" }, Yo = (e) => {
	let { data: t, isConnectable: n } = e, { onDataChange: r, pluginCtx: i } = No(), a = i.config || {}, s = l(() => a.requestAPINode?.customAPIInput ? a.requestAPINode?.customAPIInput : w, [a.requestAPINode?.customAPIInput]), c = Ut();
	er(t, Ve, {});
	let f = t[Ve], p = u(null), [m, h] = d(), g = (e) => c.getEdges().some((n) => n.source === String(t.id) && (n.sourceHandle || "OUTPUT_HANDLE_ID") === e), _ = g(Di), v = g(Oi);
	o(() => {
		let e = {
			id: t.id,
			type: t.type,
			apiPath: t.apiPath,
			body: t.body,
			query: t.query,
			header: t.header,
			method: t.method || "GET",
			responseVarName: t.responseVarName || "",
			afterSuccessResponse: t.afterSuccessResponse || [],
			afterFailedResponse: t.afterFailedResponse || []
		};
		p.current?.setFields(e), h(e);
	}, []);
	let y = l(() => ({
		updateFields: (e) => {
			let t = {
				...m,
				...e
			};
			p.current?.setFields({ ...t }), h(t);
		},
		getFields: () => p.current?.getFieldsValue()
	}), [m]), b = (e, t) => {
		f.defaultSetterMap ||= {}, f.defaultSetterMap[e.join(".")] = {
			name: e.join("."),
			setter: t
		};
	}, x = l(() => [
		{
			key: "header",
			label: "Header"
		},
		{
			key: "query",
			label: "Query"
		},
		{
			key: "body",
			label: "Body"
		}
	].map((e) => ({
		...e,
		disabled: e.key === "body" && m?.method === "GET",
		children: /* @__PURE__ */ R("div", {
			className: Jo.line,
			children: /* @__PURE__ */ R(Fo, {
				name: e.key,
				hiddenLabel: !0,
				labelAlign: "start",
				setterList: Ko
			})
		})
	})), [m]), S = (e, n) => {
		let r = c.getNode(String(t.id));
		if (!r) return;
		let i = 0;
		n !== "OUTPUT_HANDLE_ID" && (i = (r.measured?.width ?? 0) + 150);
		let a = {
			x: r.position.x + i,
			y: r.position.y + (r.measured?.height ?? 0) + 150
		}, o = {
			id: e.id,
			type: e.type,
			position: a,
			dragHandle: `.${Ti}`,
			data: { ...e }
		}, s = {
			id: `${t.id}_${o.id}`,
			source: String(t.id),
			sourceHandle: n,
			target: o.id,
			targetHandle: Ei
		};
		c.addNodes(o), c.addEdges(s), n === "OUTPUT_HANDLE_ID" ? (t.afterSuccessResponse ||= [], t.afterSuccessResponse.push(e)) : (t.afterFailedResponse ||= [], t.afterFailedResponse.push(e));
	};
	return /* @__PURE__ */ R(po.Provider, {
		value: {
			defaultSetterConfig: f.defaultSetterMap || {},
			formRef: p,
			onSetterChange: b,
			customSetterMap: { ...co }
		},
		children: /* @__PURE__ */ R("div", {
			style: {
				minHeight: "80px",
				minWidth: "100px"
			},
			children: /* @__PURE__ */ R(jo, {
				title: "Request Data",
				customHandle: /* @__PURE__ */ z(L, { children: [
					/* @__PURE__ */ R(ko, {
						type: "target",
						isConnectable: n
					}),
					/* @__PURE__ */ R(Oo, {
						style: {
							position: "absolute",
							left: "50%",
							bottom: "0"
						},
						title: "请求成功时",
						onNewNodeAdd: (e) => S(e, Di),
						disabled: _,
						children: /* @__PURE__ */ R(Ao, {
							isConnectable: n,
							style: {
								width: "10px",
								height: "10px",
								background: "#8BC34A"
							}
						})
					}),
					/* @__PURE__ */ R(Oo, {
						title: "请求异常时",
						onNewNodeAdd: (e) => S(e, Oi),
						disabled: v,
						children: /* @__PURE__ */ R(Ao, {
							style: {
								left: "75%",
								bottom: "0",
								width: "10px",
								height: "10px",
								background: "#ff4d4f"
							},
							id: Oi,
							isConnectable: n
						})
					})
				] }),
				nodeProps: e,
				handleNewNodeAdd: () => {},
				children: /* @__PURE__ */ R("div", {
					style: { width: "500px" },
					children: /* @__PURE__ */ z(Ni, {
						name: "requestAPI",
						ref: p,
						customSetterMap: co,
						onValueChange: (e) => {
							h(e), Object.assign(t, e), r();
						},
						children: [
							/* @__PURE__ */ R("div", {
								className: Jo.line,
								children: /* @__PURE__ */ R(Y, {
									label: "API",
									name: "apiPath",
									valueChangeEventName: "onChange",
									formatEventValue: (e) => e.target.value,
									children: /* @__PURE__ */ R(s, { form: y })
								})
							}),
							/* @__PURE__ */ R("div", {
								className: Jo.line,
								children: /* @__PURE__ */ R(Y, {
									label: "请求方法",
									name: "method",
									valueChangeEventName: "onChange",
									children: /* @__PURE__ */ R(j, {
										defaultValue: "GET",
										style: { width: 230 },
										options: qo
									})
								})
							}),
							/* @__PURE__ */ R("div", {
								className: Jo.line,
								children: /* @__PURE__ */ R(Y, {
									label: "返回值变量",
									name: "responseVarName",
									tips: "变量名必须以字母（a-z、A-Z）、下划线（_）或美元符号（$）开头。后续字符可以是字母、数字（0-9）、下划线或美元符号。变量名不能是保留关键字（例如 if、while 等）",
									valueChangeEventName: "onChange",
									formatEventValue: (e) => e.target.value,
									children: /* @__PURE__ */ R(w, {})
								})
							}),
							/* @__PURE__ */ R(ne, {
								defaultActiveKey: m?.method === "POST" ? "body" : "query",
								items: x
							})
						]
					})
				})
			})
		})
	});
}, Xo = (e) => {
	let { data: t } = e;
	er(t, Ve, {});
	let { onDataChange: n, pluginCtx: r, nodeModel: i } = No();
	return /* @__PURE__ */ R("div", {
		style: {
			minHeight: "80px",
			minWidth: "100px"
		},
		children: /* @__PURE__ */ R(jo, {
			title: "Run Code",
			nodeProps: e,
			children: /* @__PURE__ */ R(sa, {
				mode: "inline",
				initialValue: t.value,
				containerStyle: {
					paddingTop: "10px",
					width: "600px",
					height: "300px"
				},
				onValueChange: (e) => {
					t.value = e.value, n();
				},
				setterContext: {
					pluginCtx: r,
					setCollapseHeaderExt: void 0,
					onSetterChange: function() {},
					keyPaths: [],
					label: "",
					nodeModel: i
				}
			})
		})
	});
}, X = /* @__PURE__ */ function(e) {
	return e.START_NODE = "START_NODE", e[e.JUMP_LINK = F.JUMP_LINK] = "JUMP_LINK", e[e.ASSIGN_VALUE = F.ASSIGN_VALUE] = "ASSIGN_VALUE", e[e.CALL_NODE_METHOD = F.CALL_NODE_METHOD] = "CALL_NODE_METHOD", e[e.RUN_CODE = F.RUN_CODE] = "RUN_CODE", e[e.REQUEST_API = F.REQUEST_API] = "REQUEST_API", e;
}({}), Zo = {
	START_NODE: Lo,
	[X.JUMP_LINK]: Go,
	[X.ASSIGN_VALUE]: Io,
	[X.CALL_NODE_METHOD]: Wo,
	[X.RUN_CODE]: Xo,
	[X.REQUEST_API]: Yo
}, Qo = (e, t, n) => {
	let r = new Wt.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
	return r.setGraph({ rankdir: n.direction }), t.forEach((e) => r.setEdge(e.source, e.target)), e.forEach((e) => r.setNode(e.id, {
		...e,
		width: e.measured?.width ?? 0,
		height: e.measured?.height ?? 0
	})), Wt.layout(r), {
		nodes: e.map((e) => {
			let t = r.node(e.id), n = t.x - (e.measured?.width ?? 0) / 2, i = t.y - (e.measured?.height ?? 0) / 2;
			return {
				...e,
				position: {
					x: n,
					y: i
				}
			};
		}),
		edges: t
	};
}, $o = (e) => {
	let t = e.id || I();
	return {
		id: t,
		type: e.type,
		position: {
			x: 0,
			y: 0
		},
		dragHandle: `.${Ti}`,
		selectable: e.type !== X.START_NODE,
		data: {
			...e,
			id: t
		}
	};
}, es = (e, t, n = Di) => ({
	id: `${e}_${t}`,
	source: e,
	sourceHandle: n,
	target: t,
	targetHandle: Ei
}), ts = (e) => {
	let t = [$o({
		id: X.START_NODE,
		type: X.START_NODE
	})], n = [];
	if (!e?.handler?.length) return {
		nodes: t,
		edges: n
	};
	let r = (e, i) => {
		e.forEach((e) => {
			let a = $o(e);
			t.push(a), e.next && n.push(es(e.id, String(e.next), i?.sourceHandler)), e.type === "REQUEST_API" && (e.afterSuccessResponse?.length && (n.push(es(e.id, String(e.afterSuccessResponse[0].id))), r(e.afterSuccessResponse)), e.afterFailedResponse?.length && (n.push(es(e.id, String(e.afterFailedResponse[0].id), Oi)), r(e.afterFailedResponse, { sourceHandler: Oi })));
		});
	}, i = e.handler[0];
	return n.push(es(X.START_NODE, i.id)), r(e.handler), {
		nodes: t,
		edges: n
	};
}, ns = (e) => {
	let { nodes: t, edges: n } = e, r = {
		type: "ACTION",
		handler: []
	}, i = t.find((e) => e.type === X.START_NODE);
	if (!i) return r;
	let a = new Map(t.map((e) => [e.id, e])), o = /* @__PURE__ */ new Set(), s = (e) => {
		if (o.has(e)) return [];
		o.add(e);
		let t = a.get(e);
		if (!t) return [];
		let r = [], i = {
			...t.data,
			id: e
		};
		if (t.type === "REQUEST_API") {
			let t = n.filter((t) => t.source === e && t.sourceHandle === "OUTPUT_HANDLE_ID").map((e) => s(e.target)).flat(), a = n.filter((t) => t.source === e && t.sourceHandle === "REQUEST_API_FAILED_HANDLE_ID").map((e) => s(e.target)).flat();
			return i.afterSuccessResponse = t, i.afterFailedResponse = a, r.push(i), r;
		}
		r.push(i);
		let c = n.filter((t) => t.source === e && t.sourceHandle === "OUTPUT_HANDLE_ID");
		if (c.length > 1) throw ae.error("不允许存在一个节点连接多个节点"), Error("不允许存在一个节点连接多个节点");
		return c.length !== 0 && c.forEach((e) => {
			let t = s(e.target);
			r.push(...t), i.next = t[0]?.id ?? null;
		}), r;
	}, c = s(i.id);
	return c.shift(), r.handler = c, r;
}, rs = [
	"StringSetter",
	"NumberSetter",
	"ExpressionSetter",
	"JSONSetter",
	{
		componentName: "FunctionSetter",
		props: {
			mode: "inline",
			minimap: !1,
			lineNumber: !1,
			containerStyle: {
				width: "500px",
				height: "250px"
			}
		}
	}
], is = function(e, t) {
	return Ut().getEdges().some((n) => n.source === String(e.id) && (n.sourceHandle || "OUTPUT_HANDLE_ID") === t);
}, as = function(e, t, n) {
	let r = {
		x: e.position.x,
		y: e.position.y + (e.measured?.height ?? 0) + 150
	}, i = {
		id: t.id,
		type: t.type,
		position: r,
		dragHandle: `.${Ti}`,
		data: { ...t }
	};
	return {
		newEdge: {
			id: `${e.data.id}_${i.id}`,
			source: String(e.data.id),
			sourceHandle: n ?? "OUTPUT_HANDLE_ID",
			target: i.id,
			targetHandle: Ei
		},
		newNode: i
	};
}, os = (e) => {
	let { fitView: t } = Ut(), [n, r] = d(!1), [a, s, c] = Ht([{
		id: X.START_NODE,
		data: { id: X.START_NODE },
		position: {
			x: 0,
			y: 0
		},
		type: X.START_NODE,
		dragHandle: `.${Ti}`,
		selectable: !1
	}]), [l, f, p] = Vt([]), m = u([]);
	m.current = l;
	let g = i((e) => f((t) => Bt({ ...e }, t)), [f]), _ = u([]);
	_.current = a;
	let [v, y] = d(!1), b = i((e) => {
		let n = Qo(_.current, l, { direction: "TB" });
		s([...n.nodes]), f([...n.edges]), setTimeout(() => {
			r(!0), e?.fitView !== !1 && t({});
		});
	}, [
		l,
		t,
		f,
		s
	]);
	o(() => {
		let { nodes: t, edges: n } = ts(e.value);
		s(t), f(n), setTimeout(() => {
			y(!0);
		}, 300);
	}, [
		e.value,
		f,
		s
	]);
	let x = i(() => {
		setTimeout(() => {
			let t = ns({
				nodes: _.current,
				edges: m.current
			});
			e.onValueChange?.(t);
		});
	}, [e]);
	return /* @__PURE__ */ R(Mo.Provider, {
		value: {
			pluginCtx: e.setterContext?.pluginCtx,
			pageModel: e.setterContext?.pluginCtx?.pageModel,
			onDataChange: x,
			nodeModel: e.setterContext.nodeModel
		},
		children: /* @__PURE__ */ R("div", {
			style: {
				width: "100%",
				height: "100%",
				display: "flex",
				position: "relative"
			},
			children: /* @__PURE__ */ z("div", {
				style: {
					flex: 1,
					position: "relative"
				},
				children: [
					/* @__PURE__ */ R(h, {
						style: {
							position: "absolute",
							top: "10px",
							right: "20px",
							zIndex: 99
						},
						onClick: () => b({ fitView: !1 }),
						children: "Reset Layout"
					}),
					!n && /* @__PURE__ */ R("div", { style: {
						position: "absolute",
						left: 0,
						top: 0,
						width: "100%",
						height: "100%",
						backgroundColor: "white",
						zIndex: 999
					} }),
					v && /* @__PURE__ */ z(Rt, {
						nodes: a,
						edges: l,
						onNodesChange: (e) => {
							c(e), x();
						},
						onEdgesChange: (e) => {
							p(e), x();
						},
						onConnect: (e) => {
							g(e), x();
						},
						defaultEdgeOptions: { type: "smoothstep" },
						minZoom: .2,
						maxZoom: 1,
						onInit: () => {
							b();
						},
						fitView: !0,
						nodeTypes: Zo,
						children: [
							/* @__PURE__ */ R(Nt, {}),
							/* @__PURE__ */ R(Pt, {}),
							/* @__PURE__ */ R(It, {})
						]
					})
				]
			})
		})
	});
}, ss = (e) => {
	let [t, n] = d(!1), r = u(e.value), i = async (t) => {
		(await e.setterContext?.pluginCtx?.pluginManager?.get("Hotkeys"))?.export.disable(t);
	}, a = e.children || /* @__PURE__ */ R(h, {
		size: "small",
		style: {
			marginTop: "5px",
			width: "100%",
			color: "#676767",
			fontSize: "12px"
		},
		children: "Edit Flow"
	});
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R("div", {
		onClick: async () => {
			await i(!0), n(!0);
		},
		children: a
	}), /* @__PURE__ */ R(na, {
		destroyOnHidden: !0,
		open: t,
		centered: !0,
		title: "Edit Flow",
		width: "calc(100vw - 200px)",
		onCancel: () => {
			n(!1), i(!1);
		},
		onOk: async () => {
			e.onValueChange?.(r.current), await i(!1), n(!1);
		},
		children: /* @__PURE__ */ R("div", {
			style: {
				width: "100%",
				height: "calc(100vh - 200px)"
			},
			children: /* @__PURE__ */ R(zt, { children: /* @__PURE__ */ R(os, {
				...e,
				onValueChange: (e) => {
					r.current = e;
				}
			}) })
		})
	})] });
};
ss.setterName = "逻辑流设置器";
//#endregion
//#region src/component/CustomSchemaForm/components/Setters/AdvanceSetterList.ts
var cs = { ActionFlowSetter: ss }, ls = { CFromRenderBox: "_CFromRenderBox_bin45_2" }, us = (e) => {
	let { node: t } = e, n = t?.material?.value.props || [], r = u(null), a = u(!1), s = u(null), c = i(() => {
		if (a.current) {
			a.current = !1;
			return;
		}
		let e = t?.getPlainProps?.() || {};
		r.current?.setFields(e);
	}, [t]), l = i(() => {
		a.current || s.current !== null || (s.current = window.requestAnimationFrame(() => {
			s.current = null, c();
		}));
	}, [c]);
	o(() => {
		c();
		let e = ({ node: e }) => {
			(e === t || e?.id === t?.id) && l();
		}, n = () => l();
		return t?.emitter.on("onNodeChange", e), t?.emitter.on("onReloadPage", n), () => {
			t?.emitter.off("onNodeChange", e), t?.emitter.off("onReloadPage", n), s.current !== null && (window.cancelAnimationFrame(s.current), s.current = null);
		};
	}, [
		t,
		l,
		c
	]);
	let d = i((e) => {
		if (t) {
			a.current = !0;
			try {
				t.updateValue({ props: e });
			} finally {
				a.current = !1;
			}
		}
	}, [t]), f = t?.getPlainProps?.() || {}, p = (e, n) => {
		t && (t.value.configure = t.value.configure || {}, t.value.configure.propsSetter = t.value.configure.propsSetter || {}, t.value.configure.propsSetter[e.join(".")] = {
			name: e.join("."),
			setter: n
		});
	}, m = e.pluginCtx.config?.customPropertySetterMap;
	return /* @__PURE__ */ R("div", {
		className: ls.CFromRenderBox,
		children: /* @__PURE__ */ R(yo, {
			pluginCtx: e.pluginCtx,
			nodeId: t?.id,
			defaultSetterConfig: t?.value.configure.propsSetter || {},
			onSetterChange: p,
			properties: n,
			initialValue: f,
			ref: r,
			customSetterMap: {
				...cs,
				...m
			},
			onValueChange: d
		}, t?.id)
	});
}, ds = {
	key: "Property",
	name: "Property",
	view: ({ node: e, pluginCtx: t }) => /* @__PURE__ */ R(us, {
		node: e,
		pluginCtx: t
	}),
	show: (e) => e.node?.material?.value.advanceCustom?.rightPanel?.property !== !1
}, fs = {
	statePanel: "_statePanel_1a1yw_2",
	editorBox: "_editorBox_1a1yw_7"
}, ps = (e) => {
	let t = e.node, n = t.value.state || {}, r = u(null);
	return o(() => {
		let e = t.value.state || {};
		r?.current?.setValue(JSON.stringify(e, null, 2));
	}, [t]), /* @__PURE__ */ R("div", {
		className: fs.statePanel,
		children: /* @__PURE__ */ R("div", {
			className: fs.editorBox,
			children: /* @__PURE__ */ R(Br, {
				initialValue: JSON.stringify(n, null, 2),
				language: "json",
				options: {
					automaticLayout: !0,
					tabSize: 2,
					minimap: { enabled: !1 },
					quickSuggestions: !1,
					suggestOnTriggerCharacters: !1,
					folding: !1
				},
				onDidMount: (e) => {
					r.current = e;
				},
				onChange: (e) => {
					try {
						let n = JSON.parse(e || "{}");
						t.value.state = n, t.updateValue();
					} catch (e) {
						console.warn(e);
					}
				}
			})
		})
	});
}, ms = {
	key: "State",
	name: "State",
	view: ({ node: e, pluginCtx: t }) => e ? /* @__PURE__ */ R(ps, {
		node: e,
		pluginCtx: t
	}) : /* @__PURE__ */ R(L, {}),
	show: (e) => e.node?.material?.value.advanceCustom?.rightPanel?.state !== !1
}, hs = { advanceBox: "_advanceBox_qtkk3_2" }, gs = [
	{
		name: "id",
		title: {
			label: "id",
			tip: "node unique id"
		},
		valueType: "string",
		readOnly: !0,
		setters: [{
			componentName: "StringSetter",
			props: {
				disabled: !0,
				variant: "borderless"
			}
		}]
	},
	{
		name: "componentName",
		title: {
			label: "CName",
			tip: "component name"
		},
		valueType: "string",
		readOnly: !0,
		setters: [{
			componentName: "StringSetter",
			props: {
				disabled: !0,
				variant: "borderless"
			}
		}]
	},
	{
		name: "condition",
		title: {
			label: "Render",
			tip: "controller component render"
		},
		valueType: "boolean",
		setters: ["BooleanSetter", "ExpressionSetter"]
	},
	{
		name: "loop",
		title: "loop render",
		valueType: "object",
		setters: [{
			componentName: "ShapeSetter",
			props: {
				collapse: { open: !0 },
				elements: [
					{
						name: "open",
						title: "open",
						valueType: "boolean",
						setters: ["BooleanSetter", "ExpressionSetter"]
					},
					{
						name: "data",
						title: "data",
						valueType: "array",
						setters: [
							{
								componentName: "ArraySetter",
								initialValue: [],
								props: { item: {
									setters: ["JSONSetter", "ExpressionSetter"],
									initialValue: {}
								} }
							},
							"JSONSetter",
							"ExpressionSetter"
						]
					},
					{
						name: "forName",
						title: {
							label: "name",
							tip: "loop element name"
						},
						valueType: "string",
						setters: ["StringSetter"]
					},
					{
						name: "forIndex",
						title: {
							label: "index",
							tip: "loop element index"
						},
						valueType: "string",
						setters: ["StringSetter"]
					},
					{
						name: "key",
						title: {
							label: "key",
							tip: "loop element key"
						},
						valueType: "expression",
						setters: ["ExpressionSetter"]
					},
					{
						name: "name",
						title: {
							label: "variable \n name",
							tip: "loop variable name"
						},
						valueType: "string",
						setters: [{
							componentName: "StringSetter",
							props: { prefix: "loopData" }
						}]
					}
				]
			},
			initialValue: {
				open: !1,
				data: []
			}
		}]
	},
	{
		name: "refId",
		title: {
			label: "refId",
			tip: "unique node flag"
		},
		valueType: "string",
		setters: ["StringSetter"]
	},
	{
		name: "nodeName",
		title: {
			label: /* @__PURE__ */ z(L, { children: [
				"node ",
				/* @__PURE__ */ R("br", {}),
				" name"
			] }),
			tip: "alias for node"
		},
		valueType: "string",
		setters: ["StringSetter"]
	}
], _s = (e) => {
	let { node: t } = e, n = l(() => {
		let e = gs;
		return t?.material?.value.advanceCustom?.rightPanel?.advanceOptions?.loop || !t?.material?.value.isContainer || (e = e.filter((e) => e?.name !== "loop")), t?.material?.value.advanceCustom?.rightPanel?.advanceOptions?.render || (e = e.filter((e) => e?.name !== "condition")), e;
	}, [
		t?.material?.value.advanceCustom?.rightPanel?.advanceOptions?.loop,
		t?.material?.value.advanceCustom?.rightPanel?.advanceOptions?.render,
		t?.material?.value.isContainer
	]), r = (e, n) => {
		t && (t.value.configure = t.value.configure || {}, t.value.configure.advanceSetter = t.value.configure.advanceSetter || {}, t.value.configure.advanceSetter[e.join(".")] = {
			name: e.join("."),
			setter: n
		});
	}, i = u(null);
	return o(() => {
		let e = t?.value.loop, n = {
			id: t?.id,
			componentName: t?.value.componentName,
			condition: t?.value.condition ?? !0,
			loop: {
				open: e?.open || !1,
				data: e?.data || [],
				forName: e?.forName || "item",
				forIndex: e?.forIndex || "index",
				key: e?.key || "",
				name: e?.name || ""
			},
			refId: t?.value.refId,
			nodeName: t?.value.nodeName
		};
		i.current?.setFields(n);
	}, [t]), t ? /* @__PURE__ */ R("div", {
		className: hs.advanceBox,
		children: /* @__PURE__ */ R(yo, {
			nodeId: e.node?.id,
			pluginCtx: e.pluginCtx,
			defaultSetterConfig: t.value.configure?.advanceSetter || {},
			onSetterChange: r,
			properties: n,
			initialValue: {},
			ref: i,
			onValueChange: (e) => {
				t && (t.value.loop = e.loop, t.value.condition = e.condition, t.value.refId = e.refId, t.value.nodeName = e.nodeName, t.updateValue());
			}
		}, t.id)
	}) : /* @__PURE__ */ R(L, {});
}, vs = {
	key: "Advance",
	name: "Advance",
	view: ({ node: e, pluginCtx: t }) => e ? /* @__PURE__ */ R(_s, {
		node: e,
		pluginCtx: t
	}) : /* @__PURE__ */ R(L, {}),
	show: (e) => e.node?.material?.value.advanceCustom?.rightPanel?.advance !== !1
}, ys = {
	rightPanelContainer: "_rightPanelContainer_wh9yl_2",
	tabLabel: "_tabLabel_wh9yl_11",
	emptyPanel: "_emptyPanel_wh9yl_95"
}, bs = {
	visualPanelBox: "_visualPanelBox_doseu_2",
	header: "_header_doseu_8"
}, xs = {
	cssFieldBox: "_cssFieldBox_neyda_2",
	row: "_row_neyda_9",
	fieldLabel: "_fieldLabel_neyda_14",
	leftBox: "_leftBox_neyda_20",
	rightBox: "_rightBox_neyda_23",
	inputBox: "_inputBox_neyda_26",
	cssBox: "_cssBox_neyda_30",
	switchBtn: "_switchBtn_neyda_40"
}, Ss = {
	cssColors: {
		aliceblue: "#f0f8ff",
		antiquewhite: "#faebd7",
		aqua: "#00ffff",
		aquamarine: "#7fffd4",
		azure: "#f0ffff",
		beige: "#f5f5dc",
		bisque: "#ffe4c4",
		black: "#000000",
		blanchedalmond: "#ffebcd",
		blue: "#0000ff",
		blueviolet: "#8a2be2",
		brown: "#a52a2a",
		burlywood: "#deb887",
		cadetblue: "#5f9ea0",
		chartreuse: "#7fff00",
		chocolate: "#d2691e",
		coral: "#ff7f50",
		cornflowerblue: "#6495ed",
		cornsilk: "#fff8dc",
		crimson: "#dc143c",
		cyan: "#00ffff",
		darkblue: "#00008b",
		darkcyan: "#008b8b",
		darkgoldenrod: "#b8860b",
		darkgray: "#a9a9a9",
		darkgreen: "#006400",
		darkgrey: "#a9a9a9",
		darkkhaki: "#bdb76b",
		darkmagenta: "#8b008b",
		darkolivegreen: "#556b2f",
		darkorange: "#ff8c00",
		darkorchid: "#9932cc",
		darkred: "#8b0000",
		darksalmon: "#e9967a",
		darkseagreen: "#8fbc8f",
		darkslateblue: "#483d8b",
		darkslategray: "#2f4f4f",
		darkslategrey: "#2f4f4f",
		darkturquoise: "#00ced1",
		darkviolet: "#9400d3",
		deeppink: "#ff1493",
		deepskyblue: "#00bfff",
		dimgray: "#696969",
		dimgrey: "#696969",
		dodgerblue: "#1e90ff",
		firebrick: "#b22222",
		floralwhite: "#fffaf0",
		forestgreen: "#228b22",
		fuchsia: "#ff00ff",
		gainsboro: "#dcdcdc",
		ghostwhite: "#f8f8ff",
		goldenrod: "#daa520",
		gold: "#ffd700",
		gray: "#808080",
		green: "#008000",
		greenyellow: "#adff2f",
		grey: "#808080",
		honeydew: "#f0fff0",
		hotpink: "#ff69b4",
		indianred: "#cd5c5c",
		indigo: "#4b0082",
		ivory: "#fffff0",
		khaki: "#f0e68c",
		lavenderblush: "#fff0f5",
		lavender: "#e6e6fa",
		lawngreen: "#7cfc00",
		lemonchiffon: "#fffacd",
		lightblue: "#add8e6",
		lightcoral: "#f08080",
		lightcyan: "#e0ffff",
		lightgoldenrodyellow: "#fafad2",
		lightgray: "#d3d3d3",
		lightgreen: "#90ee90",
		lightgrey: "#d3d3d3",
		lightpink: "#ffb6c1",
		lightsalmon: "#ffa07a",
		lightseagreen: "#20b2aa",
		lightskyblue: "#87cefa",
		lightslategray: "#778899",
		lightslategrey: "#778899",
		lightsteelblue: "#b0c4de",
		lightyellow: "#ffffe0",
		lime: "#00ff00",
		limegreen: "#32cd32",
		linen: "#faf0e6",
		magenta: "#ff00ff",
		maroon: "#800000",
		mediumaquamarine: "#66cdaa",
		mediumblue: "#0000cd",
		mediumorchid: "#ba55d3",
		mediumpurple: "#9370db",
		mediumseagreen: "#3cb371",
		mediumslateblue: "#7b68ee",
		mediumspringgreen: "#00fa9a",
		mediumturquoise: "#48d1cc",
		mediumvioletred: "#c71585",
		midnightblue: "#191970",
		mintcream: "#f5fffa",
		mistyrose: "#ffe4e1",
		moccasin: "#ffe4b5",
		navajowhite: "#ffdead",
		navy: "#000080",
		oldlace: "#fdf5e6",
		olive: "#808000",
		olivedrab: "#6b8e23",
		orange: "#ffa500",
		orangered: "#ff4500",
		orchid: "#da70d6",
		palegoldenrod: "#eee8aa",
		palegreen: "#98fb98",
		paleturquoise: "#afeeee",
		palevioletred: "#db7093",
		papayawhip: "#ffefd5",
		peachpuff: "#ffdab9",
		peru: "#cd853f",
		pink: "#ffc0cb",
		plum: "#dda0dd",
		powderblue: "#b0e0e6",
		purple: "#800080",
		rebeccapurple: "#663399",
		red: "#ff0000",
		rosybrown: "#bc8f8f",
		royalblue: "#4169e1",
		saddlebrown: "#8b4513",
		salmon: "#fa8072",
		sandybrown: "#f4a460",
		seagreen: "#2e8b57",
		seashell: "#fff5ee",
		sienna: "#a0522d",
		silver: "#c0c0c0",
		skyblue: "#87ceeb",
		slateblue: "#6a5acd",
		slategray: "#708090",
		slategrey: "#708090",
		snow: "#fffafa",
		springgreen: "#00ff7f",
		steelblue: "#4682b4",
		tan: "#d2b48c",
		teal: "#008080",
		thistle: "#d8bfd8",
		tomato: "#ff6347",
		turquoise: "#40e0d0",
		violet: "#ee82ee",
		wheat: "#f5deb3",
		white: "#ffffff",
		whitesmoke: "#f5f5f5",
		yellow: "#ffff00",
		yellowgreen: "#9acd32"
	},
	cssKeyValue: {
		"align-content": { values: [
			"center",
			"flex-end",
			"flex-start",
			"space-around",
			"space-between",
			"stretch"
		] },
		"align-items": { values: [
			"baseline",
			"center",
			"flex-end",
			"flex-start",
			"stretch"
		] },
		"align-self": { values: [
			"auto",
			"normal",
			"self-start",
			"self-end",
			"baseline",
			"center",
			"start",
			"end",
			"flex-end",
			"flex-start",
			"safe",
			"stretch",
			"unsafe"
		] },
		all: { values: [] },
		animation: { values: [] },
		"animation-delay": { values: [] },
		"animation-direction": { values: [
			"alternate",
			"alternate-reverse",
			"normal",
			"reverse"
		] },
		"animation-duration": { values: [] },
		"animation-fill-mode": { values: [
			"backwards",
			"both",
			"forwards",
			"none"
		] },
		"animation-iteration-count": { values: ["infinite"] },
		"animation-name": { values: ["none"] },
		"animation-play-state": { values: ["paused", "running"] },
		"animation-timing-function": { values: [
			"cubic-bezier()",
			"ease",
			"ease-in",
			"ease-in-out",
			"ease-out",
			"linear",
			"step-end",
			"step-start",
			"steps()"
		] },
		"backface-visibility": { values: ["hidden", "visible"] },
		background: {
			values: [],
			type: "color"
		},
		"background-attachment": { values: [
			"fixed",
			"local",
			"scroll"
		] },
		"background-blend-mode": { values: [
			"color",
			"color-burn",
			"color-dodge",
			"darken",
			"difference",
			"exclusion",
			"hard-light",
			"hue",
			"lighten",
			"luminosity",
			"multiply",
			"normal",
			"overlay",
			"saturation",
			"screen",
			"soft-light"
		] },
		"background-clip": { values: [
			"border-box",
			"content-box",
			"padding-box"
		] },
		"background-color": {
			values: [],
			type: "color"
		},
		"background-image": { values: [
			"image()",
			"linear-gradient()",
			"radial-gradient()",
			"repeating-linear-gradient()",
			"repeating-radial-gradient()",
			"url()"
		] },
		"background-origin": { values: [
			"border-box",
			"content-box",
			"padding-box"
		] },
		"background-position": { values: [
			"left",
			"center",
			"right",
			"bottom",
			"top"
		] },
		"background-repeat": { values: [
			"no-repeat",
			"repeat",
			"repeat-x",
			"repeat-y",
			"round",
			"space"
		] },
		"background-size": { values: [
			"auto",
			"contain",
			"cover"
		] },
		border: { values: [] },
		"border-collapse": { values: ["collapse", "separate"] },
		"border-color": {
			values: [],
			type: "color"
		},
		"border-spacing": { values: [] },
		"border-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-bottom": { values: [] },
		"border-bottom-color": {
			values: [],
			type: "color"
		},
		"border-bottom-left-radius": { values: [] },
		"border-bottom-right-radius": { values: [] },
		"border-bottom-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-bottom-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-image": { values: ["url()"] },
		"border-image-outset": { values: [] },
		"border-image-slice": { values: [] },
		"border-image-source": { values: [] },
		"border-image-repeat": { values: [
			"repeat",
			"round",
			"space",
			"stretch"
		] },
		"border-image-width": { values: ["auto"] },
		"border-left": { values: [] },
		"border-left-color": {
			values: [],
			type: "color"
		},
		"border-left-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-left-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-radius": { values: [] },
		"border-right": { values: [] },
		"border-right-color": {
			values: [],
			type: "color"
		},
		"border-right-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-right-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-top": { values: [] },
		"border-top-color": {
			values: [],
			type: "color"
		},
		"border-top-left-radius": { values: [] },
		"border-top-right-radius": { values: [] },
		"border-top-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"border-top-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"border-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"box-decoration-break": { values: ["clone", "slice"] },
		"box-shadow": { values: ["none"] },
		"box-sizing": { values: ["border-box", "content-box"] },
		bottom: { values: ["auto"] },
		"break-after": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"break-before": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"break-inside": { values: [
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region"
		] },
		"caption-side": { values: ["bottom", "top"] },
		"caret-color": {
			values: ["auto"],
			type: "color"
		},
		clear: { values: [
			"both",
			"left",
			"none",
			"right"
		] },
		clip: { values: ["auto"] },
		color: {
			values: [],
			type: "color"
		},
		columns: { values: [] },
		"column-count": { values: [] },
		"column-fill": { values: ["auto", "balance"] },
		"column-gap": { values: ["normal"] },
		"column-rule": { values: [] },
		"column-rule-color": {
			values: [],
			type: "color"
		},
		"column-rule-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"column-rule-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		"column-span": { values: ["all", "none"] },
		"column-width": { values: ["auto"] },
		content: { values: [
			"attr()",
			"close-quote",
			"no-close-quote",
			"no-open-quote",
			"normal",
			"none",
			"open-quote"
		] },
		"counter-increment": { values: ["none"] },
		"counter-reset": { values: ["none"] },
		cursor: { values: /* @__PURE__ */ "alias.all-scroll.auto.cell.col-resize.context-menu.copy.crosshair.default.e-resize.ew-resize.grab.grabbing.help.move.n-resize.ne-resize.nesw-resize.no-drop.none.not-allowed.ns-resize.nw-resize.nwse-resize.pointer.progress.row-resize.s-resize.se-resize.sw-resize.text.vertical-text.w-resize.wait.zoom-in.zoom-out".split(".") },
		direction: { values: ["ltr", "rtl"] },
		display: { values: [
			"block",
			"contents",
			"flex",
			"flow-root",
			"grid",
			"inline",
			"inline-block",
			"inline-flex",
			"inline-grid",
			"inline-table",
			"list-item",
			"none",
			"run-in",
			"subgrid",
			"table",
			"table-caption",
			"table-cell",
			"table-column",
			"table-column-group",
			"table-footer-group",
			"table-header-group",
			"table-row",
			"table-row-group"
		] },
		"empty-cells": { values: ["hide", "show"] },
		fill: { values: [] },
		filter: { values: [
			"blur()",
			"brightness()",
			"contrast()",
			"custom()",
			"drop-shadow()",
			"grayscale()",
			"hue-rotate()",
			"invert()",
			"none",
			"opacity()",
			"sepia()",
			"saturate()",
			"url()"
		] },
		flex: { values: ["auto", "none"] },
		"flex-basis": { values: ["auto"] },
		"flex-direction": { values: [
			"column",
			"column-reverse",
			"row",
			"row-reverse"
		] },
		"flex-flow": { values: [
			"column",
			"column-reverse",
			"nowrap",
			"row",
			"row-reverse",
			"wrap",
			"wrap-reverse"
		] },
		"flex-grow": { values: [] },
		"flex-shrink": { values: [] },
		"flex-wrap": { values: [
			"nowrap",
			"wrap",
			"wrap-reverse"
		] },
		float: { values: [
			"left",
			"right",
			"none",
			"inline-start",
			"inline-end"
		] },
		"flow-into": {
			values: ["none"],
			type: "named-flow"
		},
		"flow-from": {
			values: ["none"],
			type: "named-flow"
		},
		font: { values: [] },
		"font-display": { values: [
			"auto",
			"block",
			"swap",
			"fallback",
			"optional"
		] },
		"font-family": { values: [
			"auto",
			"cursive",
			"fantasy",
			"monospace",
			"sans-serif",
			"serif"
		] },
		"font-feature-settings": { values: ["normal"] },
		"font-kerning": { values: [
			"auto",
			"none",
			"normal"
		] },
		"font-language-override": { values: ["normal"] },
		"font-size": { values: [
			"xx-small",
			"x-small",
			"small",
			"medium",
			"large",
			"x-large",
			"xx-large",
			"xxx-large",
			"larger",
			"smaller"
		] },
		"font-size-adjust": { values: ["auto", "none"] },
		"font-stretch": { values: [
			"condensed",
			"expanded",
			"extra-condensed",
			"extra-expanded",
			"normal",
			"semi-condensed",
			"semi-expanded",
			"ultra-condensed",
			"ultra-expanded"
		] },
		"font-style": { values: [
			"italic",
			"normal",
			"oblique"
		] },
		"font-synthesis": { values: [
			"none",
			"style",
			"weight"
		] },
		"font-variant": { values: ["normal", "small-caps"] },
		"font-variant-alternates": { values: ["normal"] },
		"font-variant-caps": { values: [
			"normal",
			"small-caps",
			"all-small-caps",
			"petite-caps",
			"all-petite-caps",
			"unicase",
			"titling-caps"
		] },
		"font-variant-east-asian": { values: ["normal"] },
		"font-variant-ligatures": { values: ["normal", "none"] },
		"font-variant-numeric": { values: ["normal"] },
		"font-variant-position": { values: [
			"normal",
			"sub",
			"super"
		] },
		"font-weight": { values: [
			"bold",
			"bolder",
			"lighter",
			"normal",
			"100",
			"200",
			"300",
			"400",
			"500",
			"600",
			"700",
			"800",
			"900"
		] },
		gap: { values: ["revert-layer"] },
		grid: { values: [] },
		"grid-area": { values: [] },
		"grid-auto-columns": { values: [] },
		"grid-auto-flow": { values: [
			"row",
			"column",
			"dense"
		] },
		"grid-auto-rows": { values: [] },
		"grid-column": { values: ["auto"] },
		"grid-column-end": { values: [] },
		"grid-column-gap": { values: [] },
		"grid-column-start": { values: [] },
		"grid-gap": { values: [] },
		"grid-row": { values: ["auto"] },
		"grid-row-end": { values: [] },
		"grid-row-start": { values: [] },
		"grid-row-gap": { values: [] },
		"grid-template": { values: ["none"] },
		"grid-template-areas": { values: [] },
		"grid-template-columns": { values: ["auto"] },
		"grid-template-rows": { values: ["auto"] },
		"hanging-punctuation": { values: [
			"allow-end",
			"first",
			"force-end",
			"last",
			"none"
		] },
		height: { values: [
			"auto",
			"max-content",
			"min-content",
			"fit-content"
		] },
		hyphens: { values: [
			"auto",
			"manual",
			"none"
		] },
		"image-orientation": { values: [] },
		"image-resolution": { values: ["from-image", "snap"] },
		isolation: { values: ["auto", "isolate"] },
		"justify-content": { values: [
			"center",
			"flex-end",
			"flex-start",
			"space-around",
			"space-between"
		] },
		"justify-items": { values: [
			"auto",
			"normal",
			"stretch",
			"center",
			"start",
			"end",
			"flex-start",
			"flex-end",
			"self-start",
			"self-end",
			"left",
			"right",
			"baseline",
			"first",
			"last",
			"safe",
			"unsafe",
			"legacy"
		] },
		"justify-self": { values: [
			"auto",
			"normal",
			"stretch",
			"center",
			"start",
			"end",
			"flex-start",
			"flex-end",
			"self-start",
			"self-end",
			"left",
			"right",
			"baseline",
			"first",
			"last",
			"safe",
			"unsafe"
		] },
		left: { values: ["auto"] },
		"letter-spacing": { values: ["normal"] },
		"line-height": { values: ["normal"] },
		"list-style": { values: [
			"none",
			"url()",
			"armenian",
			"circle",
			"decimal",
			"decimal-leading-zero",
			"disc",
			"georgian",
			"inside",
			"lower-alpha",
			"lower-greek",
			"lower-latin",
			"lower-roman",
			"outside",
			"square",
			"upper-alpha",
			"upper-latin",
			"upper-roman"
		] },
		"list-style-image": { values: ["none", "url()"] },
		"list-style-position": { values: ["inside", "outside"] },
		"list-style-type": { values: [
			"armenian",
			"circle",
			"decimal",
			"decimal-leading-zero",
			"disc",
			"georgian",
			"lower-alpha",
			"lower-greek",
			"lower-latin",
			"lower-roman",
			"none",
			"square",
			"upper-alpha",
			"upper-latin",
			"upper-roman"
		] },
		margin: { values: ["auto"] },
		"margin-bottom": { values: ["auto"] },
		"margin-left": { values: ["auto"] },
		"margin-right": { values: ["auto"] },
		"margin-top": { values: ["auto"] },
		"max-height": { values: ["none"] },
		"max-width": { values: ["none"] },
		"min-height": { values: [] },
		"min-width": { values: [] },
		"mix-blend-mode": { values: [
			"color",
			"color-burn",
			"color-dodge",
			"darken",
			"difference",
			"exclusion",
			"hard-light",
			"hue",
			"lighten",
			"luminosity",
			"multiply",
			"normal",
			"overlay",
			"saturation",
			"screen",
			"soft-light"
		] },
		"object-fit": { values: [
			"contain",
			"cover",
			"fill",
			"none",
			"scale-down"
		] },
		"object-position": { values: [
			"left",
			"center",
			"right",
			"bottom",
			"top"
		] },
		opacity: { values: [] },
		order: { values: [] },
		orphans: { values: [] },
		outline: { values: [] },
		"outline-color": {
			values: ["invert"],
			type: "color"
		},
		"outline-offset": { values: [] },
		"outline-style": { values: [
			"dashed",
			"dotted",
			"double",
			"groove",
			"hidden",
			"inset",
			"none",
			"outset",
			"ridge",
			"solid"
		] },
		"outline-width": { values: [
			"medium",
			"thin",
			"thick"
		] },
		overflow: { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-x": { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-y": { values: [
			"auto",
			"hidden",
			"scroll",
			"visible"
		] },
		"overflow-wrap": { values: [
			"normal",
			"anywhere",
			"break-word"
		] },
		padding: { values: [] },
		"padding-bottom": { values: [] },
		"padding-left": { values: [] },
		"padding-right": { values: [] },
		"padding-top": { values: [] },
		"page-break-after": { values: [
			"always",
			"auto",
			"avoid",
			"left",
			"right"
		] },
		"page-break-before": { values: [
			"always",
			"auto",
			"avoid",
			"left",
			"right"
		] },
		"page-break-inside": { values: ["auto", "avoid"] },
		perspective: { values: ["none"] },
		"perspective-origin": { values: [
			"bottom",
			"center",
			"left",
			"right",
			"top"
		] },
		"pointer-events": { values: [
			"all",
			"auto",
			"fill",
			"none",
			"painted",
			"stroke",
			"visible",
			"visibleFill",
			"visiblePainted",
			"visibleStroke"
		] },
		position: { values: [
			"absolute",
			"fixed",
			"relative",
			"static",
			"sticky"
		] },
		quotes: { values: ["none"] },
		"region-break-after": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"region-break-before": { values: [
			"always",
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region",
			"column",
			"left",
			"page",
			"region",
			"right"
		] },
		"region-break-inside": { values: [
			"auto",
			"avoid",
			"avoid-column",
			"avoid-page",
			"avoid-region"
		] },
		"region-fragment": { values: ["auto", "break"] },
		resize: { values: [
			"both",
			"horizontal",
			"none",
			"vertical"
		] },
		right: { values: ["auto"] },
		"scroll-behavior": { values: ["auto", "smooth"] },
		"scroll-snap-type": { values: [
			"none",
			"x",
			"y",
			"block",
			"inline",
			"both",
			"mandatory",
			"proximity"
		] },
		src: { values: ["url()"] },
		"shape-image-threshold": { values: [] },
		"shape-inside": { values: [
			"auto",
			"circle()",
			"ellipse()",
			"outside-shape",
			"polygon()",
			"rectangle()"
		] },
		"shape-margin": { values: [] },
		"shape-outside": { values: [
			"none",
			"circle()",
			"ellipse()",
			"polygon()",
			"inset()",
			"margin-box",
			"border-box",
			"padding-box",
			"content-box",
			"url()",
			"image()",
			"linear-gradient()",
			"radial-gradient()",
			"repeating-linear-gradient()",
			"repeating-radial-gradient()"
		] },
		"tab-size": { values: [] },
		"table-layout": { values: ["auto", "fixed"] },
		"text-align": { values: [
			"start",
			"end",
			"center",
			"left",
			"justify",
			"right",
			"match-parent",
			"justify-all"
		] },
		"text-align-last": { values: [
			"center",
			"left",
			"justify",
			"right"
		] },
		"text-decoration": { values: [
			"line-through",
			"none",
			"overline",
			"underline"
		] },
		"text-decoration-color": {
			values: [],
			type: "color"
		},
		"text-decoration-line": { values: [
			"line-through",
			"none",
			"overline",
			"underline"
		] },
		"text-decoration-skip": { values: [
			"edges",
			"ink",
			"none",
			"objects",
			"spaces"
		] },
		"text-decoration-style": { values: [
			"dashed",
			"dotted",
			"double",
			"solid",
			"wavy"
		] },
		"text-emphasis": { values: [] },
		"text-emphasis-color": {
			values: [],
			type: "color"
		},
		"text-emphasis-position": { values: [
			"above",
			"below",
			"left",
			"right"
		] },
		"text-emphasis-style": { values: [
			"circle",
			"dot",
			"double-circle",
			"filled",
			"none",
			"open",
			"sesame",
			"triangle"
		] },
		"text-indent": { values: [] },
		"text-justify": { values: [
			"auto",
			"none",
			"inter-word",
			"inter-character"
		] },
		"text-overflow": { values: ["clip", "ellipsis"] },
		"text-shadow": { values: [] },
		"text-rendering": { values: [
			"auto",
			"geometricPrecision",
			"optimizeLegibility",
			"optimizeSpeed"
		] },
		"text-transform": { values: [
			"capitalize",
			"full-width",
			"lowercase",
			"none",
			"uppercase"
		] },
		"text-underline-position": { values: [
			"alphabetic",
			"auto",
			"below",
			"left",
			"right"
		] },
		top: { values: ["auto"] },
		transform: { values: [
			"matrix()",
			"matrix3d()",
			"none",
			"perspective()",
			"rotate()",
			"rotate3d()",
			"rotateX()",
			"rotateY()",
			"rotateZ()",
			"scale()",
			"scale3d()",
			"scaleX()",
			"scaleY()",
			"scaleZ()",
			"skewX()",
			"skewY()",
			"translate()",
			"translate3d()",
			"translateX()",
			"translateY()",
			"translateZ()"
		] },
		"transform-origin": { values: [
			"bottom",
			"center",
			"left",
			"right",
			"top"
		] },
		"transform-style": { values: ["flat", "preserve-3d"] },
		transition: { values: [] },
		"transition-delay": { values: [] },
		"transition-duration": { values: [] },
		"transition-property": { values: ["all", "none"] },
		"transition-timing-function": { values: [
			"cubic-bezier()",
			"ease",
			"ease-in",
			"ease-in-out",
			"ease-out",
			"linear",
			"step-end",
			"step-start",
			"steps()"
		] },
		"unicode-bidi": { values: [
			"bidi-override",
			"embed",
			"normal"
		] },
		"unicode-range": { values: [] },
		"user-select": { values: [
			"all",
			"auto",
			"contain",
			"none",
			"text"
		] },
		"vertical-align": { values: [
			"baseline",
			"bottom",
			"middle",
			"sub",
			"super",
			"text-bottom",
			"text-top",
			"top"
		] },
		visibility: { values: [
			"collapse",
			"hidden",
			"visible"
		] },
		"white-space": { values: [
			"normal",
			"nowrap",
			"pre",
			"pre-line",
			"pre-wrap"
		] },
		widows: { values: [] },
		width: { values: [
			"auto",
			"max-content",
			"min-content",
			"fit-content"
		] },
		"will-change": { values: [
			"auto",
			"contents",
			"opacity",
			"scroll-position"
		] },
		"word-break": { values: [
			"normal",
			"break-all",
			"keep-all"
		] },
		"word-spacing": { values: ["normal"] },
		"z-index": { values: ["auto"] }
	}
};
Ss.cssKeyValue, Ss.cssColors;
var Cs = Object.keys(Ss.cssKeyValue), ws = e.createContext({
	defaultSetterConfig: {},
	customSetterMap: {}
}), Ts = () => a(ws), Es = Cs.map((e) => ({ value: e })), Ds = n(function(e, t) {
	let [n, r] = d(""), i = Ts(), { mod: a = "create" } = e, [c, l] = d({
		property: e.value?.property || "",
		value: e.value?.value || ""
	});
	o(() => {
		e.value && l(e.value);
	}, [e.value]);
	let [f, p] = d(Es), g = (e) => {
		let t = Es.filter((t) => t.value.includes(e));
		p(e ? t : Es);
	}, _ = (t) => {
		e.onValueChange({ ...t });
	}, v = u(null);
	return s(t, () => ({ reset: () => {
		l({
			property: "",
			value: {
				type: Re.EXPRESSION,
				value: ""
			}
		}), v.current?.focus();
	} }), []), /* @__PURE__ */ R(L, { children: /* @__PURE__ */ z("div", {
		className: xs.cssFieldBox,
		children: [/* @__PURE__ */ z("div", {
			className: xs.leftBox,
			children: [
				/* @__PURE__ */ z("div", {
					className: xs.row,
					children: [/* @__PURE__ */ R("span", {
						className: xs.fieldLabel,
						children: "Name"
					}), /* @__PURE__ */ R(m, {
						status: n,
						disabled: a === "edit",
						ref: v,
						onSearch: g,
						popupMatchSelectWidth: 200,
						value: c.property,
						onChange: (e) => {
							r("");
							let t = {
								...c,
								property: e
							};
							l(t), _(t);
						},
						className: P([xs.inputBox]),
						onBlur: () => {
							_(c);
						},
						placeholder: "property",
						options: f
					})]
				}),
				a === "create" && /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(h, {
					size: "small",
					block: !0,
					icon: /* @__PURE__ */ R(De, { style: {
						fontSize: "12px",
						display: "inline-flex"
					} }),
					onClick: () => {
						if (c.property === "") {
							r("error");
							return;
						}
						r(""), (e.onCreate?.(c))?.errorKey?.includes("key") && r("error");
					}
				}) }),
				a !== "create" && /* @__PURE__ */ z("div", {
					className: xs.row,
					children: [/* @__PURE__ */ R("span", {
						className: xs.fieldLabel,
						children: "Value"
					}), /* @__PURE__ */ R(b, {
						theme: { token: { borderRadius: 4 } },
						children: /* @__PURE__ */ R("div", {
							style: { width: "100%" },
							children: /* @__PURE__ */ R($i, {
								value: c.value,
								setterContext: {
									pluginCtx: i.pluginCtx,
									setCollapseHeaderExt: void 0,
									onSetterChange: function() {},
									keyPaths: [],
									label: "",
									nodeModel: i.nodeModel
								},
								onValueChange: function(e) {
									let t = {
										...c,
										value: e
									};
									console.log("newVal", t), l(t), _(t);
								},
								mode: "modal"
							})
						})
					})]
				})
			]
		}), /* @__PURE__ */ R("div", {
			className: xs.rightBox,
			children: /* @__PURE__ */ R("div", {
				style: { height: "30px" },
				children: e.onDelete && a === "edit" && /* @__PURE__ */ R(h, {
					size: "small",
					type: "text",
					onClick: () => {
						e.onDelete?.();
					},
					children: /* @__PURE__ */ R(Te, { style: {
						display: "inline-flex",
						fontSize: "12px"
					} })
				})
			})
		})]
	}) });
}), Os = n(function(e, t) {
	let [n, r] = d([]);
	s(t, () => ({ setValue: (e) => {
		r(e);
	} }), []), o(() => {
		e.initialValue && r(e.initialValue);
	}, []);
	let [i, a] = d({
		property: "",
		value: {
			type: "EXPRESSION",
			value: ""
		}
	}), c = (t) => {
		e.onValueChange?.(t);
	}, l = u(null);
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ z("div", {
			className: xs.cssBox,
			children: [n.map((e, t) => /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(Ds, {
				value: e,
				mod: "edit",
				onValueChange: (e) => {
					if (e.property === "") {
						n.splice(t, 1), r([...n]);
						return;
					}
					n[t] = e, r([...n]), c(n);
				},
				onDelete: () => {
					n.splice(t, 1), r([...n]), c(n);
				}
			}) }, t)), /* @__PURE__ */ R(Ds, {
				value: i,
				ref: l,
				mod: "create",
				onValueChange: (e) => {
					a(e);
				},
				onCreate: (e) => {
					if (n.find((t) => t.property === e.property)) return ae.error("The attribute name already exists, please replace"), { errorKey: [e.property] };
					n.push(e), r([...n]), c(n), a({
						property: "",
						value: {
							type: "EXPRESSION",
							value: ""
						}
					});
				}
			})]
		})
	});
}), ks = [{
	title: "Class Names",
	name: "className",
	valueType: "array",
	setters: [{
		componentName: "ArraySetter",
		props: {
			sortLabelKey: "name",
			collapse: { open: !0 },
			item: {
				setters: [{
					componentName: "ShapeSetter",
					props: { elements: [{
						name: "name",
						title: "类名",
						valueType: "string",
						setters: ["StringSetter"]
					}, {
						name: "status",
						title: "启用",
						valueType: "boolean",
						setters: ["BooleanSetter", "ExpressionSetter"]
					}] },
					initialValue: {}
				}],
				initialValue: {
					name: "",
					status: !0
				}
			}
		},
		initialValue: []
	}]
}], As = n(function(e, t) {
	let n = u(null);
	return s(t, () => ({ setValue(e) {
		n?.current?.setFields({ className: e || [] });
	} })), /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(yo, {
			ref: n,
			initialValue: [],
			nodeId: e.nodeModel.id,
			pluginCtx: e.pluginContext,
			properties: ks,
			onSetterChange: function() {},
			onValueChange: (t) => {
				e.onValueChange?.(t.className || []);
			},
			defaultSetterConfig: {}
		}) })
	});
}), Z = {
	cssFieldBox: "_cssFieldBox_20o6s_2",
	inputAuto: "_inputAuto_20o6s_46",
	error: "_error_20o6s_51",
	keyField: "_keyField_20o6s_54",
	notEdit: "_notEdit_20o6s_64",
	keyFieldSizer: "_keyFieldSizer_20o6s_67",
	propertyLabel: "_propertyLabel_20o6s_75",
	active: "_active_20o6s_82",
	cssBox: "_cssBox_20o6s_86"
}, js = n(function(e, t) {
	let [n] = d(""), [r] = d(""), { mode: i = "edit" } = e, a = l(() => i === "create", [i]), o = e.value, c = o?.property || "", f = !a && c.length > 18, [p, g] = d(Ms), [_, v] = d([]), [y, b] = d([]), x = (e) => {
		let t = Ms.filter((t) => t.value.includes(e));
		g(e ? t : Ms);
	}, S = () => {
		let e = [], t = da[o?.property];
		t && (e = t.values?.map((e) => ({ value: e })) || []), v(e), b(e);
	}, C = (e) => {
		let t = y.filter((t) => t.value.includes(e));
		v(e ? t : y);
	}, w = (t) => (e.onValueChange?.({
		property: t,
		value: o?.value || ""
	}), !0), T = u(null), E = u(null), [D, O] = d({
		key: !1,
		value: !1
	});
	return s(t, () => ({ reset: () => {
		E.current?.focus();
	} }), []), /* @__PURE__ */ z("div", {
		className: Z.cssFieldBox,
		children: [
			/* @__PURE__ */ R(N, {
				title: f ? c : void 0,
				placement: "topLeft",
				children: /* @__PURE__ */ z("div", {
					className: P([
						Z.keyField,
						a && Z.inputAuto,
						a && D.key && Z.active,
						n === "error" && Z.error,
						!a && Z.notEdit
					]),
					children: [a ? /* @__PURE__ */ R(m, {
						ref: E,
						variant: "borderless",
						onSearch: x,
						status: n,
						popupMatchSelectWidth: 200,
						value: o?.property,
						onChange: (e) => {
							w(e);
						},
						style: {
							width: "100%",
							position: "absolute",
							left: 0,
							top: 0
						},
						onFocus: () => {
							O({
								key: !0,
								value: !1
							});
						},
						onBlur: () => {
							O({
								key: !1,
								value: !1
							});
						},
						onKeyDown: (e) => {
							e.code === "Enter" && !n && T.current?.focus();
						},
						placeholder: "property",
						options: p
					}) : /* @__PURE__ */ R("span", {
						className: Z.propertyLabel,
						children: c
					}), a && /* @__PURE__ */ R("span", {
						className: Z.keyFieldSizer,
						children: c
					})]
				})
			}),
			/* @__PURE__ */ R("span", {
				style: { padding: "0 2px" },
				children: ":"
			}),
			/* @__PURE__ */ R(m, {
				variant: "borderless",
				ref: T,
				status: r,
				popupMatchSelectWidth: 200,
				value: o?.value,
				onChange: (t) => {
					S(), e.onValueChange?.({
						property: o?.property || "",
						value: t || ""
					});
				},
				style: { flex: 1 },
				onFocus: () => {
					O({
						key: !1,
						value: !0
					});
				},
				onBlur: () => {
					O({
						key: !1,
						value: !1
					});
				},
				className: P([Z.inputAuto, D.value && Z.active]),
				placeholder: "value",
				onSearch: C,
				options: _,
				onKeyDown: (t) => {
					t.code === "Enter" && a && e.onCreate?.({
						property: o?.property || "",
						value: o?.value || ""
					});
				}
			}),
			e.onDelete && i === "edit" && /* @__PURE__ */ R(h, {
				size: "small",
				type: "text",
				onClick: () => {
					e.onDelete?.();
				},
				children: /* @__PURE__ */ R(Te, { style: {
					display: "inline-flex",
					fontSize: "12px"
				} })
			}),
			e.onCreate && i === "create" && /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(h, {
				size: "small",
				type: "text",
				icon: /* @__PURE__ */ R(De, { style: {
					fontSize: "12px",
					display: "inline-flex"
				} }),
				onClick: () => {
					e.onCreate?.({
						property: o?.property || "",
						value: o?.value || ""
					});
				}
			}) })
		]
	});
}), Ms = fa.map((e) => ({ value: e })), Ns = n(function(e, t) {
	let [n, r] = d([]), [i, a] = d({
		property: "",
		value: ""
	});
	s(t, () => ({ setValue: (e) => {
		r(e);
	} }), []), o(() => {
		e.initialValue && r([...e.initialValue]);
	}, []);
	let c = (t) => {
		e.onValueChange?.(t);
	}, l = u(null);
	return /* @__PURE__ */ R(b, {
		theme: { token: { borderRadius: 4 } },
		children: /* @__PURE__ */ z("div", {
			className: Z.cssBox,
			children: [n.map((e, t) => /* @__PURE__ */ R("div", { children: /* @__PURE__ */ R(js, {
				mode: "edit",
				allValues: n,
				value: e,
				onValueChange: (e) => {
					n[t] = e;
					let i = JSON.parse(JSON.stringify(n));
					r(i), c(i);
				},
				onDelete: () => {
					n.splice(t, 1);
					let e = JSON.parse(JSON.stringify(n));
					r(e), c(e);
				}
			}) }, t)), /* @__PURE__ */ R(js, {
				allValues: n,
				mode: "create",
				value: i,
				ref: l,
				onValueChange: (e) => {
					a({ ...e });
				},
				onCreate: (e) => {
					if (e.property && e.value) {
						let t = [...n];
						t.push(e), r(t), a({
							property: "",
							value: ""
						}), c(t), l.current?.reset();
					}
				}
			}, "newInput")]
		})
	});
}), Ps = {
	cssCard: "_cssCard_1fnta_2",
	stateTags: "_stateTags_1fnta_14",
	stateTag: "_stateTag_1fnta_14",
	stateTagClose: "_stateTagClose_1fnta_31",
	cssRules: "_cssRules_1fnta_49"
}, Fs = [
	"normal",
	"hover",
	"focus",
	"focus-within",
	"focus-visible",
	"checked",
	"disable",
	"active"
].map((e) => ({
	key: e,
	label: e
})), Is = (e) => {
	let [t, n] = d("normal"), r = l(() => jn(e.responsiveSizes).map(({ label: e, width: t }) => ({
		key: `${t}`,
		label: `${e} (${t} px)`
	})), [e.responsiveSizes]), a = u({}), s = (e) => {
		n(e);
	}, [c, f] = d([]), p = l(() => Fs.filter((e) => !c.includes(e.key)), [c]), m = l(() => Fs.filter((e) => c.includes(e.key)), [c]), [h, _] = d(e.initialValue ?? {});
	o(() => {
		let e = Object.keys(h);
		f(e);
	}, [h]);
	let y = l(() => {
		let e = h?.[t];
		if (!e) return {};
		let n = {};
		return Object.keys(e).forEach((t) => {
			n[t] = Bn(e[t] || "");
		}), n;
	}, [t, h]), b = i(() => {
		Object.keys(a.current).forEach((e) => {
			let t = a.current?.[e], n = y[e] || [];
			t && t.setValue(n);
		});
	}, [y]), x = u();
	x.current = b, e.handler && (e.handler.current = { setValue: async (e) => {
		ot(e) ? _({ normal: { normal: "" } }) : _(e), await H(), x.current?.();
	} }), o(() => {
		x.current?.();
	}, [t]);
	let C = i((n, r) => {
		let i = {
			...h,
			[t]: {
				...h[t] || {},
				[n]: Fn(r)
			}
		};
		e.onValueChange?.(i);
	}, [
		h,
		e,
		t
	]);
	return /* @__PURE__ */ R(L, { children: /* @__PURE__ */ z(g, {
		className: Ps.cssCard,
		size: "small",
		type: "inner",
		title: /* @__PURE__ */ R("span", { children: "CSS" }),
		extra: /* @__PURE__ */ R(S, {
			menu: {
				items: p,
				onClick: (e) => {
					f((t) => [...t, e.key]);
				}
			},
			children: /* @__PURE__ */ R(De, {})
		}),
		children: [/* @__PURE__ */ R(M, {
			className: Ps.stateTags,
			size: [0, 8],
			wrap: !0,
			style: { paddingBottom: "10px" },
			children: m.map((e) => {
				let r = t.includes(e.key);
				return /* @__PURE__ */ z(Dn, {
					style: { border: r ? "1px solid rgba(0,0,0,0))" : "1px solid rgb(216 216 216 / 82%)" },
					checked: r,
					onChange: () => s(e.key),
					className: Ps.stateTag,
					children: [e.label, e.key !== "normal" && /* @__PURE__ */ R(we, {
						className: Ps.stateTagClose,
						onClick: (t) => {
							t.stopPropagation(), t.preventDefault(), f((t) => t.filter((t) => t !== e.key)), n("normal");
						}
					})]
				}, e.key);
			})
		}), /* @__PURE__ */ R(v, {
			className: Ps.cssRules,
			defaultActiveKey: ["normal"],
			bordered: !1,
			style: { marginBottom: "10px" },
			onChange: async () => {
				await H(), x.current?.();
			},
			items: [{
				key: "normal",
				label: /* @__PURE__ */ R("span", { children: "Default (All sizes)" }),
				children: /* @__PURE__ */ R(Ns, {
					ref: (e) => {
						a.current.normal = e;
					},
					onValueChange: (e) => C("normal", e),
					initialValue: y.normal
				})
			}, ...r.map((e) => ({
				key: e.key,
				label: /* @__PURE__ */ R("span", { children: e.label }),
				children: /* @__PURE__ */ R(Ns, {
					ref: (t) => {
						a.current[e.key] = t;
					},
					onValueChange: (t) => C(e.key, t)
				})
			}))]
		})]
	}) });
}, Ls = (e) => {
	let t = u(null), n = e.node, [r, a] = d(null), s = n.value.classNames || [], c = u(null), l = u(null), f = u(null), p = u(!1), m = u(null), h = i(() => zn(n.value.style || []), [n]);
	o(() => {
		let t = !1, r, i = async () => {
			let o = (await e.pluginCtx.pluginManager.get("Designer"))?.export.getComponentInstances(n.id)?.[0]?.getDom?.();
			if (!t) {
				if (o) {
					a(o);
					return;
				}
				r = window.setTimeout(i, 50);
			}
		};
		return i(), () => {
			t = !0, r && window.clearTimeout(r), a(null);
		};
	}, [n, e.pluginCtx.pluginManager]);
	let g = i(() => {
		if (p.current) {
			p.current = !1;
			return;
		}
		let { expressionProperty: e, normalProperty: r } = zn(n.value.style || []), i = Hn(n.value.css);
		t.current?.setValue([...e]), c.current?.setValue(i), f.current?.setValue(n.value.classNames || []), l.current?.setValue(Nn(r) || {});
	}, [n]), _ = i((e) => {
		p.current = !0;
		try {
			e();
		} finally {
			p.current = !1;
		}
	}, []), y = i(() => {
		p.current || m.current !== null || (m.current = window.requestAnimationFrame(() => {
			m.current = null, g();
		}));
	}, [g]);
	o(() => {
		g();
		let e = ({ node: e }) => {
			(e === n || e?.id === n.id) && y();
		};
		return n.emitter.on("onNodeChange", e), n.emitter.on("onReloadPage", y), () => {
			n.emitter.off("onNodeChange", e), n.emitter.off("onReloadPage", y), m.current !== null && (window.cancelAnimationFrame(m.current), m.current = null);
		};
	}, [
		n,
		e.activeTab,
		y,
		g
	]);
	let b = (e) => {
		let { normalProperty: t } = h();
		_(() => {
			n.value.style = [...t, ...e], n.updateValue();
		});
	}, x = (e) => {
		let { expressionProperty: t } = h();
		_(() => {
			n.value.style = [...e, ...t], n.updateValue();
		});
	};
	return /* @__PURE__ */ R("div", {
		className: bs.visualPanelBox,
		children: /* @__PURE__ */ z("div", {
			style: { marginBottom: "10px" },
			children: [
				/* @__PURE__ */ R(io, {
					ref: l,
					visualSizeDom: r,
					onValueChange: (e) => {
						x(Pn(e));
					}
				}),
				/* @__PURE__ */ R(v, {
					bordered: !1,
					style: { marginBottom: "10px" },
					defaultActiveKey: ["origin-css-edit"],
					onChange: (e) => {
						e.length && g();
					},
					items: [{
						key: "origin-css-edit",
						label: /* @__PURE__ */ R("span", {
							className: bs.header,
							children: "Style Variable"
						}),
						children: /* @__PURE__ */ R(Os, {
							ref: t,
							initialValue: h().expressionProperty,
							onValueChange: (e) => {
								b(e);
							}
						})
					}]
				}),
				/* @__PURE__ */ R("div", {
					style: { paddingTop: "10px" },
					children: /* @__PURE__ */ R(As, {
						nodeModel: e.node,
						initialValue: s,
						ref: f,
						pluginContext: e.pluginCtx,
						onValueChange: (e) => {
							_(() => {
								n.value.classNames = e, n.updateValue();
							});
						}
					})
				}),
				/* @__PURE__ */ R(Is, {
					handler: c,
					onValueChange: (e) => {
						_(() => {
							n.value.css = Vn(`c_${n.id}`, e), n.updateValue();
						});
					},
					responsiveSizes: e.pluginCtx.engine.props.responsiveSizes
				})
			]
		})
	});
}, Rs = {
	key: "VisualPanelPlus",
	name: "Visual",
	view: ({ node: e, pluginCtx: t, activeTab: n }) => e ? /* @__PURE__ */ R(Ls, {
		node: e,
		pluginCtx: t,
		activeTab: n
	}) : /* @__PURE__ */ R(L, {}),
	show: (e) => e.node?.material?.value.advanceCustom?.rightPanel?.visual !== !1
}, zs = {
	eventBox: "_eventBox_1h00g_2",
	eventToolbar: "_eventToolbar_1h00g_7",
	eventSelect: "_eventSelect_1h00g_11",
	addButton: "_addButton_1h00g_14",
	eventList: "_eventList_1h00g_17",
	eventItem: "_eventItem_1h00g_20",
	eventContent: "_eventContent_1h00g_37"
}, Bs = [{
	label: "afterMount",
	value: mt
}, {
	label: "beforeDestroy",
	value: ht
}], Vs = (e) => {
	let { node: t } = e, { t: n } = Dt(), [r, i] = d([]), a = t?.value.eventListener;
	o(() => {
		let e = t?.material?.value.events?.map((e) => typeof e == "string" ? {
			label: e,
			value: e
		} : {
			label: e.name || e.event,
			value: e.event
		}) || [];
		i([...Bs.map((e) => ({
			...e,
			label: n(e.label)
		})), ...e]);
	}, [
		t?.id,
		t?.material?.value.events,
		n
	]);
	let [s, c] = d();
	return t ? /* @__PURE__ */ z("div", {
		className: zs.eventBox,
		children: [/* @__PURE__ */ z("div", {
			className: zs.eventToolbar,
			children: [/* @__PURE__ */ R(j, {
				value: s,
				showSearch: !0,
				placeholder: n("selectEvent"),
				optionFilterProp: "label",
				onChange: (e) => {
					c(e);
				},
				allowClear: !0,
				className: zs.eventSelect,
				options: r
			}), /* @__PURE__ */ R(h, {
				type: "primary",
				className: zs.addButton,
				onClick: () => {
					let e = s;
					e && (t.value.eventListener = [...t.value.eventListener || [], {
						name: e,
						func: {
							type: "ACTION",
							handler: [],
							params: []
						}
					}], t.updateValue(), c(void 0));
				},
				children: n("add")
			})]
		}), /* @__PURE__ */ R("div", {
			className: zs.eventList,
			children: a?.map((n, i) => {
				let a = r.find((e) => e.value === n.name);
				return /* @__PURE__ */ z("div", {
					className: zs.eventItem,
					children: [/* @__PURE__ */ R("div", {
						className: zs.eventContent,
						children: /* @__PURE__ */ R(ss, {
							value: n.func,
							onValueChange: (e) => {
								n.func.handler = e.handler, t?.updateValue();
							},
							setterContext: {
								pluginCtx: e.pluginCtx,
								onSetterChange: () => {},
								keyPaths: [""],
								label: "",
								nodeModel: t
							},
							children: /* @__PURE__ */ R("span", { children: a?.label || n.name })
						})
					}), /* @__PURE__ */ R(h, {
						type: "text",
						size: "small",
						danger: !0,
						icon: /* @__PURE__ */ R(me, {}),
						onClick: (e) => {
							e.stopPropagation();
							let n = [...t?.value.eventListener || []];
							n.splice(i, 1), t.value.eventListener = n, t?.updateValue();
						}
					})]
				}, i);
			})
		})]
	}) : /* @__PURE__ */ R(L, {});
}, Hs = {
	key: "Event",
	name: "Event",
	view: ({ node: e, pluginCtx: t }) => e ? /* @__PURE__ */ R(Vs, {
		node: e,
		pluginCtx: t
	}) : /* @__PURE__ */ R(L, {}),
	show: (e) => e.node?.material?.value.advanceCustom?.rightPanel?.advance !== !1
}, Us = class extends e.Component {
	constructor(e) {
		super(e), this.state = {
			node: e.pluginCtx.engine.getActiveNode(),
			activeKey: "Visual",
			panels: [
				ds,
				Rs,
				Hs,
				ms,
				vs
			],
			displayPanels: []
		};
	}
	addPanel = (e) => {
		let t = [...this.state.panels, e];
		this.setState({ panels: t }), this.updatePanels();
	};
	removePanel = (e) => {
		let t = this.state.panels.filter((t) => t.name !== e);
		this.setState({ panels: t }), this.updatePanels();
	};
	replacePanel = (e, t) => {
		let n = this.state.panels.findIndex((t) => t.name === e), r = [...this.state.panels];
		n > -1 && (r[n] = t), this.setState({ panels: r }), this.updatePanels();
	};
	choosePanel = (e) => {
		this.setState({ activeKey: e }), this.updatePanels();
	};
	updatePanels = () => {
		let { pluginCtx: e } = this.props, { node: t, panels: n } = this.state, r = n, i = {
			panels: [],
			displayPanels: []
		};
		if (t) {
			let n = {
				node: t,
				pluginCtx: e,
				activeTab: this.state.activeKey
			}, a = r.filter((e) => e.show === void 0 || e.show(n)), o = t.material?.value.advanceCustom?.rightPanel?.customTabs || [];
			a.concat(o), i = {
				panels: r,
				displayPanels: a
			};
		} else i = {
			panels: r,
			displayPanels: []
		};
		return this.setState(i), i;
	};
	onNodeChange = ({ node: e }) => {
		let { pluginCtx: t } = this.props, { panels: n, activeKey: r } = this.state, i = {
			node: e,
			pluginCtx: t,
			activeTab: this.state.activeKey
		}, a = n.filter((e) => e.show === void 0 || e.show(i)), o = a.find((e, t) => t === 0)?.key || "";
		a.find((e) => e.key === r) ? this.setState({
			node: e,
			displayPanels: a
		}) : this.setState({
			activeKey: o,
			node: e,
			displayPanels: a
		});
	};
	componentDidMount() {
		let { pluginCtx: e } = this.props;
		e.globalEmitter.on("onSelectNodeChange", (e) => {
			setTimeout(() => {
				this.onNodeChange(e);
			}, 10);
		}), e.pageModel.emitter.on("*", () => {
			let t = e.engine.getActiveNode();
			this.onNodeChange({ node: t });
		});
		let { displayPanels: t } = this.updatePanels(), n = t.find((e, t) => t === 0)?.key || "";
		t.find((e) => e.key === this.state.activeKey) || this.setState({ activeKey: n }), e.pluginReadyOk();
	}
	render() {
		let { displayPanels: e, node: t, activeKey: n } = this.state, { pluginCtx: r } = this.props;
		if (!t) return /* @__PURE__ */ R("div", {
			className: ys.emptyPanel,
			children: /* @__PURE__ */ R(C, {
				image: C.PRESENTED_IMAGE_SIMPLE,
				description: "Please select a node from left view"
			})
		});
		let i = {
			node: t,
			pluginCtx: r,
			activeTab: this.state.activeKey
		}, a = r.config?.customPropertySetterMap;
		return /* @__PURE__ */ R(ws.Provider, {
			value: {
				customSetterMap: { ...a },
				defaultSetterConfig: {},
				nodeId: this.state.node?.id,
				nodeModel: this.state.node,
				pluginCtx: this.props.pluginCtx
			},
			children: /* @__PURE__ */ R("div", {
				className: ys.rightPanelContainer,
				children: /* @__PURE__ */ R(ne, {
					activeKey: n,
					tabPosition: "top",
					style: {
						flex: 1,
						height: "100%"
					},
					onChange: (e) => {
						this.setState({ activeKey: e });
					},
					items: e.map((e) => ({
						label: /* @__PURE__ */ R("div", {
							className: ys.tabLabel,
							children: typeof e.name == "string" ? e.name : e.name?.(i)
						}),
						key: e.key,
						children: e.view(i)
					}))
				})
			})
		});
	}
}, Ws = "RightPanel", Gs = () => {
	let t = e.createRef();
	return {
		name: Ws,
		PLUGIN_NAME: Ws,
		async init(e) {
			e.getWorkbench().replaceRightView(/* @__PURE__ */ R(Us, {
				ref: t,
				pluginCtx: e
			}));
		},
		async destroy() {},
		export: () => t?.current,
		meta: { engine: { version: "1.0.0" } }
	};
};
Gs.PLUGIN_NAME = Ws;
//#endregion
//#region src/plugins/GlobalStatePanel/localize/index.ts
var Ks = {
	zh_CN: { pluginName: "全局状态" },
	en_US: { pluginName: "Global State" }
}, qs = { box: "_box_1ypoq_2" }, Js = "GlobalState", Ys = `plugin:${Js}`, Xs = !1, Zs = (e) => {
	let { pluginCtx: t } = e, n = t.pageModel.value.componentsTree.value.state || {}, r = u(null);
	return o(() => {
		r?.current?.setValue(JSON.stringify(n, null, 2)), t.pageModel.emitter.on("onReloadPage", () => {
			if (Xs) {
				Xs = !1;
				return;
			}
			r.current?.setValue(JSON.stringify(t.pageModel.value.componentsTree.value.state, null, 2));
		});
	}, []), /* @__PURE__ */ R("div", {
		className: qs.box,
		children: /* @__PURE__ */ R(Br, {
			initialValue: JSON.stringify(t.pageModel.value.componentsTree.value.state, null, 2),
			language: "json",
			options: {
				automaticLayout: !0,
				tabSize: 2,
				minimap: { enabled: !1 },
				quickSuggestions: !1,
				suggestOnTriggerCharacters: !1,
				folding: !1,
				comments: {}
			},
			onDidMount: (e) => {
				r.current = e;
			},
			beforeMount: () => {},
			onChange: (e) => {
				try {
					let n = JSON.parse(e || "{}");
					t.pageModel.value.componentsTree.value.state = n, Xs = !0, t.pageModel.value.componentsTree.updateValue();
				} catch (e) {
					console.warn(e);
				}
			}
		})
	});
}, Qs = {
	name: Js,
	async init(e) {
		let { i18n: t } = e;
		Object.keys(Ks).forEach((e) => {
			t.addResourceBundle(e, Ys, Ks[e], !0, !0);
		});
		let n = Ot(Ys)(Zs), r = Ot(Ys)(({ t: e }) => /* @__PURE__ */ R(L, { children: e("pluginName") }));
		e.getWorkbench().addLeftPanel({
			title: /* @__PURE__ */ R(r, {}),
			name: Js,
			icon: /* @__PURE__ */ R(pe, {}),
			render: /* @__PURE__ */ R(n, { pluginCtx: e })
		});
	},
	async destroy() {},
	export: () => ({}),
	meta: { engine: { version: "1.0.0" } }
};
Qs.PLUGIN_NAME = Js;
//#endregion
//#region src/plugins/DisplaySourceSchema/index.tsx
var $s = (e) => {
	let t = e.pageModel.export(), { engineCtx: n } = e, [r, i] = d(!1), a = u(null);
	return /* @__PURE__ */ z(L, { children: [/* @__PURE__ */ R("div", {
		onClick: () => {
			i(!0);
		},
		children: e.children
	}), /* @__PURE__ */ R(E, {
		open: r,
		title: "Source Schema",
		width: "100%",
		onCancel: () => i(!1),
		onOk: async () => {
			i(!1);
			let t = a.current?.getValue();
			if (!t) return;
			let r = JSON.parse(t);
			e.pageModel.updatePage(r), await H();
			let o = n.engine.getActiveNode(), s = await n.pluginManager.get("Designer"), c = o?.id || "";
			s?.ctx.emitter.on("ready", () => {
				s.export.selectNode(c);
			}), s && s.export.selectNode(c);
		},
		style: {
			height: "calc(100vh - 50px)",
			top: "25px"
		},
		destroyOnHidden: !0,
		children: /* @__PURE__ */ R("div", {
			style: {
				width: "100%",
				height: "calc(100vh - 200px)"
			},
			children: /* @__PURE__ */ R(Br, {
				initialValue: JSON.stringify(t, null, 2),
				language: "json",
				options: { automaticLayout: !0 },
				onDidMount: (e) => {
					a.current = e;
				}
			})
		})
	})] });
}, ec = "History", tc = (e) => {
	let t = e, n = {
		historyRecords: [],
		currentStepIndex: 0
	}, r = null, i = e.pageModel.export();
	r = i, n.historyRecords.push(i);
	let a = async (e) => {
		t && (t.pageModel.reloadPage(e), await H());
	}, o = {
		addStep: () => {
			let { currentStepIndex: t, historyRecords: r } = n, i = e.pageModel.export();
			t !== r.length - 1 && (n.historyRecords = r.slice(0, t + 1)), n.historyRecords.push(i), n.currentStepIndex = r.length - 1;
		},
		reset: async () => {
			if (!t) {
				console.warn("plugin ctx is null, pls check it");
				return;
			}
			r && (n.historyRecords = [], a(r));
		},
		preStep: () => {
			let { currentStepIndex: e, historyRecords: t } = n;
			if (!o.canGoPreStep()) return;
			let r = e - 1;
			n.currentStepIndex = r;
			let i = it(t[r]);
			a(i);
		},
		nextStep: () => {
			if (!o.canGoNextStep()) return;
			let { currentStepIndex: e, historyRecords: t } = n, r = e + 1;
			n.currentStepIndex = r;
			let i = it(t[r]);
			return a(i);
		},
		canGoPreStep: () => {
			let { currentStepIndex: e } = n;
			return !(e <= 0);
		},
		canGoNextStep: () => {
			let { currentStepIndex: e, historyRecords: t } = n;
			return !(e >= t.length - 1);
		}
	}, s = at(() => {
		o.addStep();
	}, 500);
	return {
		name: ec,
		PLUGIN_NAME: ec,
		async init(e) {
			e.pageModel.emitter.on("onNodeChange", () => {
				s();
			}), e.pageModel.emitter.on("onPageChange", () => {
				o.addStep();
			}), e.pluginReadyOk();
		},
		async destroy(e) {
			console.log("destroy", e);
		},
		export: () => o,
		meta: { engine: { version: "1.0.0" } }
	};
};
tc.PLUGIN_NAME = ec;
//#endregion
//#region src/plugins/Hotkeys/keymap.ts
var nc = typeof navigator < "u" && navigator.userAgent.toLowerCase().indexOf("firefox") > 0, rc = {
	backspace: 8,
	"⌫": 8,
	tab: 9,
	clear: 12,
	enter: 13,
	"↩": 13,
	return: 13,
	esc: 27,
	escape: 27,
	space: 32,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
	del: 46,
	delete: 46,
	ins: 45,
	insert: 45,
	home: 36,
	end: 35,
	pageup: 33,
	pagedown: 34,
	capslock: 20,
	num_0: 96,
	num_1: 97,
	num_2: 98,
	num_3: 99,
	num_4: 100,
	num_5: 101,
	num_6: 102,
	num_7: 103,
	num_8: 104,
	num_9: 105,
	num_multiply: 106,
	num_add: 107,
	num_enter: 108,
	num_subtract: 109,
	num_decimal: 110,
	num_divide: 111,
	"⇪": 20,
	",": 188,
	".": 190,
	"/": 191,
	"`": 192,
	"-": nc ? 173 : 189,
	"=": nc ? 61 : 187,
	";": nc ? 59 : 186,
	"'": 222,
	"[": 219,
	"]": 221,
	"\\": 220
}, ic = {
	"⇧": 16,
	shift: 16,
	"⌥": 18,
	alt: 18,
	option: 18,
	"⌃": 17,
	ctrl: 17,
	control: 17,
	"⌘": 91,
	cmd: 91,
	command: 91
};
for (let e = 1; e < 20; e++) rc[`f${e}`] = 111 + e;
var ac = (e) => rc[e.toLowerCase()] || ic[e.toLowerCase()] || e.toUpperCase().charCodeAt(0), oc = (e) => Object.keys(rc).find((t) => rc[t] === e), sc = (e) => Object.keys(ic).find((t) => ic[t] === e), cc = (e) => oc(e) || sc(e) || String.fromCharCode(e), lc = class {
	splitStr = "_";
	downKeyCodeSet = /* @__PURE__ */ new Set();
	elements;
	disposeEventCbList = [];
	customGetKeyCodeByEvent;
	disable = !1;
	hotActionMap = {};
	constructor(e) {
		this.elements = e.elements, this.customGetKeyCodeByEvent = e.customGetKeyCodeByEvent, this.init();
	}
	setDisable(e) {
		this.disable = e;
	}
	init() {
		let e = this.elements.map((e) => this.registerKeyEvent(e));
		this.disposeEventCbList = [...e];
	}
	addElement(e) {
		let t = this.registerKeyEvent(e);
		this.disposeEventCbList.push(t);
	}
	registerKeyEvent(e) {
		let t = this.getTriggerHotkeyDebounce(), n = (e) => {
			let n = this.getKeyCodeByEvent(e);
			n !== this.getKeyCodeByLabel("escape") && this.filterInputElement(e) || this.downKeyCodeSet.has(n) || (this.downKeyCodeSet.add(n), t());
		};
		e?.addEventListener("keydown", n);
		let r = (e) => {
			this.downKeyCodeSet.delete(this.getKeyCodeByEvent(e));
		};
		e?.addEventListener("keyup", r);
		let i = () => {
			this.downKeyCodeSet.clear();
		};
		return window?.addEventListener("blur", i), () => {
			e.removeEventListener("keydown", n), e.removeEventListener("keyup", r), window?.removeEventListener("blur", i);
		};
	}
	addHotAction(e, t) {
		let n = this.normalizeKeyCodes(e.map((e) => typeof e == "number" ? e : this.getKeyCodeByLabel(e)));
		this.hotActionMap[n.join(this.splitStr)] = () => {
			this.disable || t();
		};
	}
	triggerHotKey() {
		let e = this.normalizeKeyCodes(this.downKeyCodeSet).join(this.splitStr), t = this.hotActionMap[e];
		t?.();
	}
	normalizeKeyCodes(e) {
		return Array.from(e).sort((e, t) => e - t);
	}
	getTriggerHotkeyDebounce() {
		return this.triggerHotKey.bind(this);
	}
	getKeyCodeByLabel(e) {
		return ac(e);
	}
	getKeyCodeByEvent(e) {
		if (this.customGetKeyCodeByEvent) return this.customGetKeyCodeByEvent(e);
		let t = {
			" ": "space",
			ArrowDown: "down",
			ArrowLeft: "left",
			ArrowRight: "right",
			ArrowUp: "up",
			Backspace: "backspace",
			Tab: "tab",
			Control: "ctrl",
			Alt: "alt",
			Meta: "cmd",
			CapsLock: "capslock",
			Delete: "delete",
			Escape: "escape",
			Enter: "enter",
			Shift: "shift"
		}[e.key];
		if (t) return ac(t);
		if (e.key.length === 1) return ac(e.key);
		if (/^F([1-9]|1[0-9])$/.test(e.key)) return ac(e.key.toLowerCase());
		let n = {
			ArrowDown: "down",
			ArrowLeft: "left",
			ArrowRight: "right",
			ArrowUp: "up",
			Backspace: "backspace",
			ControlLeft: "ctrl",
			ControlRight: "ctrl",
			Delete: "delete",
			Enter: "enter",
			Escape: "escape",
			ShiftLeft: "shift",
			ShiftRight: "shift"
		}, r = n[e.code] ?? e.code;
		return /^Key[A-Z]$/.test(r) ? r.charCodeAt(3) : /^Digit[0-9]$/.test(r) ? r.charCodeAt(5) : n[e.code] ? ac(r) : e.keyCode || e.which || e.charCode;
	}
	getKeyString(e) {
		return cc(e);
	}
	filterInputElement(e) {
		let t = e.target || e.srcElement;
		if (!t) return !1;
		let { tagName: n } = t, r = !1, i = n === "INPUT" && ![
			"checkbox",
			"radio",
			"range",
			"button",
			"file",
			"reset",
			"submit",
			"color"
		].includes(t.type);
		return (t.isContentEditable || (i || n === "TEXTAREA" || n === "SELECT") && !t.readOnly) && (r = !0), r;
	}
	destroy() {
		this.disposeEventCbList.forEach((e) => e());
	}
}, uc = {
	zh_CN: { pluginName: "快捷键" },
	en_US: { pluginName: "Hot Keys" }
}, Q = {
	clearSelect: async (e) => {
		(await e.pluginManager.get("Designer"))?.export.clearSelectNode();
	},
	deleteNode: async (e) => {
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode();
		if (n) {
			let e = await t?.export?.deleteNode(n.id);
			return e || ae.error("该节点不能删除"), e;
		}
	},
	copyNode: async (e) => {
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode();
		if (n) return await t?.export?.copyNode(n.id);
	},
	moveToUp: async (e) => {
		if (await Q.moveToSiblingUp(e)) return;
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode()?.parent;
		if (n && n.nodeType !== "PAGE") return await t?.export?.selectNode(n.id);
	},
	moveToSiblingUp: async (e) => {
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode(), r = n?.parent;
		if (r?.nodeType === "PAGE" || !n) return;
		let i = r?.value, a = i.children || i.value, o = a.findIndex((e) => e.id === n.id) - 1;
		if (o < 0) return;
		let s = a?.[o];
		if (s && s.id) return await t?.export?.selectNode(s.id);
	},
	moveToDown: async (e) => {
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode()?.value.children?.[0];
		return n && n.id ? await t?.export?.selectNode(n.id) : await Q.moveToSiblingDown(e);
	},
	moveToSiblingDown: async (e) => {
		let t = await e.pluginManager.get("Designer"), n = e.engine.getActiveNode(), r = n?.parent;
		if (r?.nodeType === "PAGE" || !n) return;
		let i = r?.value, a = i.children || i.value, o = a.findIndex((e) => e.id === n.id) + 1;
		if (o >= a.length) return;
		let s = a?.[o];
		if (s && s.id) return await t?.export?.selectNode(s.id);
	},
	redo: async (e) => {
		let t = await e.pluginManager.get("History");
		if (t?.export.canGoNextStep()) return t?.export.nextStep(), !0;
	},
	undo: async (e) => {
		let t = await e.pluginManager.get("History");
		if (t?.export.canGoPreStep()) return t?.export.preStep(), !0;
	}
}, dc = "Hotkeys", fc = `plugin:${dc}`, pc = {
	name: dc,
	PLUGIN_NAME: dc,
	async init(e) {
		let { i18n: t } = e;
		Object.keys(uc).forEach((e) => {
			t.addResourceBundle(e, fc, uc[e], !0, !0);
		});
		let n = await e.pluginManager.get("Designer"), r = n?.export.getDesignerWindow(), i = new lc({ elements: [window.document.body, r.document.body] });
		e.engine.pageModel.emitter.on("onReloadPage", () => {
			let e = n?.export.getDesignerWindow();
			setTimeout(() => {
				i.addElement(e.document.body);
			}, 1e3);
		}), i.addHotAction(["ctrl", "c"], () => {
			Q.copyNode(e);
		}), i.addHotAction(["ctrl", "z"], () => {
			Q.undo(e);
		}), i.addHotAction([
			"ctrl",
			"shift",
			"z"
		], () => {
			Q.redo(e);
		}), i.addHotAction(["up"], () => {
			Q.moveToUp(e);
		}), i.addHotAction(["w"], () => {
			Q.moveToUp(e);
		}), i.addHotAction(["alt", "w"], () => {
			Q.moveToSiblingUp(e);
		}), i.addHotAction(["alt", "up"], () => {
			Q.moveToSiblingUp(e);
		}), i.addHotAction([93, "up"], () => {
			Q.moveToSiblingUp(e);
		}), i.addHotAction(["down"], () => {
			Q.moveToDown(e);
		}), i.addHotAction(["s"], () => {
			Q.moveToDown(e);
		}), i.addHotAction(["alt", "s"], () => {
			Q.moveToSiblingDown(e);
		}), i.addHotAction(["alt", "down"], () => {
			Q.moveToSiblingDown(e);
		}), i.addHotAction([93, "down"], () => {
			Q.moveToSiblingDown(e);
		}), i.addHotAction(["backspace"], () => {
			Q.deleteNode(e);
		}), i.addHotAction(["escape"], () => {
			Q.clearSelect(e);
		}), e.hotkeyManager = i, e.pluginReadyOk();
	},
	async destroy(e) {
		e.hotkeyManager?.destroy();
	},
	export: (e) => ({
		addHotAction: (t, n) => {
			e.hotkeyManager.addHotAction(t, n);
		},
		disable: (t) => {
			e.hotkeyManager.setDisable(t);
		}
	}),
	meta: { engine: { version: "1.0.0" } }
};
pc.PLUGIN_NAME = dc;
var $ = {
	panel: "_panel_xe8fj_2",
	collapsed: "_collapsed_xe8fj_17",
	fullScreen: "_fullScreen_xe8fj_21",
	header: "_header_xe8fj_31",
	action: "_action_xe8fj_43",
	title: "_title_xe8fj_53",
	chevron: "_chevron_xe8fj_61",
	chevronExpanded: "_chevronExpanded_xe8fj_70",
	connectionStatus: "_connectionStatus_xe8fj_74",
	connected: "_connected_xe8fj_80",
	disconnected: "_disconnected_xe8fj_85",
	count: "_count_xe8fj_90",
	actions: "_actions_xe8fj_100",
	iconButton: "_iconButton_xe8fj_114",
	content: "_content_xe8fj_130",
	empty: "_empty_xe8fj_137",
	item: "_item_xe8fj_144",
	meta: "_meta_xe8fj_149",
	message: "_message_xe8fj_157",
	stack: "_stack_xe8fj_158",
	debug: "_debug_xe8fj_175",
	info: "_info_xe8fj_176",
	log: "_log_xe8fj_177",
	warn: "_warn_xe8fj_181",
	error: "_error_xe8fj_185",
	exception: "_exception_xe8fj_186",
	unhandledrejection: "_unhandledrejection_xe8fj_187"
}, mc = "PageRuntimeLog", hc = 300, gc = (e) => !e || typeof e != "object" ? !1 : e instanceof Error || Object.prototype.toString.call(e) === "[object Error]" || typeof e.message == "string" && (typeof e.stack == "string" || typeof e.name == "string"), _c = (e) => {
	if (gc(e)) {
		let t = typeof e.name == "string" ? e.name : "Error", n = typeof e.message == "string" ? e.message : "";
		return n ? `${t}: ${n}` : t;
	}
	if (typeof e == "string") try {
		return JSON.stringify(JSON.parse(e), null, 2);
	} catch {
		return e;
	}
	try {
		return JSON.stringify(e, null, 2) ?? String(e);
	} catch {
		return String(e);
	}
}, vc = class {
	connected = !1;
	entries = [];
	maxEntries;
	restoreRuntimeConnection = null;
	subscribers = /* @__PURE__ */ new Set();
	constructor(e = hc) {
		this.maxEntries = Math.min(Math.max(e, 1), hc);
	}
	getSnapshot = () => ({
		connected: this.connected,
		entries: this.entries
	});
	subscribe = (e) => (this.subscribers.add(e), () => {
		this.subscribers.delete(e);
	});
	clear = () => {
		this.entries = [], this.notify();
	};
	disconnect = () => {
		this.restoreRuntimeConnection?.(), this.restoreRuntimeConnection = null;
	};
	connect = (e) => {
		this.disconnect();
		let t = e.console, n = {
			debug: t.debug.bind(t),
			info: t.info.bind(t),
			log: t.log.bind(t),
			warn: t.warn.bind(t),
			error: t.error.bind(t)
		}, r = (e) => {
			let t = e.error;
			this.append({
				level: "exception",
				message: e.message || _c(t) || "Unknown page runtime error",
				stack: gc(t) && typeof t.stack == "string" ? t.stack : void 0
			});
		}, i = (e) => {
			let t = e.reason;
			this.append({
				level: "unhandledrejection",
				message: _c(t) || "Unhandled promise rejection",
				stack: gc(t) && typeof t.stack == "string" ? t.stack : void 0
			});
		};
		Object.keys(n).forEach((e) => {
			t[e] = (...t) => {
				n[e](...t), this.append({
					level: e,
					message: t.map(_c).join(" "),
					stack: t.find(gc) && typeof t.find(gc)?.stack == "string" ? t.find(gc)?.stack : void 0
				});
			};
		}), e.addEventListener("error", r), e.addEventListener("unhandledrejection", i), this.connected = !0, this.notify(), this.restoreRuntimeConnection = () => {
			e.removeEventListener("error", r), e.removeEventListener("unhandledrejection", i), Object.keys(n).forEach((e) => {
				t[e] = n[e];
			}), this.connected = !1, this.notify();
		};
	};
	append(e) {
		this.entries = [...this.entries, {
			...e,
			id: `${Date.now()}-${Math.random()}`,
			timestamp: Date.now()
		}].slice(-this.maxEntries), this.notify();
	}
	notify() {
		this.subscribers.forEach((e) => e());
	}
}, yc = ({ className: t, defaultCollapsed: n = !0, runtimeWindow: r, store: i }) => {
	let a = e.useRef(null);
	a.current ||= new vc();
	let o = i || a.current, [s, c] = e.useState(o.getSnapshot()), [l, u] = e.useState(n), [d, f] = e.useState(!1), p = s.entries.filter((e) => [
		"warn",
		"error",
		"exception",
		"unhandledrejection"
	].includes(e.level)).length;
	e.useEffect(() => o.subscribe(() => c(o.getSnapshot())), [o]), e.useEffect(() => {
		if (!i) {
			if (!r) {
				o.disconnect();
				return;
			}
			return o.connect(r), () => o.disconnect();
		}
	}, [
		i,
		r,
		o
	]);
	let m = () => {
		u((e) => (e || f(!1), !e));
	};
	return /* @__PURE__ */ z("section", {
		className: `${$.panel} ${l ? $.collapsed : ""} ${d ? $.fullScreen : ""} ${t || ""}`,
		children: [/* @__PURE__ */ z("div", {
			className: $.header,
			role: "button",
			tabIndex: 0,
			"aria-expanded": !l,
			onClick: m,
			onKeyDown: (e) => {
				(e.key === "Enter" || e.key === " ") && (e.preventDefault(), m());
			},
			children: [/* @__PURE__ */ z("div", {
				className: $.title,
				children: [
					/* @__PURE__ */ R("span", { className: `${$.chevron} ${l ? "" : $.chevronExpanded}` }),
					/* @__PURE__ */ R("span", { className: `${$.connectionStatus} ${s.connected ? $.connected : $.disconnected}` }),
					/* @__PURE__ */ R("span", { children: "PageRuntimeLog" }),
					p > 0 && /* @__PURE__ */ R("span", {
						className: $.count,
						children: p
					})
				]
			}), /* @__PURE__ */ z("div", {
				className: $.actions,
				children: [/* @__PURE__ */ R("button", {
					type: "button",
					className: $.iconButton,
					"aria-label": d ? "还原日志面板" : "全屏日志面板",
					title: d ? "还原" : "全屏",
					onClick: (e) => {
						e.stopPropagation(), u(!1), f((e) => !e);
					},
					children: R(d ? ye : be, {})
				}), /* @__PURE__ */ R("button", {
					type: "button",
					className: $.action,
					onClick: (e) => {
						e.stopPropagation(), o.clear();
					},
					children: "清空"
				})]
			})]
		}), !l && /* @__PURE__ */ R("div", {
			className: $.content,
			children: s.entries.length === 0 ? /* @__PURE__ */ R("div", {
				className: $.empty,
				children: "暂无页面运行日志"
			}) : s.entries.map((e) => /* @__PURE__ */ z("article", {
				className: $.item,
				children: [
					/* @__PURE__ */ z("div", {
						className: $.meta,
						children: [/* @__PURE__ */ R("span", { children: new Date(e.timestamp).toLocaleTimeString() }), /* @__PURE__ */ R("span", {
							className: $[e.level],
							children: e.level
						})]
					}),
					/* @__PURE__ */ R("pre", {
						className: $.message,
						children: e.message
					}),
					e.stack && /* @__PURE__ */ R("pre", {
						className: $.stack,
						children: e.stack
					})
				]
			}, e.id))
		})]
	});
}, bc = (e) => {
	let t = new vc(e.config.maxEntries), n;
	return {
		name: mc,
		PLUGIN_NAME: mc,
		async init(e) {
			let r = await e.pluginManager.get("Designer");
			r && (r.export.setCanvasFooterView(/* @__PURE__ */ R(yc, {
				store: t,
				defaultCollapsed: e.config.defaultCollapsed
			})), n = r.export.subscribePageRuntime((e) => {
				e ? t.connect(e) : t.disconnect();
			})), e.pluginReadyOk();
		},
		async destroy(e) {
			n?.(), t.disconnect(), (await e.pluginManager.get("Designer"))?.export.setCanvasFooterView(null);
		},
		export: () => ({
			clear: t.clear,
			getSnapshot: t.getSnapshot,
			store: t
		}),
		meta: { engine: { version: "1.0.0" } }
	};
};
bc.PLUGIN_NAME = mc;
//#endregion
//#region src/plugins/index.tsx
var xc = /* @__PURE__ */ kn({
	AdvancePanel: () => _s,
	AdvancePanelConfig: () => vs,
	CANVAS_SIZE_OFFSET: () => 0,
	ComponentLibPlugin: () => Lr,
	ComponentStatePanel: () => ps,
	ComponentStatePanelConfig: () => ms,
	DEFAULT_PLUGIN_LIST: () => Sc,
	DEFAULT_PLUGIN_NAME_MAP: () => Cc,
	DRAG_ITEM_KEY: () => Er,
	DesignerPlugin: () => ii,
	DisplaySourceSchema: () => $s,
	DragComponent: () => Dr,
	DragComponentItem: () => Or,
	GlobalStatePanelPlugin: () => Qs,
	HistoryPlugin: () => tc,
	HotkeysPlugin: () => pc,
	OutlineTreePlugin: () => wi,
	PAGE_RUNTIME_LOG_PLUGIN_NAME: () => mc,
	PLUGIN_NAME: () => Nr,
	PageRuntimeLog: () => yc,
	PageRuntimeLogPlugin: () => bc,
	PageRuntimeLogStore: () => vc,
	PropertyPanel: () => us,
	PropertyPanelConfig: () => ds,
	RightPanelPlugin: () => Gs,
	VisualPanelPlus: () => Ls,
	VisualPanelPlusConfig: () => Rs
}), Sc = [
	ii,
	bc,
	wi,
	Lr,
	Qs,
	Gs,
	tc,
	pc
], Cc = {
	HotkeysPlugin: pc.PLUGIN_NAME,
	ComponentLibPlugin: Lr.PLUGIN_NAME,
	RightPanelPlugin: Gs.PLUGIN_NAME,
	GlobalStatePanelPlugin: Qs.PLUGIN_NAME,
	HistoryPlugin: tc.PLUGIN_NAME,
	DesignerPlugin: ii.PLUGIN_NAME,
	OutlineTreePlugin: wi.PLUGIN_NAME,
	PageRuntimeLogPlugin: bc.PLUGIN_NAME
}, wc = [{
	name: "style",
	title: "布局",
	valueType: "string",
	setters: [{
		componentName: "FastLayoutSetter",
		initialValue: {},
		hiddenLabel: !0,
		props: {}
	}]
}], Tc = {
	name: "$$attributes",
	title: "属性",
	valueType: "object",
	setters: [{
		componentName: "ArraySetter",
		props: {
			collapse: { open: !0 },
			sortLabelKey: "key",
			item: {
				setters: [{
					componentName: "ShapeSetter",
					props: { elements: [{
						name: "key",
						title: "属性名",
						valueType: "string",
						setters: ["StringSetter"]
					}, {
						name: "value",
						title: "值",
						valueType: "string",
						setters: [
							"StringSetter",
							"NumberSetter",
							"JSONSetter",
							"FunctionSetter",
							"ExpressionSetter"
						]
					}] },
					initialValue: {}
				}],
				initialValue: {}
			}
		},
		initialValue: []
	}]
}, Ec = "内置组件", Dc = "原子组件", Oc = "1.0.0", kc = "CHAMELEON_INNER_PKG", Ac = Ue.map((e) => ({
	title: rt(e),
	componentName: e,
	props: [Tc],
	snippets: [],
	npm: {
		name: e,
		package: kc,
		version: Oc
	}
})), jc = [
	{
		title: "块",
		componentName: "CBlock",
		enableNodeSizeChange: !0,
		props: [{
			name: "children",
			title: "文本",
			valueType: "string",
			setters: ["StringSetter", "ExpressionSetter"]
		}, Tc],
		groupName: Ec,
		snippets: [{
			title: "块",
			snapshotText: "Block",
			category: Dc,
			schema: {
				props: {},
				css: { value: [{
					state: "normal",
					media: [],
					text: "background: white ; width: 100%; height: 100px"
				}] }
			}
		}]
	},
	{
		title: "容器",
		componentName: "CContainer",
		enableNodeSizeChange: !0,
		isContainer: !0,
		props: [...wc, Tc],
		groupName: Ec,
		snippets: [{
			title: "容器",
			snapshotText: "Con",
			category: Dc,
			schema: { css: { value: [{
				state: "normal",
				media: [],
				text: "background: white;width: 100%;"
			}] } }
		}]
	},
	{
		title: "图片",
		componentName: "CImage",
		enableNodeSizeChange: !0,
		props: [{
			name: "src",
			title: "地址",
			valueType: "string",
			setters: ["StringSetter", "ExpressionSetter"]
		}, Tc],
		advanceCustom: { wrapComponent: (e) => (t) => /* @__PURE__ */ R(e, {
			...t,
			style: {
				...t.style || {},
				userSelect: "none",
				WebkitUserDrag: "none"
			}
		}) },
		groupName: Ec,
		snippets: [{
			title: "图片",
			snapshotText: "Img",
			category: Dc,
			schema: {
				css: { value: [{
					text: "background:white;width:500px;height:300px;overflow:auto;",
					media: [],
					state: "normal"
				}] },
				props: { src: "https://images.unsplash.com/photo-1584080277544-2db5b2c2d9dd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" }
			}
		}]
	},
	{
		title: "视频",
		componentName: "CVideo",
		enableNodeSizeChange: !0,
		props: [
			{
				name: "src",
				title: "地址",
				valueType: "string",
				setters: ["StringSetter", "ExpressionSetter"]
			},
			{
				name: "autoPlay",
				title: "自动播放",
				valueType: "string",
				setters: ["BooleanSetter", "ExpressionSetter"]
			},
			{
				name: "controls",
				title: "控制面板",
				valueType: "string",
				setters: ["BooleanSetter", "ExpressionSetter"]
			},
			Tc
		],
		fixedProps: { autoPlay: !1 },
		advanceCustom: { wrapComponent: (e) => (t) => /* @__PURE__ */ R("div", {
			style: {
				...t.style,
				display: "inline-flex"
			},
			children: /* @__PURE__ */ R(e, {
				...t,
				style: {
					...t.style,
					pointerEvents: "none"
				}
			})
		}) },
		groupName: Ec,
		snippets: [{
			title: "视频",
			snapshotText: "Video",
			category: Dc,
			schema: {
				props: { src: "https://vjs.zencdn.net/v/oceans.mp4" },
				css: { value: [{
					state: "normal",
					media: [],
					text: "background:white;width:300px;height:150px;"
				}] }
			}
		}]
	},
	{
		title: "音频",
		groupName: Ec,
		componentName: "CAudio",
		enableNodeSizeChange: !0,
		props: [
			{
				name: "src",
				title: "地址",
				valueType: "string",
				setters: ["StringSetter", "ExpressionSetter"]
			},
			{
				name: "autoPlay",
				title: "自动播放",
				valueType: "string",
				setters: ["BooleanSetter", "ExpressionSetter"]
			},
			{
				name: "controls",
				title: "控制面板",
				valueType: "string",
				setters: ["BooleanSetter", "ExpressionSetter"]
			},
			Tc
		],
		advanceCustom: { wrapComponent: () => (e) => /* @__PURE__ */ R("div", {
			style: {
				display: "inline-block",
				fontSize: 0
			},
			children: /* @__PURE__ */ R("audio", {
				...e,
				style: {
					pointerEvents: "none",
					...e.style
				}
			})
		}) },
		snippets: [{
			title: "音频",
			snapshotText: "Audio",
			category: Dc,
			schema: { props: {
				src: "https://vjs.zencdn.net/v/oceans.mp4",
				controls: !0
			} }
		}]
	},
	{
		title: "文本",
		componentName: "CText",
		groupName: Ec,
		props: [{
			name: "content",
			title: "内容",
			valueType: "string",
			setters: ["TextAreaSetter", "ExpressionSetter"]
		}, Tc],
		snippets: [{
			title: "文本",
			snapshotText: "Text",
			category: Dc,
			schema: { props: { content: "text" } }
		}]
	},
	{
		title: "Canvas",
		componentName: "CCanvas",
		enableNodeSizeChange: !0,
		props: [
			{
				name: "afterMount",
				title: "afterMount",
				valueType: "function",
				setters: [
					"FunctionSetter",
					"ExpressionSetter",
					"ActionFlowSetter"
				]
			},
			{
				name: "beforeDestroy",
				title: "beforeDestroy",
				valueType: "function",
				setters: ["FunctionSetter", "ExpressionSetter"]
			},
			Tc
		],
		groupName: Ec,
		advanceCustom: { onNewAdd: async (e) => {
			let t = e.getPlainProps(), n = Math.random().toString(32).slice(3, 9);
			return t.$$attributes = [{
				key: "id",
				value: n
			}, {
				key: "style",
				value: {
					display: "block",
					margin: "0 auto"
				}
			}], t.afterMount.value = t.afterMount.value.replace("$[id]", n), e.updateWithPlainObj({ props: t }), { addNode: e };
		} },
		snippets: [{
			title: "画布",
			snapshotText: "Cavs",
			category: Dc,
			schema: { props: {
				width: "600px",
				height: "150px",
				style: { margin: "0 auto" },
				afterMount: {
					type: "FUNCTION",
					value: "\n              function run () {\n                var ctx = document.getElementById(\"$[id]\").getContext(\"2d\");\n                ctx.font = \"48px serif\";\n                ctx.fillText(\"Hello Canvas\", 10, 50);\n              }\n              "
				}
			} }
		}]
	},
	{
		title: "HTML 标签",
		componentName: "CNativeTag",
		props: [{
			name: "htmlTag",
			title: "标签名",
			valueType: "string",
			setters: [{
				componentName: "SelectSetter",
				props: { options: Ue.map((e) => ({
					name: e,
					value: e
				})) }
			}]
		}, Tc],
		isContainer: !0,
		groupName: Ec,
		snippets: [{
			title: "HTML",
			snapshotText: "HTML",
			category: Dc,
			schema: { props: { htmlTag: "div" } }
		}]
	}
];
jc.forEach((e) => {
	e.events = Be;
});
var Mc = [...jc.map((e) => ({
	...e,
	npm: {
		name: e.componentName,
		package: kc,
		version: Oc
	}
})), ...Ac], Nc = class extends e.Component {
	static version = "0.12.7";
	currentSelectNode;
	pluginManager;
	workbenchRef = e.createRef();
	pageSchema;
	pageModel;
	material;
	emitter;
	assetsPackageListManager;
	workbenchConfig = {};
	onLanguageChanged = () => this.forceUpdate();
	_oldHiddenWidgetConfig;
	constructor(e) {
		super(e), this.pageSchema = e.schema, this.material = e.material, this.currentSelectNode = null, window.__CHAMELEON_ENG__ = this, this.assetsPackageListManager = new Gn(e.assetPackagesList || []), this.workbenchConfig = e.workbenchConfig || {}, dr(e.i18nResources), pr(e.locale), e.monacoEditor?.cndUrl && St.config({ paths: { vs: e.monacoEditor?.cndUrl } });
		try {
			this.pageModel = new ze(this.pageSchema, {
				materials: this.material || [],
				assetPackagesList: e.assetPackagesList || []
			});
		} catch (e) {
			console.error(e), this.pageModel = new ze(He);
		}
		this.emitter = Ie();
	}
	updateCurrentSelectNode(e) {
		let t = e?.id && this.pageModel.getNode(e.id) || e;
		this.currentSelectNode = t, this.emitter.emit("onSelectNodeChange", { node: t });
	}
	async componentDidMount() {
		window.__C_ENGINE__ = this, fr.on("languageChanged", this.onLanguageChanged);
		let e = this.props.plugins, t = new mr({
			engine: this,
			getWorkbench: () => this.workbenchRef.current,
			emitter: this.emitter,
			pageModel: this.pageModel,
			i18n: fr,
			assetsPackageListManager: this.assetsPackageListManager
		});
		this.pluginManager = t, t.customPlugin("Designer", (e) => (e.ctx.config.beforeInitRender = qn, e.ctx.config.customRender = Jn({
			components: this.props.components || {},
			renderProps: this.props.renderProps || {}
		}), e.ctx.config.components = this.props.components, e)), this.props.beforePluginRun?.({ pluginManager: this.pluginManager });
		let n = e.map((e) => this.pluginManager.add(e));
		this.props.onMount?.({
			pluginManager: this.pluginManager,
			engine: this
		}), await Promise.all(n), this.pageModel.emitter.on("onReloadPage", () => {
			if (!this.currentSelectNode) return;
			let e = this.pageModel.getNode(this.currentSelectNode?.id);
			e && this.updateCurrentSelectNode(e);
		}), this.props.onReady?.({
			pluginManager: this.pluginManager,
			engine: this
		});
	}
	componentDidUpdate(e) {
		e.i18nResources !== this.props.i18nResources && dr(this.props.i18nResources), e.locale !== this.props.locale && pr(this.props.locale);
	}
	componentWillUnmount() {
		fr.off("languageChanged", this.onLanguageChanged);
	}
	getActiveNode() {
		if (!this.currentSelectNode?.id) return null;
		let e = this.pageModel.getNode(this.currentSelectNode.id) ?? null;
		return this.currentSelectNode = e, e;
	}
	updatePage = (e) => {
		this.pageModel.updatePage(e);
	};
	updateMaterials = async (e, t, n) => {
		let r = (await this.pluginManager.get("Designer"))?.export;
		this.pluginManager.assetsPackageListManager.setList(t), this.pageModel.assetPackagesList = this.pluginManager.assetsPackageListManager.getList();
		let i = r?.getDesignerWindow();
		if (!i) {
			console.warn("subWin not exits");
			return;
		}
		await new pt(t, i).load();
		let a = gt(t, i), o = _t(a);
		n?.formatComponents && (o = n.formatComponents(o)), r?.updateRenderComponents(o), this.pageModel.materialsModel.addMaterials(e), this.emitter.emit("updateMaterials");
	};
	refresh = async () => {
		this.pageModel.reloadPage(this.pageModel.export("design"));
	};
	getWorkbench = () => this.workbenchRef.current;
	getI18n() {
		return fr;
	}
	async preview() {
		let e = this.workbenchRef.current?.getHiddenWidgetConfig();
		this._oldHiddenWidgetConfig = e, this.workbenchRef.current?.hiddenWidget({
			hiddenLeftPanel: !0,
			hiddenRightPanel: !0,
			hiddenTopBar: !0,
			canvasFull: !0
		}), ((await this.pluginManager.get("Designer"))?.export)?.setPreviewMode();
	}
	async exitPreview() {
		this.workbenchRef.current?.hiddenWidget({
			...this._oldHiddenWidgetConfig || {},
			canvasFull: !1
		}), ((await this.pluginManager.get("Designer"))?.export)?.setEditMode();
	}
	hiddenWidget(e) {
		this.workbenchRef.current?.hiddenWidget(e || {});
	}
	render() {
		let e = ur(fr.language), t = e === "en_US" ? Ct : wt;
		return /* @__PURE__ */ R("div", {
			className: P([ir.engineContainer, this.props.className]),
			style: this.props.style,
			children: /* @__PURE__ */ R(b, {
				locale: t,
				children: /* @__PURE__ */ R(Sr, {
					language: e,
					children: /* @__PURE__ */ R(rr, {
						ref: this.workbenchRef,
						emitter: this.emitter,
						...this.workbenchConfig
					})
				})
			})
		});
	}
};
//#endregion
export { _s as AdvancePanel, vs as AdvancePanelConfig, Gn as AssetsPackageListManager, co as BUILD_IN_SETTER_MAP, ni as CANVAS_SIZE_OFFSET, Is as CSSEditor, Ns as CSSPropertiesEditor, Os as CSSPropertiesVariableBindEditor, As as ClassNameEditor, Lr as ComponentLibPlugin, ps as ComponentStatePanel, ms as ComponentStatePanelConfig, yo as CustomSchemaForm, sr as DEFAULT_LOCALE, Sc as DEFAULT_PLUGIN_LIST, Cc as DEFAULT_PLUGIN_NAME_MAP, An as DEFAULT_RESPONSIVE_SIZES, Er as DRAG_ITEM_KEY, ii as DesignerPlugin, $r as DesignerSizer, $s as DisplaySourceSchema, Dr as DragComponent, Or as DragComponentItem, Nc as Engine, Qs as GlobalStatePanelPlugin, tc as HistoryPlugin, pc as HotkeysPlugin, Mc as InnerComponentMeta, V as LOGGER, Br as MonacoEditor, wi as OutlineTreePlugin, mc as PAGE_RUNTIME_LOG_PLUGIN_NAME, Nr as PLUGIN_NAME, yc as PageRuntimeLog, bc as PageRuntimeLogPlugin, vc as PageRuntimeLogStore, mr as PluginManager, us as PropertyPanel, ds as PropertyPanelConfig, Gs as RightPanelPlugin, cr as SUPPORTED_LOCALES, _o as SetterSwitcher, Ls as VisualPanelPlus, Rs as VisualPanelPlusConfig, rr as Workbench, dr as addI18nResources, qn as beforeInitRender, pr as changeEngineLocale, Ms as defaultPropertyOptions, er as ensureKeyExist, Bn as formatCSSTextProperty, Vn as formatCssToNodeVal, Hn as formatNodeValToEditor, zn as formatStyleProperty, Un as getColorFromStr, Jn as getDefaultRender, Mn as getResponsiveSizeByViewport, jn as getResponsiveSizes, Kn as getUniqueAssetsList, ur as normalizeLocale, Wn as parseBoxShadowString, xc as plugins, Mi as registerCustomSetter, tr as sageJSONParse, $n as simplifyPageSchema, Nn as styleArr2Obj, Fn as styleList2Text, Pn as styleObjToArr, Rn as updateNodeSizeStyle, H as waitReactUpdate };

//# sourceMappingURL=index.es.js.map